{
  "accessibility": {
    "closeModal": "Modal afsluiten",
    "useSetting": "Gebruik instelling",
    "srOnly": {
      "close": "Sluiten",
      "loading": "Aan het laden..."
    }
  },
  "account": {
    "salesResources": {
      "title": "Verkoopbronnen",
      "searchDocuments": "Documenten zoeken",
      "minimalRating": "Minimale Beoordeling",
      "maxRating": "Max. beoordeling"
    },
    "saasRebilling": {
      "enableRebillingMessage": "Schakel herfacturering voor deze klant in om tot 10x winst te maken op het gebruik van telefoon, e-mails, automatiseringen, enz.",
      "enableRebilling": "Opnieuw factureren inschakelen",
      "servicesActivateAfterPayment": "Herfactureringsdiensten worden geactiveerd nadat de klant een betaalmethode heeft toegevoegd. Tot die tijd is de toegang tot het account van de klant beperkt.",
      "cannotModifyOnHold": "Kan de instellingen voor opnieuw factureren niet aanpassen, omdat dit sub-account al een SaaS-plan in de wacht heeft staan. Toeslagen voor opnieuw factureren worden geconfigureerd in overeenstemming met het plan wanneer de klant een betaalmethode toevoegt.",
      "rebillingSettings": "Instellingen voor herfactureren"
    }
  },
  "affiliates": {
    "aboutMe": "Over mij",
    "error": {
      "unableToSend": "Kan e-mail niet verzenden"
    },
    "industriesServed": "Sectoren die wij bedienen",
    "sendAMessage": "Stuur een bericht",
    "sendMessageIntro": "Stuur een bericht om uzelf aan deze adviseur voor te stellen. Voeg details toe over uzelf en de diensten die u zoekt.",
    "socialSites": "Sociale-mediasites",
    "success": {
      "emailSent": "E-mail verzonden"
    },
    "validationErrors": {
      "validEmail": "Geef een geldig e-mailadres op.",
      "validMessage": "Geef een geldig bericht op.",
      "validName": "Geef een geldige naam op."
    },
    "yearsInBusiness": "Jaren in bedrijf",
    "yourEmail": "Uw e-ail",
    "yourName": "Uw naam",
    "paymentDetailsAccessMessage": " Dit onderdeel met uitbetalingsdetails is alleen toegankelijk en bewerkbaar via de <strong>Eigenaar van de Agentschap</strong>. Als u hulp nodig heeft, neem dan contact op met de <strong>Eigenaar van het agentschap ({ agencyOwnerEmail })</strong>.",
    "partnerBadgeAlt": "Partnerbadge",
    "photoAlt": "Partnerfoto",
    "defaultCompany": "Geen bedrijf",
    "moreServices": "+ {count} extra diensten"
  },
  "agency": {
    "saas": {
      "saasMode": "SaaS-modus",
      "pendingPaymentInformation": "In afwachting van betaalgegevens",
      "customerId": "Klant-ID",
      "noPaymentMethods": "Het lijkt erop dat er geen betaalmethodes zijn toegevoegd! Voeg een betaalmethode toe om de SaaS-modus te activeren",
      "enableSaasDescription": "Schakel SaaS in op deze locatie om een abonnement aan te maken en het telefoon- en e-mailgebruik opnieuw te factureren.",
      "missingEmailAddress": "Het e-mailadres van uw account ontbreekt, voeg eerst de gegevens toe.",
      "toConvertToSaaS": "Om dit account naar SaaS om te zetten, moet u eerst een locatiebeheerder toevoegen en het dan opnieuw proberen",
      "newUser": "Nieuwe Gebruiker Aanmaken",
      "stripeCustomerConnected": "Stripe-klant is succesvol verbonden!",
      "requestClientPaymentDetails": "Betalingsgegevens van de klant opvragen",
      "saasLocationDescription": "Locaties in SaaS-modus vereisen de creditcard van uw klant. U kunt een verzoek indienen via e-mail, sms of door het delen van een URL",
      "selectSpace": "Selecteer de spatiebalk om verder te gaan",
      "spaceDescription": "De ruimte die u hier selecteert, zal worden gebruikt om de informatie van deze klant op te slaan, hun betalingen te verwerken en hun abonnementen te beheren.",
      "stripe": "Stripe",
      "freeCreditsDescription": "Wanneer een gebruiker zich aanmeldt, kunt u gratis credits aanbieden voor het gebruik van e-mail- en telefoonservices.",
      "thatAboutMinsInCalls": "Dat is ongeveer {count} berichten of {count1} minuten aan oproepen",
      "subscriptionSettings": "Abonnementsinstellingen",
      "toUpgradeOrCancelPlan": "Plan upgraden of annuleren",
      "allowClientUpgrade": "Klant(subaccount) toestaan om te upgraden naar een hoger plan.",
      "addNewPlanFeatures": "Voeg de functies van het nieuwe plan toe bij het upgraden.",
      "upgradeFeatureDescription": "Bij het upgraden naar een hoger plan krijgen de subaccounts toegang tot de extra functies van het nieuwe plan. Toegang tot de extra functies van het nieuwe abonnement.",
      "allowClientCancel": "Klant (subaccount) toestaan om hun abonnement te annuleren.",
      "snapshotDescription": "De geselecteerde momentopname wordt automatisch toegevoegd aan de nieuw aangemaakte SaaS-locatie.",
      "ownSnapshots": "Eigen momentopnames",
      "selectAndContinue": "Selecteren en doorgaan"
    },
    "advancedSettings": {
      "controlLocationSettings": "Beheer de instellingen van de locatie",
      "disableAddSmtp": "Schakel de knop E-mailservice toevoegen uit in de instellingen van de e-mailservices van het sub-account",
      "disableAddSmtpDescription": "Gebruikers van sub-accounts beperken bij het toevoegen van hun eigen e-mailprovider",
      "enableReVerification": "Herverificatie 90 dagen inschakelen",
      "lcEmailNotEnabled": "Locatie heeft LeadConnector niet als standaard e-mailprovider",
      "onlyVisibleForAgency": "U kunt deze instelling alleen ingeschakeld zien voor bureau",
      "reVerificationDescription": "Elke e-mailverificatiestatus wordt na 90 dagen ingetrokken (Bescherm uw afzenderreputatie en zorg voor de hoogste inbox-ontvangstpercentage)",
      "account": {
        "accountDetails": "Accountgegevens",
        "advancedEmailSettings": "Geavanceerde e-mailinstellingen",
        "hipaa": "HIPAA",
        "hipaaCompliant": "HIPAA-conform",
        "smsEmailLimits": "SMS-/e-maillimieten",
        "socialProfiles": "Sociale profielen",
        "subscribed": "Geabonneerd"
      },
      "activityTracking": {
        "history": "Geschiedenis"
      },
      "addAccount": {
        "accountInfo": "Accountgegevens",
        "accountSnapshots": "Momentopname account",
        "businessNiche": "Bedrijfsniche",
        "chooseBusinessNiche": "Bedrijfsniche selecteren...",
        "pickSnapshot": "Selecteer een momentopname",
        "selectSnapshot": "Momentopname selecteren",
        "title": "Sub-account toevoegen",
        "accountInfo1": "Accountinformatie"
      },
      "addBalance": {
        "addBalanceToWallet": "Saldo toevoegen aan portemonnee",
        "addMoneyToWallet": "Voeg geld toe aan uw portemonnee",
        "balanceAddedSuccessfully": "Saldo succesvol toegevoegd",
        "cardWillBeCharged": "De kaart die eindigt op {cardNumber} zal in rekening worden gebracht",
        "complimentaryCredits": "Gratis credits ({credits})",
        "creditsRemovedByAgency": "Tegoeden verwijderd door agentschap",
        "currentBalance": "Huidig saldo",
        "customerCCWillNotBeCharged": "De creditcard van de klant zal niets in rekening worden gebracht",
        "moneyWillBeAddedToWallet": "Er wordt geld toegevoegd aan de portemonnee",
        "pleaseProvideAmountBetween": "Geef een bedrag op tussen {min} en {max}",
        "processing": "Wordt verwerkt...",
        "removeBalance": "Saldo verwijderen",
        "transactionSuccessful": "Transactie geslaagd",
        "walletBalance": "Saldo portemonnee ({balance})"
      },
      "addPaymentMethod": {
        "adding": "Toevoegen...",
        "cardDetails": "Kaartgegevens",
        "cardSuccessfullyAdded": "Kaart succesvol toegevoegd",
        "errorWhileAddingCard": "Fout bij toevoegen nieuwe kaart!",
        "maximumCardUpdateLimitReached": "Maximale limiet voor kaartupdates bereikt",
        "rateLimitMessage": "U hebt het maximale aantal pogingen voor het toevoegen van kaarten bereikt voor vandaag. Probeer het over 24 uur opnieuw."
      },
      "aiProductRebilling": {
        "funnel": " trechter",
        "images": " Afbeeldingen,",
        "per1000Words": " /1000 woorden, ",
        "perFunnel": " /trechter",
        "perImage": " / Afbeelding,",
        "pleaseCheckSupport": "raadpleeg onze",
        "ratesMayDiffer": "Tarieven kunnen verschillen per regio. De getoonde berekeningen zijn volgens de tarieven voor het VK,",
        "ratesMayDifferUS": "Tarieven kunnen verschillen per regio. Berekeningen worden weergegeven volgens de Twilio-tarieven voor de VS. Raadpleeg Twilio voor meer details.",
        "pleaseCheckTwilioRates": "Voor uitgaande SMS-berichten naar de VS/Canada wordt een tarief van $ 0,0079 per segment in rekening gebracht. Inkomende SMS-berichten tegen $ 0,0075 per segment.",
        "words": " woorden, "
      },
      "api": {
        "advancedFunctionalityNote": "Opmerking uitgebreide functionaliteit",
        "agencyApiKeys": "API-token kantoor",
        "apiAccess": {
          "partOfAdvancedApi": "Dit maakt deel uit van de Advanced API die beschikbaar is in het Pro Plan.",
          "toUpgrade": "om te upgraden."
        },
        "createNew": "Nieuw aanmaken",
        "developerCouncilInfo": "Details ontwikkelaarsraad",
        "noAccess": "U hebt geen toegang tot dit onderdeel.",
        "securityAlert": "Beveiligingswaarschuwing",
        "table": {
          "fetchingKeys": "Bedrijfssleutels ophalen...",
          "noKeysYet": "U hebt nog geen API-sleutels.",
          "toCreateFirstKeys": "om uw eerste API-sleutels te genereren."
        },
        "zapierNote": "Zapier-bericht"
      },
      "calendarBeta": {
        "abilityChooseGoogleCalendars": "Mogelijkheid om Google Agenda's te selecteren voor ‘Toevoegen aan’ + ‘Conflictagenda's' om de beschikbaarheid van elke gebruiker te berekenen",
        "abilityToAllocateRoundRobin": "Mogelijkheid om afspraken toe te wijzen in een roterend systeem",
        "abilityToChooseSpecificUser": "Mogelijkheid om een specifieke gebruiker te selecteren waarmee de afspraak moet worden geboekt",
        "adminAbilitySeeEveryUser": "Admin - Mogelijkheid om de afspraken in de agenda van elke gebruiker te bekijken",
        "adminAbilityViewAllCalendar": "Admin - Mogelijkheid om de afspraken in de agenda van elke gebruiker te bekijken",
        "adminsCanDeleteIntegrations": "Beheerders kunnen alle integraties verwijderen, terwijl gebruikers alleen hun eigen integraties kunnen verwijderen.",
        "adminsCanSeeAllIntegrations": "Beheerders kunnen alle integraties zien, ongeacht wie ze heeft aangemaakt, maar gebruikers kunnen alleen de integraties zien die zij voor zichzelf hebben gemaakt.",
        "contactDetailAppointments": "Contactgegevens > Afspraken (nieuw)",
        "conversationsScheduleAppointment": "Communicatie > Afspraak inplannen (nieuw)",
        "essentialConsiderations": "Essentiële overwegingen",
        "funnelsWebsitesCalendar": "Trechters/Websites > Agenda (Nieuw)",
        "helpReorientTriggers": "Tijdens het gesprek zullen we u helpen om de triggers af te stemmen op de nieuwe agendaconfiguratie",
        "iAgreeMessage": "Als u akkoord gaat met de bovenstaande wijzigingen, klik dan op 'Akkoord' en ga aan de slag met Agenda (Beta) voor deze locatie",
        "integrationNew": "Integratie (Nieuw)",
        "loseAbilityToViewEdit": "Wie de nieuwe versie gebruikt, kan geen afspraken (die in de vorige versie werden aangemaakt) meer bekijken of bewerken via het venster ‘Leaddetails’, maar kan al deze acties wel blijven uitvoeren op de pagina ‘Afspraken’",
        "newOldTriggersCoexist": "De nieuwe en oude triggers zullen naast elkaar blijven bestaan",
        "nonAdminAbilityViewPersonal": "Niet-beheerder - Mogelijkheid om alleen hun persoonlijke afspraken te bekijken (toegewezen Statistieken/Agendamapping onder GROEPSBEHEER hebben geen invloed)",
        "nonAdminViewPersonalOnly": "Niet-beheerder - Mogelijkheid om alleen hun persoonlijke afspraken te bekijken",
        "notAtMoment": "Momenteel niet. We doen ons uiterste best om dit zo snel mogelijk op mobiel beschikbaar te stellen.",
        "oldAppointmentsCanBeViewed": "De oude afspraken kunnen eenvoudig worden bekeken op de afsprakenpagina door middel van een schakelaar.",
        "oldAppointmentsDisplayed": "Oude afspraken worden naast de nieuwe afspraken weergegeven in dezelfde lijst",
        "oldCalendarVersionAppointments": "Oude versie agenda + oude afspraken",
        "onlyNewCalendarWidget": "Alleen de nieuwe agendawidget kan worden toegevoegd",
        "opportunityAddAppointment": "Lead > Afspraak toevoegen (nieuw)",
        "profilePageAdmin": "Profielpagina voor beheerders (nieuw)",
        "profilePageAllUsers": "Profielpagina (alle gebruikers)",
        "providesAllOptions": "Biedt alle opties (Groepen + Services) die vereist zijn om de nieuwe agenda te configureren",
        "reintegratingConnectionsRequired": "Het opnieuw integreren van alle verbindingen kan vereist zijn zodra de bètaversie van de agenda voor een locatie wordt ingeschakeld",
        "roundRobinHighlight": "Het belangrijkste kenmerk van deze update is de mogelijkheid om afspraken tussen verschillende groepen agenten te roteren.",
        "schedulingCalendarAppointments": "Planning > Agenda/Afspraken (Nieuwe filters + schakelaar om te wisselen tussen nieuwe en oude afspraken)",
        "settingsCalendarBeta": "Instellingen > Agenda (Bèta)",
        "surfacingFirstTime": "Het voor de eerste keer zichtbaar maken",
        "teamManagementAdminOnly": "Teambeheer (uitsluitend beschikbaar voor beheerders)",
        "toggleOffNewVersion": "Uitschakelen (nieuwe versie)",
        "toggleOnOldVersion": "Inschakelen (oude versie)",
        "whatChangesWithNewVersion": "Welke veranderingen werden er aangebracht in de nieuwe versie van de agenda?",
        "whatDoesCalendarEntail": "Wat houdt de Agenda (Privé beta) in?",
        "whatHappensToOldAppointments": "Wat gebeurt er met onze oude afspraken na de overgang?",
        "whatWillWeSeeMobile": "Wat zullen we op mobiel zien in bètaversie?",
        "willOldAppointmentsBeFactored": "Zullen de oude afspraken worden meegerekend bij het berekenen van de beschikbaarheid voor nieuwe afspraken?",
        "willOldCalendarUrlsWork": "Zullen onze oude agenda-URL's nog werken na de overgang?",
        "willWeGetNewVersionMobile": "Zullen we de nieuwe versie op mobiel kunnen gebruiken tijdens de bètaperiode?",
        "yesOldSettingsPageContinues": "Ja. De oude instellingenpagina zal blijven bestaan en u kunt daar nog steeds wijzigingen doorvoeren. De oude en nieuwe agendawidget zullen onafhankelijk van elkaar functioneren, maar toch voortdurend in synchronisatie met elkaar zijn om ervoor te zorgen dat uw beschikbaarheid nauwkeurig wordt berekend tussen beide systemen. Om verwarring te voorkomen, raden we u ten zeerste aan om de nieuwe URL's te gebruiken, zodat u geen twee afzonderlijke URL's hoeft te monitoren voor dezelfde set gebruikers.",
        "yesSyncOnGoogleCalendar": "Ja, aangezien de eenrichtingssynchronisatie, zorgt Google Agenda ervoor dat niet-beschikbare tijdvakken worden geblokkeerd."
      },
      "companyPlansModal": {
        "billedAnnually": "Jaarlijks gefactureerd",
        "billedMonthly": "Maandelijks gefactureerd",
        "changePlanFor": "Plan wijzigen voor {locationName}",
        "notAuthorized": "U hebt geen machtiging om deze actie uit te voeren. Alleen gebruikers en beheerders van het agentschap, evenals locatiebeheerders, kunnen dit uitvoeren.",
        "payAnnually": "Jaarlijks betalen",
        "payMonthly": "Maandelijks betalen"
      },
      "locationBillingHistory": {
        "billingHistory": "Facturatiegeschiedenis",
        "cardNo": "Kaartnr.",
        "errorWhileFetchingInvoices": "Fout tijdens het ophalen van facturen, klik om het opnieuw te proberen",
        "invoiceDescription": "Factuurbeschrijving",
        "invoiceNo": "Factuurnummer",
        "noInvoices": "Geen facturen",
        "refunded": "Terugbetaald",
        "succeeded": "geslaagd",
        "view": "BEKIJKEN"
      },
      "locationWallet": {
        "autoRechargeWith": "Automatisch opwaarderen met",
        "balance": "Saldo:",
        "credits": "Credits",
        "seeTransactions": "Transacties bekijken",
        "whenBalanceLowerThan": "bij een saldo lager dan"
      },
      "mailTransactionModal": {
        "checkYourEmail": "Controleer uw e-mail ({emails}).",
        "csvSentMessage": "We verzenden een CSV-bestand naar uw e-mail. Dit duurt meestal 7-10 minuten.",
        "enterEmailAddress": "Voer een e-mailadres in",
        "exportAndSendCsv": "CSV exporteren en verzenden",
        "exportTransactions": "Transacties exporteren",
        "itUsuallyArrives": "Deze komt meestal binnen 10 minuten aan.",
        "useCommasToSeparate": "Gebruik komma's om meerdere e-mailadressen te scheiden."
      },
      "modifySubscription": {
        "cancelClientDescription": "Het abonnement van uw klant opzeggen en het account sluiten",
        "cancelDescription": "Uw abonnement opzeggen en het account sluiten",
        "cancelImmediately": "Annuleer onmiddellijk",
        "cancelNow": "Annuleer nu",
        "cancelSubscription": "Abonnement annuleren",
        "changedYourMind": "Twijfelt u nog?",
        "changedYourMindClient": "U kunt het abonnement van uw klant hervatten",
        "changedYourMindYou": "U kunt uw abonnement hervatten",
        "confirmByTyping": "Bevestig door hieronder {text} in te typen",
        "confirmCancellation": "Annulering bevestigen",
        "modifySubscription": "Abonnement wijzigen",
        "modifyYourSubscription": "Uw abonnement wijzigen",
        "resumeSubscription": "Abonnement hervatten",
        "subscriptionWillBeCancelledOn": "Hierdoor wordt uw abonnement opgezegd op {date}. U kunt het abonnement steeds hervatten door de geplande opzegging te annuleren.",
        "subscriptionWillBeCancelledOnClient": "Hiermee wordt het abonnement van uw klant opgezegd op {date}. U en uw klanten kunnen het abonnement steeds hervatten door de geplande opzegging te annuleren.",
        "subscriptionWillBeCancelledOnDate": "Uw abonnement wordt geannuleerd op {date}.",
        "subscriptionWillBeCancelledOnDateClient": "Het abonnement van uw klant wordt geannuleerd op {date}.",
        "subscriptionWillBeResumed": "Uw abonnement wordt hervat en u zult normaal gefactureerd worden.",
        "subscriptionWillBeResumedClient": "Het abonnement van uw klant wordt hervat en zal zoals gebruikelijk worden gefactureerd.",
        "upgradeDescription": "Abonnement upgraden",
        "weAreGladYouStaying": "We zijn verheugd over uw beslissing!",
        "nextBillingDate": "Eerstvolgende facturatiedatum: {date}",
        "cancelImmediatelyTitle": "Weet u zeker dat u het abonnement onmiddellijk wilt opzeggen?",
        "cancelNowDescription": "Je abonnement wordt op {date} geannuleerd. Als u ervoor kiest om nu te annuleren, wordt uw account, inclusief alle uitgaande activiteiten zoals geplande berichten en e-mails, onmiddellijk stopgezet.",
        "cancelNowDescriptionClient": "Het abonnement van uw klant is gepland om op {date} te worden opgezegd. Als u ervoor kiest nu te annuleren, wordt het account van uw klant, inclusief alle uitgaande activiteiten zoals geplande berichten en e-mails, onmiddellijk stopgezet.",
        "modifyDescription": "U kunt uw abonnement {action}",
        "modifyDescriptionClient": "U kunt het abonnement van uw klant {action}"
      },
      "noPaymentMethodWarning": {
        "addNow": "Nu toevoegen",
        "youNeedToEnterCardInfo": "U moet uw kaartgegevens invoeren.",
        "youNeedToEnterClientCardInfo": "U moet de kaartgegevens van uw klant invoeren."
      },
      "productRebilling": {
        "chargesBasedOnTokens": "Kosten zijn gebaseerd op tokens. De hieronder weergegeven woordtellingen zijn schattingen om u inzicht te geven in het gebruik. De werkelijke kosten kunnen variëren.",
        "examplePricingGpt4oMini": "Voorbeeldprijzen - GPT-4o Mini",
        "for750kWords": "(voor 750.000 woorden) ",
        "gpt4oMini": " GPT-4o-mini ",
        "input": "Invoer",
        "or": "of ",
        "output": "Uitvoer",
        "perImage": " / Afbeelding",
        "perResultSelection": " / Resultaatselectie",
        "ratesMayDifferUK": "Tarieven kunnen verschillen per regio. De getoonde berekeningen zijn volgens de tarieven voor het VK, raadpleeg ons",
        "ratesMayDifferUS": "De tarieven kunnen verschillen per regio en nummertype. Gegevensberekeningen op basis van Twilio-tarieven voor de VS,",
        "pleaseCheckSupport": "raadpleeg onze",
        "resultSelection": " Selectie met resultaten",
        "supportDoc": "ondersteunend document",
        "forMoreDetails": "voor meer details",
        "words": " woorden"
      },
      "removePaymentMethod": {
        "endingIn": "Eindigend op *{cardNo}",
        "no": "Nee",
        "removeCard": "Kaart verwijderen?",
        "removing": "Verwijderen..",
        "yesRemove": "Ja, verwijderen"
      },
      "requestSaasModal": {
        "requestClientPaymentDetails": "Betalingsgegevens klant opvragen",
        "saasLocationDescription": "Een SaaS-abonnement voor deze locatie instellen",
        "selectSpace": "Ruimte selecteren",
        "spaceDescription": "Kies waar u de facturering voor deze locatie wilt instellen"
      },
      "saasEnableProducts": {
        "disable": "Uitschakelen",
        "enableDisableProducts": "Producten in-/uitschakelen",
        "feature": "Eigenschap",
        "unsavedChanges": "Niet-opgeslagen wijzigingen"
      },
      "saasSubscriptionPlan": {
        "agencyStripeFailed": "De eerstvolgende facturering voor deze klant lijkt in het verleden te liggen. Dit gebeurt wanneer het Stripe-account van uw kantoor niet goed functioneert. Log in op het Stripe-account van uw kantoor om dit te verhelpen.",
        "copiedText": "gekopieerde tekst:",
        "couldNotCopy": "Async: kon de tekst niet kopiëren: ",
        "multiplier": " X ",
        "nextBillingDatePrefix": " Eerstvolgende factuurdatum: ",
        "plan": "Plan",
        "pleaseContactAgency": "Neem contact op met het kantoor om uw abonnement te activeren.",
        "stripeSubscriptionId": "Stripe-abonnement-ID:",
        "subscriptionPlans": "Abonnementsplannen",
        "subscriptionWillBeCancelledOn": "Uw abonnement wordt geannuleerd op {date}",
        "subscriptionWillBeCancelledOnClient": "Het abonnement van uw klant wordt geannuleerd op {date}",
        "toModifyClientSubscription": "om het abonnement van uw klant te wijzigen",
        "toModifyYourSubscription": "om uw abonnement te wijzigen",
        "whatsappNumberSubscription": "Abonnement op WhatsApp-nummer",
        "yourBillingDatePast": "Uw volgende factuurdatum lijkt in het verleden te liggen. Neem contact op met {email} om dit te verhelpen. Alles gaat ondertussen gewoon door."
      },
      "salesResources": {
        "certifiedUser": "Gecertificeerde gebruiker",
        "clearFilter": "Filter wissen",
        "dateRange": "Datumbereik"
      },
      "upgradePlanProcessedModal": {
        "paymentInfo": "U betaalt $ {amount} per maand, {interval} gefactureerd",
        "planUpgradeFailed": "Uw plan kon niet worden geüpgrade!!",
        "planUpgraded": "Uw plan werd geüpgrade!",
        "retryUpgrade": "Opnieuw proberen te upgraden",
        "upgradeFailed": "De upgrade van uw plan is mislukt, probeer het opnieuw",
        "upgradedSuccessfully": "U hebt uw abonnement {oldPlan} succesvol geüpgraded naar {newPlan}"
      },
      "upgradePlanSelectionModal": {
        "billedAsMonthlyCharge": "gefactureerd als maandelijkse bedrag van {amount} /maand",
        "billedAsYearlyCharge": "gefactureerd als jaarlijkse bedrag van {amount} /jaar",
        "upgradeFrom": "Upgraden van",
        "whatYouWillGet": "Wat u krijgt:"
      },
      "walletTransactionModal": {
        "balanceAfterTransaction": "Saldo na transactie:",
        "callDuration": "Oproepduur:",
        "callSid": "Oproep-SID:",
        "charge": "Prijs:",
        "contact": "Contactpersoon:",
        "contactName": "Naam contactpersoon:",
        "contactPhone": "Telefoonnummer contactpersoon:",
        "credit": "Tegoed:",
        "creditsAfterTransaction": "Tegoed na transactie:",
        "dateSent": "Verzenddatum",
        "deleted": "<Deleted>.",
        "discount": "Korting:",
        "eventId": "Gebeurtenis-ID:",
        "from": "Van:",
        "noContactFound": "Geen contactpersoon gevonden",
        "noOfSegments": "Aantal segmenten:",
        "openContactPage": "Pagina met contacten openen",
        "openConversation": "Gesprek openen",
        "openEvent": "Gebeurtenis openen",
        "originalCharge": "Oorspronkelijke prijs:",
        "received": "Ontvangen",
        "smsSid": "SMS-SID:",
        "timeBilled": "Gefactureerde tijd:",
        "timeOfCall": "Tijdstip van oproep",
        "transactionDetails": "Transactie-info -",
        "transactionId": "Transactie-ID:",
        "type": "Type:",
        "segments": "Segmenten"
      },
      "calendarSettings": {
        "meetings": "Bijeenkomsten",
        "services": "Services",
        "hideCalendarWarning": "De Agendamodule volledig verbergen kan via Subaccountinstellingen > Mijn personeel > Rollen en machtigingen",
        "calendarSettingsUpdated": "Agenda-instellingen zijn bijgewerkt",
        "meetingDescription": "Schakel deze optie in om sub-accounts toe te staan de functie Vergaderingen te gebruiken, die ontworpen is voor het beheren van verkoopagenda’s, onboardinggesprekken, round-robin planning, teamsamenwerkingen, klasboekingen, interviews en meer. Ideaal voor bedrijven die flexibele en collaboratieve planningstools nodig hebben.",
        "serviceDescription": "Schakel Services in om sub-accounts toegang te geven tot een volledige boekingsoplossing voor servicegerichte bedrijven. Dit omvat het maken van boekingspagina's met meerdere services, het beheren van resources, het omgaan met meerdere locaties, het instellen van personeelsspecifieke prijsstelling, het toevoegen van servicevariaties of add-ons, en meer."
      }
    },
    "apiKeys": {
      "apiKey": "API-sleutel",
      "copied": "Gekopieerd!",
      "copyApiKey": "Kopieer uw API-sleutel",
      "createApiKey": "API-sleutel aanmaken",
      "deleteAllKeys": "Alle sleutels verwijderen",
      "nameRequired": "Het veld Naam is verplicht.",
      "somethingWentWrong": "Sorry, er is iets misgegaan! Probeer het opnieuw.",
      "updatedSuccessfully": "Succesvol geüpdatet"
    },
    "billing": {
      "accountPaused": "Uw account {name} is gepauzeerd.",
      "accountProvisioned": "Uw account wordt geprovisioneerd.",
      "activateSubAccount": "Subaccount activeren",
      "activeServices": "Actieve services",
      "addNewCard": "Nieuwe kaart toevoegen",
      "addNewService": "Nieuwe service toevoegen",
      "addPaymentMethod": "een betaalmethode toevoegen",
      "alertIcon": "alertIcon",
      "approve": "Goedkeuren",
      "authenticateCardMessage": "Voor extra veiligheid moet u uw kaartgegevens opnieuw authenticeren.",
      "badActorWarning": "Als u denkt dat deze subaccount is aangemaakt door een onbetrouwbare partij, raden we u aan om de sub-account te verwijderen en het bijbehorende abonnement te annuleren.",
      "callUs": "Bel ons",
      "cancelAndDelete": "Abonnement annuleren en subaccount verwijderen",
      "completeFormNextStep": "Voltooi het formulier in de volgende stap",
      "congratulations": "🎉 Gefeliciteerd! 🎉",
      "contactAgency": "Neem contact op met uw agentschap om het probleem op te lossen",
      "contactThroughEmailOrPhone": "U kunt telefonisch of via e-mail contact met ons opnemen om dit op te lossen",
      "dataSafe": "Al uw gegevens zijn veilig en alle automatiseringen, webpagina's enz. zullen na de betaling weer werken.",
      "declineSubAccount": "Subaccount afwijzen",
      "deleteRecommendation": "Aanbevolen wordt om dit subaccount te verwijderen. Of u kunt dit ook later doen via de pagina Subaccounts > Klant beheren.",
      "emailUsAt": "E-mail ons op",
      "moveToDashboard": "Verplaatsen naar dashboard",
      "noPaymentMethods": "Het lijkt erop dat er geen betaalmethodes zijn toegevoegd! Ga",
      "paymentMethod": "Betaalmethode",
      "paymentMethodUpdated": "Uw betaalmethode is bijgewerkt",
      "paymentNotCompleted": "U ziet dit bericht omdat de betaling niet is voltooid.",
      "proceedToNextStep": "Ga door naar de volgende stap",
      "questionMark": "?",
      "reachOutMessage": "Neem gerust contact met ons op bij vragen.",
      "reactivateBillingFor": "Heractiveer de facturering voor {location}",
      "retryPayment": "Probeer de betaling opnieuw uit te voeren",
      "secureSystemMessage": "We zijn overgestapt naar een beter beveiligd factureringssysteem.",
      "setupMessage": "Iemand zal contact met u opnemen om de account aan te maken. Dit duurt doorgaans 12-24 uur,",
      "signout": "Afmelden",
      "subAccountId": "Subaccount-ID:",
      "successfullyInitiated": "{product} is met succes gestart",
      "systemError": "Systeemfout",
      "toReactivate": "om het account opnieuw te activeren",
      "userImage": "userImage",
      "verificationSkipped": "De verificatie via e-mail en telefoon wordt overgeslagen voor dit subaccount en de klant krijgt er toegang toe.",
      "verifyAccount": "Account verifiëren",
      "verifyAfterAttempt": "U kunt deze account verifiëren na 1 verificatiepoging van de beheerder van de subaccount",
      "verifySubAccount": "Het subaccount verifiëren",
      "recommendedPlans": "Aanbevolen plannen",
      "buildYourOwnPlan": "BOUW UW EIGEN PLAN",
      "resetToDefaults": "Herstellen naar standaardinstellingen",
      "paymentMethodChange": "Als u de betaalmethode moet wijzigen",
      "approveSubAccount": "Subaccount goedkeuren",
      "approveSubAccountDescription": "De subaccount wordt hervat, de beheerders van de subaccount hebben toegang en kunnen de account gebruiken.",
      "productInitiated": "Product geïnitieerd"
    },
    "deleteConfirmation": {
      "actionCannotBeReversed": "Deze actie kan niet ongedaan worden gemaakt.",
      "cancelKeep": "Annuleren, Behouden",
      "confirmDeletionInstructions": "Bevestig de verwijdering door hieronder {word} te typen:",
      "enterConfirm": "Voer {word} in om opnieuw te genereren",
      "message": "De API-sleutel van deze locatie zal worden verwijderd.",
      "title": "API-sleutel locatie verwijderen?",
      "yesDelete": "Ja, verwijderen"
    },
    "generalDetails": {
      "noPermission": "U hebt geen toestemming om een bestand te uploaden. Controleer uw machtigingen bij de beheerder van uw bureau.",
      "relatedContacts": "Gerelateerde contactpersonen ({count})"
    },
    "locationApiKeys": {
      "deleteAllConfirmMessage": "Weet u zeker dat u alle API-sleutels van de locatie wilt verwijderen?",
      "deleteAllConfirmTitle": "Alle locatie api-sleutels verwijderen?",
      "deleteConfirmMessage": "Dit verwijdert de API-sleutel voor locatie: {location}. Wilt u doorgaan?",
      "deleteAgencyApiKeyConfirmMessage": "Hiermee wordt de API-sleutel verwijderd. Wilt u doorgaan?",
      "fetchingLocations": "Locaties ophalen...",
      "maxApiKeysMessage": "U kunt maximaal 5 API-sleutels hebben.",
      "noLocationsFound": "Geen locaties gevonden",
      "old": "Oud",
      "proPlanRequiredMessage": "Dit is onderdeel van de Advanced API die beschikbaar is in het Pro-abonnement.",
      "searchLocation": "Locatie zoeken",
      "title": "API-sleutel voor locatie"
    },
    "locationCard": {
      "deletionScheduledMessage": "Dit sub-account wordt op {date} verwijderd, als u van gedachten bent veranderd",
      "emailUsageNotRebilled": "Het e-mailgebruik wordt niet opnieuw gefactureerd",
      "emailUsageRebilled": "Het e-mailgebruik wordt opnieuw gefactureerd aan uw klant",
      "listings": "Vermeldingen",
      "manageClient": "Klant beheren",
      "paymentPending": "Uitbetaling is lopend",
      "remainingWalletBalance": "Resterend saldo van uw portemonnee voor deze SaaS-locatie",
      "requestPaymentAgain": "Opnieuw verzoeken om betaling",
      "saasModeActivated": "SaaS-modus is ingeschakeld",
      "saasModeNotActivated": "SaaS-modus is niet geactiveerd",
      "saasSubscriptionNotEnabled": "Het SaaS-abonnement is niet ingeschakeld",
      "saasSubscriptionRunning": "Het SaaS-abonnement is actief",
      "social": "Sociale media",
      "switchToSaaS": "Overschakelen naar SaaS",
      "switchToSubAccount": "Overschakelen naar sub-account",
      "telephoneUsageNotBilled": "Het telefoongebruik wordt niet opnieuw gefactureerd",
      "telephoneUsageRebilled": "Het telefoongebruik wordt opnieuw gefactureerd aan uw klant",
      "wordpressActive": "WordPress actief",
      "wordpressInactive": "WordPress inactief",
      "wordpressNotSoldYet": "WordPress is nog niet verkocht",
      "wordpressSaleSuccessful": "De verkoop van WordPress is gelukt",
      "yextActive": "Yext actief",
      "yextInactive": "Yext inactief",
      "yextNotSoldYet": "Yext is nog niet verkocht",
      "yextSaleSuccessful": "De verkoop van Yext is gelukt",
      "reviews": "Recensies"
    },
    "messageUsage": {
      "acceptTnc": "Accepteer de voorwaarden",
      "cannotPerformAction": "Deze actie kan niet worden uitgevoerd. Neem contact op met de ondersteuning.",
      "currentLimit": "Huidige limiet",
      "days": "Dag(en)",
      "failedToUpdate": "Het gebruik van berichten kon niet worden bijgewerkt",
      "helpCentre": "Helpcentrum",
      "increaseLimitFurther": "Limiet verder verhogen",
      "increaseLimitNow": "Limiet nu verhogen",
      "lessThanUsage": "Uw huidige verbruik is {usage}, en het geselecteerde gebruik is minder dan het huidige verbruik.",
      "lessThanUsageModal": "Huidig gebruik is {usage}, de limiet kan niet minder zijn dan het huidige gebruik",
      "limitAlreadyUnlocked": "Limiet is al ontgrendeld",
      "limitReached": "Limiet bereikt",
      "limitUpdatedFrom": "Limiet {type} is geüpdatet van {old} naar {new}",
      "lookingForSmsLimit": "Op zoek naar de SMS-limiet?",
      "minLimitShould": "Minimale limiet moet {limit} zijn",
      "newLimit": "Nieuwe {type} -limiet",
      "perDay": "/ Dag",
      "sameLimit": "De geselecteerde limiet is hetzelfde als de huidige limiet!",
      "smsLimitLocation": "Sms-limiet is nu op locatieniveau te vinden",
      "smsLimitSettingsInfo": "U kunt deze instellingen nu vinden onder 'Communicatielimiet' in 'Geavanceerde instellingen'",
      "timesInLast30Days": "Aantallen de laatste 30 dagen",
      "todaysUsage": "Gebruik van vandaag",
      "typePerDay": "{type} / dag",
      "updateLimit": "Limiet bijwerken",
      "updateLimitFor": "Update {type} -limiet voor {name}"
    },
    "prospectDetails": {
      "activeCampaignsWorkflows": "Dynamische {type}",
      "contactSource": "Bron van contactpersoon",
      "customer": "Klant",
      "noPastCampaignsWorkflows": "Geen verleden {type}",
      "pastCampaignsWorkflows": "Verleden {type}"
    },
    "settings": {
      "affiliateSettings": "Instellingen voor partners",
      "agencyBilling": "Facturering agentschap",
      "agencyTeamManagement": "Teammanagement agentschap",
      "apiKeys": "API-sleutels",
      "compliance": "Naleving",
      "customMenuLink": "Aangepaste menulink",
      "launchpadSettings": "Launchpad-instellingen",
      "phoneSystemTwilio": "Telefoonsysteem - Twilio",
      "smtpService": "SMTP-service",
      "userSettings": "Gebruikersinstellingen",
      "agencySettings": "Instellingen agentschap",
      "mailgun": "MailGun"
    },
    "snapshot": {
      "errorCreating": "Fout tijdens het maken van een snapshot",
      "pickAnAccount": "U moet een account selecteren.",
      "snapshotName": "Naam snapshot",
      "snapshotNameRequired": "U moet de snapshot een naam geven."
    },
    "socialDetails": {
      "blogRss": "Blog RSS",
      "foursquare": "Foursquare",
      "foursquareUrl": "Foursquare URL",
      "googlePlacesId": "Google Locatie ID",
      "googlePlus": "Google+",
      "googlePlusUrl": "Google+ URL",
      "instagramUrl": "Instagram-URL",
      "linkedInUrl": "LinkedIn-URL",
      "pinterest": "Pinterest",
      "pinterestUrl": "Pinterest-URL",
      "yelp": "Yelp",
      "yelpUrl": "Yelp URL",
      "youTube": "YouTube"
    },
    "requestSms": "Verzoek via SMS",
    "iAlreadyHaveACustomer": "Ik heb al een klant",
    "noAccountFound": "Geen account gevonden!",
    "thisIs": "Dit is",
    "pleaseEnterValueBetween0To30Days": "Voer alstublieft een waarde in tussen 0 en 30 dagen",
    "learnHowToAddOneTimeSetupFeeToThesePlans": "Leer hoe u eenmalige kosten voor configuratie kunt toevoegen aan deze plannen",
    "doNotDeleteStripeProductsWarning": "<span style=\"font-weight: bold;\">Verwijder deze producten niet</span> uit uw Stripe-account",
    "opportunityStats": "Kansstatistieken",
    "createNewSnapshot": "Nieuwe momentopname maken",
    "stripeSettings": {
      "agencyDashboardVisibleTo": "Dashboard voor agentschappen zichtbaar voor",
      "onlyMe": "Alleen ik",
      "allAgencyAdmins": "Alle beheerders van agentschappen",
      "stripeConnect": "Wordt binnenkort niet meer gebruikt. Schakel over naar Stripe Connect",
      "recommendStripe": "Voor een betere beveiliging raden we aan om Stripe Connect te gebruiken.",
      "switchToStripeConnect": "Schakel over naar Stripe Connect",
      "highLevelAccess": "HighLevel heeft toegang tot uw gegevens en kan namens u betalingen en klanten aanmaken",
      "stripeAccountWarning": "Eenmaal verbonden, kan het Stripe-account niet meer worden gewijzigd. We raden aan om een nieuw Stripe-account te gebruiken voor HighLevel-inkomsten.",
      "connectToStripeAccount": "Verbind met uw Stripe-account",
      "unverified": "De aan dit agentschap gekoppelde Stripe-account is niet geverifieerd en kan geen betalingen ontvangen. Voltooi de verificatie door in te loggen op uw Stripe-account.",
      "loginToStripe": "Log in op Stripe",
      "connectedAccount": "Gekoppelde account",
      "verified": "GEVERIFIEERD",
      "totalPendingBalance": "Totaal openstaand saldo",
      "disconnectStripe": "Stripe loskoppelen",
      "removeSaasPlanConfigurations": "Alle configuraties van het SaaS-plan verwijderen?",
      "haveSaasPlans": "U hebt SaaS-plannen aangemaakt in de Stripe-account!",
      "disconnectWarning": "Als u de verbinding verbreekt, zullen alle SaaS-plannen verloren gaan en moet u deze opnieuw aanmaken.",
      "acknowledgeDisconnect": "Ik begrijp dat al mijn SaaS-plannen verloren zullen gaan en ik deze opnieuw zal moeten aanmaken.",
      "disconnect": "Verbreken"
    },
    "zoomSuccess": {
      "title": "Ik hoop dat u een geweldige ervaring had!",
      "message": "Bedankt voor uw beschikbaarheid. We kijken ernaar uit om u weer te mogen verwelkomen!"
    },
    "supportDashboard": {
      "trialExperienceSpecialist": "Uw specialist op het gebied van proefperiodes",
      "successSpecialist": "Uw succespecialist",
      "supportSpecialist": "Uw ondersteuningsspecialist",
      "jumpOnZoomCall": "Neem deel aan een Zoom-gesprek met mij voor uw kick-offgesprek",
      "jumpOnChat": "Start een chat met me voor hulp",
      "joinVideoCallNow": "Neem nu deel aan het videogesprek",
      "whatToExpect": "Wat te verwachten?",
      "helpArticles": "Helpartikelen",
      "changelog": "Changelog",
      "ideasBoard": "Ideeënbord"
    },
    "saasDashboard": {
      "title": "SaaS-dashboard",
      "plansAndPricing": "Plannen en prijzen"
    },
    "listAccounts": {
      "newInterfaceAvailable": "Voor deze pagina is nu een meer overzichtelijke en snellere interface beschikbaar. Probeer het zelf uit!",
      "enableInLabs": "Inschakelen in Labs",
      "pendingTransferRequests": "U hebt lopende overdrachtsverzoeken voor subaccounts.",
      "otherAgenciesRequested": "Andere agentschappen hebben gevraagd om subaccounts aan u over te dragen.",
      "reviewRequests": "Recensieverzoeken",
      "clientList": "Klantenlijst (Subaccounts)",
      "subAccountTransfers": "Overdrachten subaccount"
    },
    "implementationModal": {
      "title": "Uw HighLevel-videogesprek gaat beginnen!",
      "videoCall": "Videogesprek",
      "whatsNext": "Wat is de volgende stap?",
      "enteringLobby": "U zult in onze lobby andere Highlevelers vinden net zoals uzelf!",
      "successConcierge": "Onze succesconcierge zal u verwelkomen en u verbinden met de volgende beschikbare adviseur voor een persoonlijke sessie.",
      "haveReady": "Houd het volgende bij de hand",
      "stableInternet": "Stabiele internetverbinding.",
      "videoNameMatches": "Uw videonaam komt overeen met uw HighLevel-gebruikersnaam.",
      "estimatedDuration": "Geschatte sessieduur",
      "firstVisit": "Eerste bezoek: onboardingsessie HighLevel: (45-60 minuten).",
      "returning": "Terugkerend: Voortgezette ondersteuning bij de implementatie (15-25 minuten).",
      "meetingBegins": "Uw meeting zal automatisch beginnen over <span class=\"text-[#155EEF]\">{ countdown } seconden.</span>  Of u kunt zich meteen registreren door op de onderstaande knop te klikken:",
      "joinNow": "Meld u nu aan"
    },
    "gdpr": {
      "logo": "AVG-logo",
      "dataProtection": "Gegevensbescherming en AVG",
      "introduction": "Introductie",
      "intro1": "HighLevel zet zich in voor de bescherming van de privacy van onze gebruikers en hun klanten. Wij blijven op de hoogte van ontwikkelingen op het gebied van wetgeving inzake gegevensbescherming om ervoor te zorgen dat u veiligheid gewaarborgd is wanneer u ons platform gebruikt.",
      "intro2": "Deze pagina licht de regels toe, hoe deze van toepassing zijn op uw gebruik van het HighLevel-platform en de maatregelen die wij hebben genomen om hieraan te voldoen.",
      "intro3": " U dient dit document samen met ons privacybeleid door te nemen en contact op te nemen met een gespecialiseerde jurist indien u meer informatie of advies nodig hebt.",
      "gdprRegulation": "Algemene Verordening Gegevensbescherming (AVG)",
      "regulation1": "Verordening (EU) 2016/679, Algemeen bekend als de Algemene Verordening Gegevensbescherming (AVG), is een EU-verordening die tot doel heeft de wetgeving inzake gegevensbescherming en privacy in de hele EU te harmoniseren. De bepalingen van de AVG zijn van toepassing op persoonsgegevens waarbij een EU-ingezete is betrokken.",
      "regulation2": "De AVG heeft als doel individuen meer controle te geven over hoe hun gegevens door bedrijven worden gebruikt en het verzamelen en verwerken van gegevens transparanter te maken.",
      "regulation3": "De AVG werd direct opgenomen in de Britse wetgeving na het einde van de Brexit-overgangsperiode, wat betekent dat Britse bedrijven nog steeds aan de bepalingen moeten voldoen via de 'UK GDPR'.",
      "basicConcepts": "Basisprincipes van de AVG",
      "controllerAndProcessor": "Verwerkingsverantwoordelijke en verwerker",
      "controllerProcessorObligation": "De AVG legt verschillende verplichtingen op aan personen, afhankelijk van of zij de verwerkingsverantwoordelijke of verwerker van persoonsgegevens zijn.",
      "controllerDefinition": " Een beheerder is een entiteit die besluit om persoonsgegevens te verwerken en beslissingen neemt over de basis van verwerking en de methoden die daarvoor worden gebruikt. Verwerkingsverantwoordelijken hebben bepaalde verplichtingen met betrekking tot persoonsgegevens, waarmee u zich vertrouwd moet maken voor u persoonsgegevens van uw klanten verzamelt.",
      "processorDefinition": "Een verwerker is een entiteit die gegevens verwerkt voor en namens de verwerkingsverantwoordelijke. Zij nemen geen onafhankelijke beslissingen met betrekking tot de gegevens of de verwerking ervan, aangezien zij deze uitsluitend in opdracht van de verwerkingsverantwoordelijke verwerken en alle instructies van deze laatste moeten opvolgen.",
      "youAreController": "Wanneer u gebruikmaakt van de HighLevel-service, bent u een verwerkingsverantwoordelijke. U hebt zelf de controle over de gegevens die u uploadt naar het HighLevel-systeem, wat u met die gegevens doet en waarom. Bijgevolg dient u ervoor te zorgen dat u over een wettelijke basis beschikt om de gegevens te verwerken en dat u de gegevens niet langer bewaart dan wettelijk noodzakelijk is.",
      "highlevelIsProcessor": "U dient ervoor te zorgen dat u uw verplichtingen als verwerkingsverantwoordelijke begrijpt en uw eigen systemen en beleid vernieuwt om het rechtmatig uploaden van persoonsgegevens naar HighLevel in te schakelen. HighLevel is een gegevensverwerker. We slaan de door u verzamelde gegevens op en beheren deze volgens uw instructies met behulp van het HighLevel-platform. We zullen nooit door u in het HighLevel-systeem geüploade persoonsgegevens gebruiken voor onze eigen doeleinden of zonder uw toestemming.",
      "legalBasisForProcessing": "Wettelijke basis voor verwerking",
      "legalBasisRequirement": "Persoonsgegevens mogen alleen worden verzameld en verwerkt als er een wettelijke basis voor bestaat. De toegestane juridische grondslagen zijn vastgelegd in de AVG.",
      "processorReliesOnCustomers": "In de hoedanigheid van verwerker vertrouwt HighLevel op onze klanten om de juiste grondslag te selecteren waaronder zij persoonsgegevens zullen verzamelen en verwerken, en om de juiste kennisgevingen en toestemmingen te verstrekken. Voor u gebruik maakt van de HighLevel-service, dient u de tijd te nemen om te bepalen welke juridische grondslagen er voor u beschikbaar zijn, en alleen persoonsgegevens te verzamelen en te bewaren voor zover dat vereist is overeenkomstig de desbetreffende grondslag. U mag de basis waarop u persoonsgegevens hebt verzameld niet wijzigen zonder een zeer goede reden, daarom is het belangrijk om de vereisten van de verschillende grondslagen te begrijpen en ervoor te zorgen dat u meteen de juiste selecteert.",
      "dataSubjectAccessRights": "Toegangsrechten betrokkene",
      "dataSubjectRights": "De AVG verleent betrokkenen (d.w.z. uw klanten) bepaalde rechten met betrekking tot hun persoonsgegevens, waaronder het recht op inzage, correctie en/of verwijdering van alle gegevens die hen betreffen.",
      "highlevelEasySystems": "HighLevel heeft eenvoudige systemen geïmplementeerd waarmee u ons kunt informeren over een dergelijk verzoek van een betrokkene, en waarmee wij u kunnen informeren als wij een dergelijk verzoek ontvangen. Wij zullen ervoor zorgen dat er meteen aan deze verzoeken wordt voldaan volgens uw instructies. U dient zich vertrouwd te maken met uw verplichtingen, inclusief die met betrekking tot persoonsgegevens die u op uw eigen systemen bewaart, of andere services dan die van HighLevel.",
      "transfersToUSA": "Gegevensoverdracht naar de VS",
      "transfersRestrictions": "Persoonsgegevens mogen niet buiten de EEA worden overgedragen, behalve onder specifieke omstandigheden. Wij maken gebruik van de standaard contractuele clausules als onderdeel van onze overeenkomst voor gegevensverwerking die wij met iedereen van onze klanten ondertekenen.",
      "dataSecurity": "Gegevensbeveiliging",
      "securitySafeguards": "We hebben strikte veiligheidsmaatregelen en -procedures geïmplementeerd om ervoor te zorgen dat alle persoonsgegevens die wij bewaren, veilig worden opgeslagen. Wij testen onze producten regelmatig op bugs en kwetsbaarheden.",
      "backupSystems": "Wij zorgen voor een regelmatig back-up van onze systemen en garanderen gegevensherstel en gegevensintegriteit om het risico op beschadiging of verlies van persoonsgegevens tot een minimum te beperken.",
      "stepsForCompliance": "Stappen die wij hebben ondernomen om de AVG-naleving te garanderen",
      "dutyAsProcessor": "We nemen onze taken als verwerker zeer serieus. We hebben een aantal procedures opgezet en maatregelen genomen om ervoor te zorgen dat we blijven voldoen aan de AVG en dat u de door u verzamelde persoonsgegevens op rechtmatige wijze naar ons kunt verzenden, bijvoorbeeld:",
      "standardContractualClauses": "Onze overeenkomst voor gegevensverwerking berust op de standaard contractbepalingen om te waarborgen dat u op legale wijze persoonsgegevens naar ons in de Verenigde Staten kunt verzenden.",
      "detectBreaches": "We kunnen inbreuken op persoonsgegevens opsporen en onze klanten zo snel mogelijk te informeren.",
      "dealWithAccessRequests": "We zijn in staat om verzoeken om inzage en verwijdering van gegevens te behandelen en zorgen ervoor dat we u informeren wanneer een betrokkene een dergelijk verzoek bij ons indient.",
      "assessedDocumented": "We hebben de persoonsgegevens die we namens u verwerken, beoordeeld en gedocumenteerd.",
      "assessedSecurity": "We hebben onze beveiliging geëvalueerd en waar nodig verbeterd om ervoor te zorgen dat deze geschikt is voor het risiconiveau met betrekking tot een datalek.",
      "dataProcessingAgreement": "Overeenkomst gegevensverwerking",
      "dateUpdated": "Datum herziening: 1 april 2023",
      "downloadAgreement": "Downloadovereenkomst",
      "supportEmail": "support{'@'}gohighlevel.com",
      "anyQuestions": "Heeft u nog vragen?"
    },
    "sendGridSettings": {
      "title": "SendGrid-instellingen",
      "settingsForLocations": "SendGrid-instellingen voor locaties",
      "sendGrid": "SendGrid",
      "last12Months": "Afgelopen 12 maanden",
      "totalSent": "Totaal verzonden",
      "opens": "Opent",
      "clicks": "Klikken",
      "bounces": "Bounces"
    },
    "launchpadSettings": {
      "disableLaunchpad": "Launchpad uitschakelen voor al mijn locaties.",
      "description1": "Launchpad is een goed doordachte landingspagina waarvan is bewezen dat deze klanttevredenheid en retentie oplevert via het productgebruik. ",
      "description2": "Het verbinden van GMB, FB, Webchat-plugin, gebruik van een mobiele app enzovoort zijn geweldige functies die klanten langer vasthouden.",
      "confirmDisable": "Weet u zeker dat u Launchpad wilt uitschakelen?"
    },
    "affiliateSettings": {
      "affiliateLinkDescription": "Dit is uw partnerlink. Gebruik deze link om mensen die u kent toe te staan zich te registreren voor een account en ontvang zo 40% van hun maandelijkse terugkerende omzet, levenslang.",
      "appendToUrls": "Voeg dit toe aan het einde van uw URL's:",
      "needToSignUp": "Inschrijven?",
      "goToUrl": "URL openen:",
      "andSignUpUsing": "en aanmelden via het e-mailadres",
      "asYourEmailAddress": "als uw e-mailadres voor FirstPromoter.",
      "pageSettings": "Pagina-instellingen",
      "facebookPixelId": "Facebook Pixel-ID",
      "pixelId": "Pixel-ID"
    },
    "agencyAPIKeySettings": {
      "enhancedAccountSecurity": "Vanaf 17 juni 2024 wordt verbeterde accountbeveiliging standaard automatisch ingeschakeld voor uw account. Deze beveiligingsverbeteringen omvatten:",
      "discontinuationOfAutoGeneration": "Stopzetting van het automatisch genereren van locatie-API-sleutels",
      "exclusionOfApiKeysInLocationCrudApis": "Uitsluiting van API-sleutels in locatie-CRUD-API's",
      "optOutLink": "Om u af te melden voor deze wijziging, schakelt u de verbeterde accountbeveiliging uit in <a href=\"/settings/company\">Instellingen &gt; Bedrijf</a>",
      "advancedFunctionalityNote": "Deze API biedt uitgebreide functionaliteit. Ons ondersteuningsteam kan geen rechtstreekse hulp bieden met betrekking tot de API-configuratie.",
      "developerCouncilInfo": "Onze ontwikkelaarsraad komt maandelijks bijeen (<a href=\"https://gohighlevel.com/events\">https://gohighlevel.com/events</a>) en we hebben ook een Slack-kanaal voor de ontwikkelaarscommunity waar u hulp kunt vragen van de community en ons API-team. (<a href=\"https://www.gohighlevel.com/dev-slack\">https://www.gohighlevel.com/dev-slack</a>)",
      "zapierNote": "Om Zapier te gebruiken, heeft u de locatie-API-sleutel voor de specifieke locatie nodig. U kunt deze vinden in de onderstaande lijst of door over te schakelen naar het account via de wisselknop in het menu aan de linkerkant.",
      "partOfAdvancedApi": "Dit is onderdeel van de Advanced API die beschikbaar is in het Pro-abonnement.",
      "upgradeMessage": "Dit is onderdeel van de Advanced API die beschikbaar is in het Pro-abonnement. <a>Klik hier</a> om te upgraden."
    },
    "accountMap": {
      "addAccountManually": "Account handmatig toevoegen"
    },
    "accountTeamsManagement": {
      "settingsAsGroups": "Instellingen als Groepen."
    },
    "accountDetails": {
      "basicDetails": "Basisgegevens",
      "saas": "SaaS",
      "rebilling": "Opnieuw factureren",
      "marketplaceApps": "Marketplace-apps",
      "advancedEmailSettings": "Uitgebreide instellingen",
      "calendarSettings": "Agenda-instellingen"
    },
    "advancedEmailSettings": {
      "controlLocationSettings": "Beheer de instellingen van de locatie",
      "disableAddEmailService": "Schakel de knop E-mailservice toevoegen uit in de instellingen van de e-mailservices van het sub-account",
      "disableAddSmtp": "Schakel de knop E-mailservice toevoegen uit in de instellingen van de e-mailservices van het sub-account",
      "restrictSubAccountEmailProvider": "Gebruikers van sub-accounts beperken bij het toevoegen van hun eigen e-mailprovider",
      "disableAddSmtpDescription": "Gebruikers van sub-accounts beperken bij het toevoegen van hun eigen e-mailprovider",
      "enableReVerification": "Herverificatie over 90 dagen inschakelen",
      "locationNoLeadConnector": "Locatie heeft LeadConnector niet als standaard e-mailprovider ingesteld",
      "lcEmailNotEnabled": "Locatie heeft LeadConnector niet als standaard e-mailprovider ingesteld",
      "onlyForAgency": "U kunt deze instelling alleen ingeschakeld zien voor agentschappen",
      "onlyVisibleForAgency": "U kunt deze instelling alleen ingeschakeld zien voor agentschappen",
      "reVerificationDescription": "Elke e-mailverificatiestatus wordt na 90 dagen ingetrokken (bescherm uw reputatie als afzender met het hoogste ontvangstpercentage)"
    }
  },
  "attributes": {
    "addAttribute": "Attribuut toevoegen",
    "attributeName": "Attribuutnaam",
    "enterAttributeName": "Voer de naam van het attribuut in",
    "number": "Nummer",
    "selectAttributeType": "Klik op het type kenmerk"
  },
  "audit": {
    "changeModal": {
      "additionalMetaData": "Aanvullende metadata",
      "title": "Toegevoegde / bijgewerkte velden"
    }
  },
  "bulkActions": {
    "additionalDetails": "Aanvullende details",
    "allOnGivenDate": "Alles op gegeven datum",
    "attempted": "Geprobeerd",
    "batchQuantity": "Batchgrootte",
    "bulkActionProcessing": "Verwerking van bulkacties",
    "bulkActionTitle": "Bulkactie",
    "campaignRequired": "Campagne is vereist",
    "currentStatus": "Huidige status",
    "delayBetweenBatches": "Vertraging tussen batches",
    "dispatchMode": "Verzendmodus: {mode}",
    "editBatchQuantity": "Batchgrootte bewerken",
    "emailStats": "E-mailstatistieken",
    "enterBatchSprintLimit": "Voer een batchsprintlimiet in",
    "hideStats": "Statistieken verbergen",
    "mode": "Modus",
    "nextProcessingOn": "Volgende verwerking op",
    "noStatsFound": "Geen statistieken gevonden",
    "parentBulkActionID": "ID voor bovenliggende bulkactie",
    "pleaseEnterQuantity": "Voer een hoeveelheid in",
    "processAllAsSoonAsPossible": "Alles zo snel mogelijk verwerken",
    "processAllOnGivenDate": "Alles op de opgegeven datum verwerken",
    "processDuring": "Verwerken tijdens",
    "processGraduallyDrip": "Geleidelijk verwerken (druppelen)",
    "processingAllowedOn": "Verwerking toegestaan op",
    "restoredBulkActionId": "Herstelde bulkactie-ID:",
    "revert": "Ongedaan maken",
    "revertedBulkActionId": "Teruggedraaide bulkactie-ID:",
    "saveChanges": "Wijzigingen opslaan",
    "scheduledStart": "Ingeplande start",
    "showErrorLog": "Foutenlogboek weergeven",
    "showImported": "Geïmporteerd weergeven",
    "showStats": "Statistieken tonen",
    "skipped": "Overgeslagen",
    "statistics": "Statistieken",
    "statuses": {
      "complete": "Voltooien",
      "next-drip": "Volgende druppel",
      "notStarted": "Niet begonnen",
      "processing": "Wordt verwerkt...",
      "queueing": "aangevraagd",
      "reading": "Lezen",
      "resumed": "Hervat",
      "reverted": "ongedaan gemaakt",
      "waiting": "Wachten"
    },
    "successful": "Gelukt",
    "tagsAdded": "Tags toegevoegd",
    "tagsRemoved": "Tags verwijderd",
    "tagsRestored": "Tags hersteld",
    "timeElapsed": "Verstreken tijd",
    "totalExported": "Totaal geëxporteerd",
    "totalMerge": "Totaal samengevoegd",
    "unknownError": "Onbekende fout",
    "updateBatchQuantity": "Batchgrootte bijwerken",
    "updated": "Geüpdatet",
    "usesDynamicList": "** Gebruikt dynamische lijst",
    "workflowRequired": "Workflow is vereist"
  },
  "business": {
    "addedToCompany": "Contactpersoon(en) succesvol aan het bedrijf toegevoegd",
    "cantAddMoreContacts": "U kunt niet meer dan 50 contactpersonen per keer toevoegen",
    "cleanerUi": "Schonere UI",
    "common": {
      "addContact": "Contactpersoon toevoegen",
      "internalServerError": "Interne serverfout",
      "to": "naar"
    },
    "companiesNowHave": "Bedrijven hebben nu",
    "companyNoteLabsText": "Bedrijfsnotities is een laboratoriumfunctie",
    "contactRemoveCompany": "Weet u zeker dat u deze contactpersoon van het bedrijf wilt wissen?",
    "moreFunctionalUx": "Meer functionele UX",
    "newCompanyUpdate": "Update van het nieuwe bedrijf!",
    "tabs": "Tabbladen",
    "tasks": {
      "assignTask": "Taak toewijzen",
      "assignee": "Verantwoordelijke",
      "deleteTask": "Taak verwijderen",
      "editTask": "Taak bewerken",
      "markAsComplete": "Markeren als voltooid",
      "markAsPending": "Markeren als in afwachting",
      "nameAndDescription": "Naam en beschrijving",
      "noTasksAvailable": "Geen taken beschikbaar"
    },
    "visitLabs": "Bezoek Labs"
  },
  "calendar": {
    "googleCalendar": "Google Agenda",
    "noSync": "Geen synchronisatie",
    "outlookCalendar": "Outlook Agenda"
  },
  "common": {
    "topBar": {
      "toggleFrontendDebugger": "Frontend Debugger in- of uitschakelen"
    },
    "icons": {
      "star": ""
    },
    "errorOccurred": "Er ging iets mis. Probeer het opnieuw.",
    "tabs": "Tabbladen",
    "showPassword": "Wachtwoord tonen",
    "hidePassword": "Wachtwoord verbergen",
    "goToHomepage": "Ga naar startpagina",
    "leadConnectorHqLogo": "Lead Connector HQ logo",
    "companyLogo": "Bedrijfslogo",
    "countries": {
      "australia": "Australië",
      "austria": "Oostenrijk",
      "czechRepublic": "Tsjechische Republiek",
      "belgium": "België",
      "brazil": "Brazilië",
      "canada": "Canada",
      "chile": "Chili",
      "denmark": "Denemarken",
      "switzerland": "Zwitserland",
      "germany": "Duitsland",
      "estonia": "Estland",
      "spain": "Spanje",
      "finland": "Finland",
      "france": "Frankrijk",
      "uk": "VK",
      "hongKong": "Hongkong",
      "hungary": "Hongarije",
      "ireland": "Ierland",
      "italy": "Italië",
      "japan": "Japan",
      "kenya": "Kenia",
      "lithuania": "Litouwen",
      "mexico": "Mexico",
      "netherlands": "Nederland",
      "newZealand": "Nieuw-Zeeland",
      "norway": "Noorwegen",
      "philippines": "Filippijnen",
      "puertoRico": "Puerto Rico",
      "poland": "Polen",
      "portugal": "Portugal",
      "sweden": "Zweden",
      "singapore": "Singapore",
      "unitedStates": "Verenigde Staten",
      "vietnam": "Vietnam",
      "southAfrica": "Zuid-Afrika"
    },
    "countryshortcodes": {
      "ca": "CA",
      "eu": "EU",
      "in": "IN",
      "na": "n.v.t.",
      "us": "VS"
    },
    "misc": {
      "0": "0",
      "1": "1",
      "10": "10",
      "10x": "10x",
      "1 (555) 987-6543": "+1 (555) 987-6543",
      "1x": "1x",
      "3x": "3x",
      "720_x_720_px": " 720 x 720 px",
      "x": "x",
      "g": "G",
      "m": "/M",
      "s": "s",
      "k": " K",
      "esc": "ESC",
      "fb": "fb",
      "ghl": "GHL",
      "mrr": "MRR",
      "dnd": "DND",
      "gbp": "GBP",
      "sms": "Sms",
      "api": "API",
      "otp": "OTP",
      "tcr": "TCR",
      "ein": "EIN",
      "acn": "ACN",
      "cbn": "CBN",
      "vat": "BTW",
      "cvv": "CVV",
      "amex": "AMEX",
      "visa": "VISA",
      "mastercard": "MasterCard",
      "dinersClub": "Diners Club",
      "2fa": "2FA",
      "ivr": "IVR",
      "ppc": "PPC",
      "cpaas": "CPaaS",
      "lc": "LC",
      "a2p": "A2P",
      "sha": "SHA",
      "_frameborder0_scrollingauto_width100_height500ifra": "&quot; frameborder=&quot;0&quot; scrolling=&quot;auto&quot; width=&quot;100%&quot; height=&quot;500&quot;&gt;</iframe>",
      "iframe_src": "<iframe src=\"",
      "editNumberPoolStrongnamestrong": "Nummerpool bewerken - <strong>{name}</strong>",
      "displayphonenumber": "displayPhoneNumber",
      "js_heap_memory": "JS Heap-geheugen",
      "vuex_store_modules": "Vuex Store Modules",
      "vuex_store_size": "Vuex Store Grootte",
      "admanagerlogo": "ad-manager-logo",
      "seosearchatlaslogo": "seo-search-atlas-logo",
      "modelimage": "model-afbeelding",
      "tipaltiiframe": "tipalti-iframe",
      "fileimage": "afbeeldingsbestand",
      "urlimage": "url-afbeelding",
      "msgsndr8": "msgsndr8",
      "testmaindomaincom": "testmain{'@'}domain.com",
      "webdevexamplecom": "web-dev{'@'}example.com",
      "httpexamplecom": "http://example.com",
      "smtpgmailcom": "smtp.gmail.com",
      "xyzcomOrUtmcampaignxyz": "xyz.com of utm_campaign=xyz",
      "websitecom": "website.com",
      "strongshakenstirstrongVerifica": "De <strong>SHAKEN/STIR</strong>-verificatie is voltooid voor uw subaccount. Bouw vertrouwen op bij uw klanten door middel van geverifieerde oproepen.",
      "mp3wavfile": "mp3/wav-bestand",
      "usd": "$",
      "1_555_9876543": "+1 (555) 987-6543"
    },
    "stepProgress": "Stap {currentStep} van {totalSteps}",
    "loadMore": "Meer laden",
    "1_segment_is_equal_to_a_sms_of_160_characters_clic": "1 segment staat gelijk aan een SMS van 160 tekens. Klik op het pictogram voor meer details over de prijzen.",
    "1_segment_is_equal_to_an_sms_of_160_characters_cli": "1 segment is gelijk aan een SMS van 160 tekens. Klik op het pictogram voor meer informatie over de prijzen.",
    "_email": "/ e-mail",
    "_ip": "/ IP",
    "_min": " / min",
    "_of_total": "% van het totaal",
    "_please_add_a_payment_method_for": "! Voeg een betaalmethode toe voor ",
    "_segment": " / segment",
    "_used": "% gebruikt",
    "a_new_twilio_account_needs_to_be_created_before_we": "Er moet een nieuw Twilio-account worden aangemaakt voordat we opnieuw kunnen factureren",
    "a_sub_account_can_have_up_to_10_custom_objects_if_": "Een subaccount kan maximaal 10 aangepaste objecten bevatten. Als de limiet wordt overschreden, worden er geen aangepaste objecten aangemaakt op basis van deze momentopname.",
    "a_twilio_account_is_already_setup_for_this_location": "Er is al een Twilio-account ingesteld voor deze locatie",
    "accountName": "Accountnaam",
    "account_sid": "Account SID:",
    "action": "Actie",
    "actions": "Acties",
    "activate": "Inschakelen",
    "active": "Actief",
    "active_listeners": "Actieve luisteraars",
    "active_subscriptions": "Actieve abonnementen",
    "ad_manager": " Advertentiebeheer",
    "add": "Toevoegen",
    "addAction": "Actie toevoegen",
    "add_eliza": "Voeg Eliza toe",
    "add_image": "Afbeelding toevoegen",
    "add_payment_method": "Betaalmethode toevoegen",
    "add_to_account": "Aan account toevoegen",
    "add_user_icon": "Gebruikerspictogram Toevoegen",
    "add_your_first_email": "Voeg uw eerste e-mail toe.",
    "address": "Adres",
    "adwords_reporting": "Adwords-rapportage",
    "affiliate_manager": "Partner Manager",
    "agency": "Agentschap",
    "agency_logo": "logo van het agentschap",
    "agency_settings": "Instellingen agentschap",
    "agent_reporting": "Rapportage door agenten",
    "ai_employee": " AI-medewerker ",
    "all": "Alle",
    "allow_subaccounts_to_cancel_their_subscription": "Sta subaccounts toe om hun abonnement op te zeggen",
    "allow_subaccounts_to_upgrade_to_a_higher_plan": "Sta subaccounts toe om naar een hoger plan te upgraden",
    "allowed_format": "Toegestane indeling:",
    "am": "AM",
    "announcements_click_to_open_in_new_tab": "Aankondigingen - klik om te openen in een nieuw tabblad",
    "answers": "Antwoorden",
    "app_name": "App-naam",
    "appointments": "Afspraken",
    "apps": " apps",
    "ask_ai": "Vraag het aan AI",
    "ask_anything": "Stel uw vraag...",
    "assigned_to_another_user": "(Toegewezen aan een andere gebruiker)",
    "at_least_one_location_is_required": "Er is minimaal één locatie vereist",
    "attach_snapshot": "Momentopname bijvoegen",
    "attribution_reporting": "Rapportagetoewijzing",
    "authorized_representative": "Geautoriseerde vertegenwoordiger",
    "automation_type": "Automatiseringstype",
    "available_hours": "Beschikbare uren",
    "avg_memoryinstance": "Gem. geheugen/instance",
    "back": "Terug",
    "base_url": "Basis-URL",
    "between_10_kb_and_5_mb": " Tussen 10 KB en 5 MB",
    "birthday_sms": "Verjaardagssms",
    "birthday_sms_with_image": "Verjaardags-SMS met Afbeelding",
    "blogging": "Bloggen",
    "bounced": "Gebounced",
    "bulk_requests": "Bulkverzoeken",
    "business_email": "Zakelijke e-mail",
    "business_hours_configurations": "Configuraties voor openingsuren",
    "business_industry": "Bedrijfssector",
    "business_information": "Bedrijfsinformatie",
    "business_logo": "Bedrijfslogo",
    "business_niche": "Bedrijfsniche",
    "business_phone": "Zakelijk telefoonnummer",
    "business_physical_address": "Fysiek bedrijfsadres",
    "business_regions_of_operations": "Bedrijfsregio's activiteiten",
    "business_registration_id_type": "Type bedrijfsregistratie-ID",
    "business_registration_number": "KVK-nummer",
    "business_type": "Bedrijfstype",
    "business_website": "Bedrijfswebsite",
    "busy": "Niet beschikbaar",
    "buttons": {
      "cancel": "Annuleren",
      "confirm": "Bevestigen",
      "deleteAll": "Alles verwijderen",
      "view": "Bekijken",
      "close": "Sluiten",
      "previous": "Vorige",
      "next": "Volgende",
      "clear": "Wissen",
      "save": "Opslaan",
      "edit": "Bewerken",
      "delete": "Verwijderen",
      "reset": "Herstellen",
      "refresh": "Vernieuwen",
      "nextLoading": "Volgende...",
      "copied": "Gekopieerd",
      "notNow": "Niet nu",
      "send": "Verzenden",
      "send1": "Verzenden",
      "download": "Downloaden",
      "sendNow": "Nu verzenden",
      "saved": "Opgeslagen",
      "back": "Terug",
      "update": "Updaten",
      "add": "Toevoegen",
      "submit": "Verzenden",
      "submitting": "Indienen",
      "done": "Voltooid",
      "manageUsers": "Gebruikers beheren",
      "no": "Nee",
      "yes": "Ja"
    },
    "calendar": "Agenda",
    "calendar_groups": "Agendagroepen",
    "call": "Oproep",
    "call_reporting": "Gespreksrapportage",
    "call_tracking_is_disabled": "Oproeptracking is uitgeschakeld",
    "call_voicemail_settings": "Instellingen voor oproepen en voicemails",
    "calls": " oproepen",
    "campaign": "Campagne",
    "campaigns": "Campagnes",
    "cancel": " Annuleren ",
    "cancel_subscription": "Abonnement opzeggen",
    "cancelled": "Geannuleerd",
    "certificates": "Certificaten",
    "change": "Wijzigen",
    "changed_data": "Gewijzigde Gegevens",
    "charge": " Prijs",
    "charged_to_customer": "In rekening gebracht aan de klant",
    "chat": "Chat",
    "chat_user": "Chatgebruiker",
    "chat_widget_icon": "Pictogram chatwidget",
    "chats_will_be_saved_for_2_days": "Chats worden 2 dagen bewaard",
    "check": "check",
    "check_number_validity_before_first_sms_block_incom": "Controleer de geldigheid van het nummer voordat u de eerste SMS verstuurt, detecteer inkomende spamoproepen en zoek de namen van onbekende bellers op voordat u de telefoon opneemt. Er gelden extra kosten",
    "cinque_terre": "Cinque Terre",
    "city": "Stad",
    "clear_history": "Geschiedenis wissen",
    "click_here": "Klik hier",
    "click_on_create_new_snapshot_to_add_one": " Klik op Nieuwe momentopname maken om deze toe te voegen.",
    "click_to_access_the_highlevel_welcome_course": "Klik om toegang te krijgen tot de HighLevel Welkomstcursus",
    "click_to_upgrade": "Klik om te upgraden",
    "clicked": "Geklikt",
    "clio": "Clio",
    "cloning": "Klonen",
    "close_debugger": "Sluit de debugger",
    "close_whatsapp_template_creator": "Sluit WhatsApp Template Creator",
    "collection": "Verzameling",
    "columns": "Kolommen",
    "coming_soon": "Binnenkort beschikbaar",
    "company_email_": "Zakelijke e-mail (",
    "complete_component_data": "Volledige Componentgegevens",
    "complete_event_data": "Volledige gegevens gebeurtenis",
    "complete_query_data": "Volledige querygegevens",
    "completed": "Voltooid",
    "complimentary_credits": "Gratis tegoed",
    "component": "Onderdeel",
    "component_name": "Componentnaam",
    "component_type": "Componenttype",
    "components": " onderdelen",
    "condition": "Voorwaarde",
    "confirm": "BEVESTIGEN",
    "confirmation_message": "Bevestigingsbericht",
    "confirmed": "Bevestigd",
    "connect_with_a_certified_admin_click_to_open_in_ne": "Neem contact op met een gecertificeerde beheerder - klik om te openen in een nieuw tabblad",
    "connect_with_us_start_live_chat": "Contacteer ons - start de live chat",
    "connect_your_stripe_account": "Verbind uw Stripe-account ",
    "connect_zoom": "Zoom verbinden",
    "consider_leaving_it_blank_should_you_choose_to_use": "U kunt dit leeg te laten, mocht u ervoor kiezen om de vooraf geconfigureerde bijeenkomstlocatie te gebruiken",
    "contact": "Contactpersoon",
    "contact_support": "neem contact op met de ondersteuning",
    "contact_us_call_highlevel_at_18887324197": "Neem contact met ons op - bel HighLevel op +1(888)732-4197",
    "contacts": "Contactpersonen",
    "content_ai": "Content AI",
    "controls": "Besturingselementen",
    "conversations": "Gesprekken",
    "copied": "Gekopieerd",
    "cost_borne_by_you": " door u gedragen kosten",
    "count": "Count",
    "country": "Land",
    "createNewFolder": "Nieuwe map aanmaken",
    "credit_balance": "KREDIETSALDO",
    "current_location_id": "Huidig locatie-ID",
    "custom": "Aangepast",
    "custom_email": "Aangepast e-mailadres",
    "custom_niche": "Aangepaste niche",
    "customer_notifications": "Klantmeldingen",
    "customize": "Aanpassen",
    "customize_chat_widget": "Pas de chatwidget aan",
    "dashboard_stats": "Dashboardstatistieken",
    "data_keys": "Datasleutels",
    "date": "Datum",
    "days": "Dagen",
    "dedicated_ip": "Statisch IP-adres ",
    "default": "Standaard",
    "default_snapshots": "Standaard momentopnames",
    "delete": "Verwijderen",
    "deleted": "verwijderd",
    "delivered": "Afgeleverd",
    "description": "Beschrijving",
    "details": "Details",
    "disable_gbp_messaging_not_recommended": "GBP-berichten uitschakelen (niet aanbevolen)",
    "disable_tracking": "Schakel tracking uit",
    "disabled": "Uitgeschakeld",
    "dismiss": "Weigeren",
    "display_name": "Weergavenaam",
    "do_not_delete": "niet verwijderen",
    "do_something": "ONDERNEEM ACTIE",
    "do_you_want_to_keep_the_same_or_create_a_new_one": "Wilt u hetzelfde behouden of een nieuwe aanmaken?",
    "download_application_icon": "Download het applicatiepictogram",
    "draft": "Concept",
    "dropdown_icon": "Pictogram keuzelijst",
    "duplicate": "Dupliceren",
    "duration": "Duur",
    "eliza": "Eliza",
    "eliza_bypass_tag_optional": "Eliza Bypass-tag (Optioneel)",
    "eliza_is_required": "Eliza is vereist.",
    "eliza_service": "Eliza-service",
    "email": "E-mail",
    "email_resell_settings": "Instellingen voor doorverkoop per e-mail",
    "email_sending": "E-mail verzenden",
    "email_signature": "E-mailhandtekening",
    "enable": "Inschakelen",
    "enable_beta": " Bèta inschakelen",
    "enable_company_automation": "Bedrijfsautomatisering inschakelen",
    "enable_disable_deprecated_features": "Inschakelen / Uitschakelen van verouderde functies",
    "enable_gbp_call_tracking": " Schakel het volgen van GBP-gesprekken in ",
    "enable_gbp_messaging": "GBP-berichten inschakelen",
    "enable_signature_on_all_outgoing_messages": "Schakel handtekening in voor alle uitgaande berichten",
    "enabled": "Ingeschakeld",
    "notEnabled": "Niet ingeschakeld",
    "enter_a_logical_name": "Voer een logische naam in",
    "enter_the_exact_business_address_as_it_appears_in_": "Voer het exacte bedrijfsadres in zoals het verschijnt in de EIN-vermelding.",
    "enter_the_exact_legal_business_name_as_registered_": "Voer de exacte juridische bedrijfsnaam in, zoals geregistreerd bij de officiële instanties.",
    "enter_the_full_street_address_as_it_appears_in_the": "Voer het volledige straatadres in zoals het verschijnt in de EIN-vermelding.",
    "enter_user_email": "Voer het e-mailadres van de gebruiker in",
    "enter_user_phone_number": "Voer het telefoonnummer van de gebruiker in",
    "enter_your_business_registration_id_type": "Voer uw type bedrijfsregistratie-ID in",
    "enter_your_business_vertical_eg_travel": "Voer uw bedrijfssector in (bijv.: reizen)",
    "error_code": "Foutcode",
    "error_code_chart": "Tabel met foutcodes",
    "error_while_copying_api_key": "Fout bij het kopiëren van de API-sleutel!",
    "event": "Gebeurtenis",
    "event_bus_listeners": "Eventbusluisteraars",
    "events": " gebeurtenissen",
    "everything_in": "Alles in ",
    "exact": "Exact",
    "execute_this_action_if_the_current_time_falls_in_t": "Voer de actie uit als de huidige tijd binnen dit venster valt; wacht zoniet tot het volgende tijdvenster om deze actie uit te voeren.",
    "extension": "Uitbreiding",
    "facebook": "Facebook",
    "facebook_ads": "Facebookadvertenties",
    "facebook_ads_reporting": "Rapportage Facebook-advertenties",
    "facebook_adsets": "Facebook AdSets",
    "facebook_campaigns": "Facebook-campagnes",
    "facebook_icon": "Facebookpictogram",
    "facebook_page": "Facebookpagina",
    "feature_image": "afbeeldingskenmerk",
    "features": "Voorzieningen:",
    "feedback": "Feedback: ",
    "file_path": "Bestandspad",
    "firestore_listeners": "Firestore Listeners",
    "forms": "Formulieren",
    "free": "Gratis",
    "fri": "Vr",
    "friendly_business_name": "Beschrijvende bedrijfsnaam",
    "from": " van ",
    "funnels": "Trechters",
    "gbp_call_tracking": "GBP-gesprekstracering",
    "gbp_configuration": "GBP-configuratie",
    "general": "Algemeen",
    "general_information": "Algemene informatie",
    "generating_link_please_wait": "Link genereren, even geduld...",
    "google_ads_adgroups": "Google Ads AdGroups",
    "google_ads_ads": "Google Ads Advertenties",
    "google_ads_campaigns": "Google Ads-campagnes",
    "google_ads_keywords": "Google Ads-zoekwoorden",
    "google_business_messaging": "Google Business Messaging",
    "google_business_profile": "Google Bedrijfsprofiel",
    "google_my_business_icon": "Pictogram Google Bedrijfsprofiel",
    "hello": "Hallo ",
    "here": "hier",
    "hhmm_a": "hh:mm A",
    "hi": "Hallo ",
    "hide": "Verbergen",
    "highlevel_events_click_to_open_in_new_tab": "Highlevel Events - klik om te openen in een nieuw tabblad",
    "how_can_i_help_you_today": "Hoe kan ik u vandaag helpen?",
    "how_did_the_call_go": "Hoe is het gesprek verlopen?",
    "how_do_i_calculate_my_email_cost_click_on_the_icon": "Hoe kan ik mijn e-mailkosten berekenen? Klik op het pictogram voor meer informatie",
    "how_does_it_work": "Hoe het werkt",
    "htmlElement": "HTML-element (TODO):",
    "html_element_todo": "HTML-element (TODO): ",
    "id": "ID: ",
    "if": "Indien",
    "if_activated_the_sender_information_will_be_automa": "Indien geactiveerd, wordt de afzenderinformatie automatisch toegevoegd aan het eerste SMS-bericht van elke bulkberichtcampagne om naleving te garanderen en de bezorgpercentages te verhogen.",
    "if_activated_we_will_insert_unsubscribe_links_in_y": "Indien geactiveerd, zullen we uitschrijflinks in de voettekst van uw e-mails invoegen, zodat ontvangers zich kunnen afmelden zonder de e-mail als klacht/spam te markeren.",
    "ignore_this_update": "Negeer deze update",
    "image": "afbeelding",
    "image_turned_on": "Afbeelding Ingeschakeld",
    "imported_date": "Importdatum",
    "imported_snapshots": "Geïmporteerde momentopnames",
    "inbound": "Inkomend",
    "inbound_number": "Inkomend nummer",
    "incoming_call_timeout": "Time-out inkomend gesprek",
    "instance_id": "Instance-ID",
    "instances": "Instanties: ",
    "instructions_mentioned_in_this_page": "instructies die op deze pagina worden vermeld",
    "internal": "Intern",
    "intro_message": "Introbericht",
    "intro_question": "Introductievraag",
    "invalid": "Ongeldig",
    "invoicing": "Facturering",
    "is_scheduled_for_deletion_on": " is gepland voor verwijdering op ",
    "job_position": "Functie",
    "job_title": "Functietitel",
    "join_our_facebook_group_click_to_open_in_new_tab": "Word lid van onze Facebookgroep - klik om te openen in een nieuw tabblad",
    "jpg_or_png": " JPG of PNG ",
    "just_one_sec": "Even geduld..",
    "key_sizes": "Sleutelgroottes",
    "label": "label",
    "labels": {
      "sortDirection": "Sorteerrichting",
      "tableStyling": "Tabelopmaak",
      "loadingMore": "Meer laden...",
      "loading": "Aan het laden...",
      "filter": "Filteren",
      "search": "Zoeken...",
      "sortBy": "Sorteren op",
      "perPage": "Per pagina",
      "date": "Datum",
      "time": "Tijd",
      "readMore": "Lees meer",
      "day": "Dag",
      "slot": "Tijdsperiode",
      "template": "Sjabloon",
      "city": "Stad",
      "country": "Land",
      "state": "Provincie",
      "customerName": "Naam klant",
      "friendlyName": "Beschrijvende naam",
      "required": "* vereist",
      "addressLine1": "Adresregel 1",
      "addressLine2": "Adresregel 2",
      "postalCode": "Postcode",
      "searchUsers": "Zoeken naar gebruikers",
      "unknown": "Onbekend",
      "businessName": "Bedrijfsnaam"
    },
    "last_updated": "Laatst bijgewerkt",
    "launchpad_icon": "Pictogram launchpad",
    "lead": "Lead",
    "leadconnector": "LeadConnector",
    "learn_how": "(Meer weten?)",
    "legal_business_name": "Juridische bedrijfsnaam",
    "limit_updated_from": " limiet bijgewerkt van ",
    "listeners": " Luisteraars",
    "loading_your_conversation_history": "Uw gespreksgeschiedenis laden...",
    "location": "Locatie",
    "locations": " locaties",
    "logical_name": "Logische Naam",
    "logical_name_is_required": "Een logische naam is vereist.",
    "logo": "Logo",
    "mailgun": "MailGun",
    "making_calls": "Bellen",
    "manage_custom_email": "Aangepaste e-mail beheren",
    "marketing": "Marketing",
    "maximize": "Maximaliseren",
    "me_": "Mij (",
    "member_since": "Lid sinds",
    "membership": "Lidmaatschap",
    "memory_analysis": "Geheugenanalyse",
    "memory_api_not_available": "Geheugen-API is niet beschikbaar",
    "message": "Bericht",
    "minimize": "Minimaliseren",
    "minimum_must_be": " Het minimum moet ",
    "miscellaneous_charges": "Diverse kosten",
    "missed_call_text_back": "Gemiste oproep terug sms'en",
    "missed_text_back_call_message": "Gemiste tekst terugbelbericht",
    "model": "Model",
    "module": "Module",
    "modules": " modules",
    "mon": "Ma",
    "month": "/maand",
    "monthly": "maandelijks",
    "more_emails_in_thread": " meer e-mails in de conversatie",
    "mount_count": "Mount Count",
    "mount_time": "Montagetijd",
    "moved_to_calendar_settings": "Verplaatst naar de kalenderinstellingen",
    "multiple_locations_using_same_twilio_account": "Meerdere locaties die hetzelfde Twilio-account gebruiken",
    "must_be_in_range_of_0": " Moet binnen het bereik van 0- liggen.",
    "must_be_less_than_monthly_plan_12": " Moet lager zijn dan het Maandabonnement * 12 ",
    "my_business_is": "Mijn bedrijf is ",
    "my_snapshots": "Mijn momentopnames",
    "name": "Naam",
    "name_of_other_registration_id_type": "Naam van een ander registratie-ID type",
    "newFolder": "Nieuwe map",
    "new_task_update": "Nieuwe Taakupdate!",
    "next": "Volgende",
    "no_answer": "Geen antwoord",
    "no_bigger_than_25mb": "niet groter dan 2,5 MB",
    "no_customer_selected": "Geen klant geselecteerd",
    "no_error_data_found": "Geen foutgegevens gevonden",
    "no_payment_method_available": "Geen betaalmethode beschikbaar",
    "no_provider_found": "Geen aanbieder gevonden",
    "no_snapshots_found": "Er konden geen momentopnames worden gevonden!",
    "noshow": "No-show",
    "not": "Niet",
    "not_now": "Niet nu",
    "not_saved": "Niet opgeslagen",
    "notes": "Notities",
    "notifications": "Meldingen",
    "now": "Nu",
    "numbers_and": " aantal(en) en ",
    "objective": "Doelstelling:",
    "of": "van",
    "onboarding_video_tutorials_click_to_open_in_new_ta": "Videotutorials onboarding - klik om te openen in een nieuw tabblad",
    "online_listings": "Online vermeldingen",
    "only_assigned_data": "Alleen toegewezen data",
    "open_performance_debugger": "Open Performance Debugger",
    "opened": "Geopend",
    "opportunities": "Leads",
    "options": {
      "ascending": "Oplopend",
      "descending": "Aflopend",
      "none": "-- Geen --"
    },
    "or_drag_and_drop": "of slepen en neerzetten",
    "outbound": "Uitgaand",
    "pagination": "Paginering",
    "pass_body_content_here": " Hier is de inhoud van de Body Pass ",
    "password": "Wachtwoord",
    "paused": "Onderbroken",
    "payment_links": "Betaallinks",
    "payment_methods": "Betaalmethoden",
    "payment_refund": "Terugbetaling",
    "payment_settings_navigation": "Navigatie voor betalingsinstellingen",
    "payments": "Betalingen",
    "payments_integration": "Betalingsintegratie",
    "pending": "In afwachting",
    "per_page": "Per pagina",
    "percentage": "Percentage",
    "permanently_delete_this_email": "Deze e-mail permanent verwijderen",
    "personal_logo": "Persoonlijk logo",
    "phone": "Telefoon",
    "phone_number_with_country_code": "Telefoonnummer (met landcode)",
    "pick_a_niche": "Selecteer een niche",
    "pick_a_snapshot": "Selecteer een momentopname",
    "pick_business_industry": "Selecteer een bedrijfssector",
    "pick_business_registration_id_type": "Kies het type bedrijfsregistratie-ID",
    "pick_business_type": "Selecteer het bedrijfstype",
    "pick_job_position": "Selecteer een functie",
    "plans_pricing": "Plannen en prijzen",
    "please_enter_a_value_greater_than_20": "Voer een waarde groter dan 20 in.",
    "pm": "PM",
    "points": "Punten",
    "postalzip_code": "Postcode",
    "previous": "Vorige",
    "privacy_policy_url": "URL Privacybeleid",
    "privacy_policy_url_will_be_shown_on_your_google_ag": "De URL van het privacybeleid zal worden weergegeven in uw Google-agentgegevens.",
    "process_your_payment": "Verwerk uw betaling",
    "profile_picture": "Profielfoto",
    "profit": "Winst",
    "prospecting": " Acquisitie ",
    "provide_prebuild_snapshots_to_the_new_accounts": "Zorg ervoor dat de nieuwe accounts pre-build snapshots ontvangen.",
    "queries": " queries",
    "questions": "Vragen",
    "quick_actions_icon": "Pictogram voor snelle activiteiten",
    "re_generate_key": "Sleutel opnieuw genereren",
    "read_only": "Alleen-lezen",
    "receipts_settings": "Instellingen voor betalingsbewijzen",
    "receiving_calls": "Oproepen ontvangen",
    "recent_events": "Recente gebeurtenissen",
    "recommended": "Aanbevolen",
    "recommended_resolution": "Aanbevolen oplossing:",
    "reconnect": "Opnieuw verbinden ",
    "record_payment": "Betaling registreren",
    "registered": " geregistreerd.",
    "renameFolder": "Map hernoemen",
    "replied": "Geantwoord",
    "representative_email": "E-mail vertegenwoordiger",
    "resell_settings": " Instellingen voor doorverkoop",
    "reset": "Herstellen",
    "resolve_now": "Nu oplossen",
    "resource_counts": "Resource-aantallen",
    "restore": "Herstellen",
    "results": "Resultaten",
    "reviews": "Recensies",
    "rollover_unused_credits_to_next_month": "Zet ongebruikt tegoed over naar de volgende maand",
    "row": " rij",
    "runNow": "Nu uitvoeren",
    "sample_data": "(Voorbeeldgegevens)",
    "sat": "Za",
    "save": "Opslaan",
    "save_missed_call_text_settings": "Instellingen Sms terugsturen voor gemiste oproepen",
    "save_staging_url": "Staging-URL opslaan",
    "saved": "Opgeslagen",
    "saving": "Opslaan...",
    "search": "Zoeken",
    "search_active_apps": "Zoeken naar actieve apps...",
    "search_components": "Onderdelen zoeken...",
    "search_customer": "Klant zoeken",
    "search_email": "E-mail zoeken",
    "search_history": "Zoekgeschiedenis...",
    "search_icon": "zoekpictogram",
    "search_listeners": "Zoeken naar luisteraars...",
    "search_modules": "Zoeken naar modules...",
    "search_queries": "Queries doorzoeken...",
    "see_this_review_on_gbp": "Bekijk deze recensie op GBP ",
    "segments": " segmenten",
    "select": "Selecteren",
    "select_a_snapshot": "Selecteer een momentopname",
    "monetary": "MONETAIR",
    "pleaseSelectAValue": "Selecteer een waarde",
    "select_account": "Account selecteren",
    "select_an_account": "Selecteer een account",
    "select_eliza_bypass_tag": "Selecteer de Eliza Bypass-tag",
    "select_phone_number": "Selecteer telefoonnummer",
    "select_send_to_eliza_tag": "Selecteer Verzenden naar Eliza-tag",
    "select_snapshot": " Momentopname selecteren",
    "select_upto": "Selecteer maximaal ",
    "selected": "Geselecteerd: ",
    "send": "Verzenden",
    "send_to_eliza_tag_optional": "Stuur naar Eliza Tag (optioneel) ",
    "seo": " SEO ",
    "settings": "Instellingen",
    "setup_pending": "Configuratie in afwachting",
    "share": "Delen",
    "shared_snapshots": "Gedeelde momentopnames",
    "shared_type": "Gedeeld type",
    "shipping_and_delivery": "Verzending en levering",
    "shipping_origin": "Herkomst verzending",
    "show": "Tonen",
    "showed": "Aanwezig",
    "signin_with_single_signon": "Inloggen met eenmalige aanmelding",
    "size": "Formaat",
    "sms_message_sent_to_customer": "Sms-bericht verzonden naar de klant",
    "snapshot_date": "Datum momentopname",
    "snapshot_name": "Naam momentopname",
    "social_planner": "Social Planner",
    "sortBy": "Sorteren op",
    "sortOptions": {
      "createdDate": "Aanmaakdatum"
    },
    "source": "Bron",
    "sources": "Bronnen:",
    "spent": "Uitgegeven",
    "staging_url_settings_for_db_event": "Instellingen voor staging-URL (voor Db-gebeurtenis)",
    "state": "Provincie",
    "state_prov_region_": "Staat / Provincie / Regio *",
    "states": {
      "alabama": "Alabama",
      "alaska": "Alaska",
      "arizona": "Arizona",
      "arkansas": "Arkansas",
      "california": "California",
      "colorado": "Colorado",
      "connecticut": "Connecticut",
      "delaware": "Delaware",
      "district_of_columbia": "District Of Columbia",
      "florida": "Florida",
      "georgia": "Georgië",
      "hawaii": "Hawaii",
      "idaho": "Idaho",
      "illinois": "Illinois",
      "indiana": "Indiana",
      "iowa": "Iowa",
      "kansas": "Kansas",
      "kentucky": "Kentucky",
      "louisiana": "Louisiana",
      "maine": "Maine",
      "maryland": "Maryland",
      "massachusetts": "Massachusetts",
      "michigan": "Michigan",
      "minnesota": "Minnesota",
      "mississippi": "Mississippi",
      "missouri": "Missouri",
      "montana": "Montana",
      "nebraska": "Nebraska",
      "nevada": "Nevada",
      "new_hampshire": "New Hampshire",
      "new_jersey": "New Jersey",
      "new_mexico": "New Mexico",
      "new_york": "New York",
      "north_carolina": "North Carolina",
      "north_dakota": "North Dakota",
      "ohio": "Ohio",
      "oklahoma": "Oklahoma",
      "oregon": "Oregon",
      "pennsylvania": "Pennsylvania",
      "rhode_island": "Rhode Island",
      "south_carolina": "South Carolina",
      "south_dakota": "South Dakota",
      "tennessee": "Tennessee",
      "texas": "Texas",
      "utah": "Utah",
      "vermont": "Vermont",
      "virginia": "Virginia",
      "washington": "Washington",
      "west_virginia": "West Virginia",
      "wisconsin": "Wisconsin",
      "wyoming": "Wyoming",
      "noRecordsFound": "Geen records gevonden",
      "noEntriesToShow": "Er zijn geen vermeldingen om te tonen",
      "unsuccessful": "Mislukt",
      "pending": "In afwachting",
      "noUsersFound": "Geen gebruikers gevonden"
    },
    "status": "Status",
    "stop_delete_operation": "Verwijderbewerking stoppen",
    "street_address": "Straatadres",
    "street_address_as_it_appears_in_the_ein_listing": "Straatadres zoals het voorkomt in de EIN-lijst.",
    "stripe_icon": "Stripe-icoon",
    "stripe_integration": "Stripe-integratie",
    "stripe_secret_key": "Razorpay geheime sleutel",
    "subscriptions": "Abonnementen",
    "sun": "Zo",
    "surveys": "Enquêtes",
    "suspend_subaccount_when_their_saas_subscription_fa": "Subaccount opschorten wanneer hun SaaS-abonnement niet geldig is.",
    "switchAccount": "Account wisselen",
    "switch_off_sections_below_to_disable": "Schakel de onderstaande onderdelen uit om uit te schakelen",
    "tags": "Tags",
    "tax_settings": "Belastinginstellingen",
    "team_management": "Teammanagement",
    "team_notifications": "Teammeldingen",
    "template": "Sjabloon",
    "terms_and_conditions": "Algemene voorwaarden",
    "test_mobile_no": "Test mobiel nummer.",
    "text_messages": "Sms-berichten",
    "the_proposed_size_is_350px_180px": "De voorgestelde grootte is 350px * 180px",
    "the_proposed_size_is_512512px": "De voorgestelde grootte is 512*512px",
    "the_selected_language_will_be_used_by_the_system_a": "De geselecteerde taal zal door het systeem als standaard worden ingesteld.",
    "the_welcome_message_automatically_appears_after_a_": "Het welkomstbericht verschijnt automatisch nadat een gebruiker een nieuw gesprek begint.",
    "these_are_margins_that_are_billed_to_your_clients_": "Dit zijn marges die aan uw klanten worden gefactureerd over de ",
    "this_data_will_be_used_for_future_compliance_regis": "Deze gegevens worden gebruikt voor toekomstige nalevingsregistratie.",
    "this_is_my_twilio_use_same": "Dit is mijn Twilio, gebruik dezelfde",
    "this_is_visible_to_both_agency_and_location": "Dit is zichtbaar voor zowel het agentschap als de locatie",
    "this_name_will_be_visible_to_leads_chatting_with_y": "Deze naam zal zichtbaar zijn voor leads die met uw bedrijf chatten",
    "this_setting_is_applicable_with_only_team_calendar": "Deze instelling is alleen van toepassing op teamagenda's.",
    "this_stripe_customer_is_already_connected_to_anoth": "Deze Stripe-klant is al verbonden met een ander subaccount.",
    "thu": "Do",
    "tiktok": "Tiktok",
    "time_signed": " Tijd ondertekend: ",
    "time_zone_": "Tijdzone *",
    "timestamp": "Tijdstempel",
    "title": "Titel",
    "to_resolve_this_problem_follow_the": "Om dit probleem op te lossen, volg de ",
    "token": "Token:",
    "total": "Totaal: ",
    "trigger_link": "Triggerlink",
    "triggers": "Triggers",
    "tue": "Di",
    "twilio": "Twilio",
    "twilio_setup_pending": "Twilio-installatie in afwachting",
    "type": "Type",
    "type_campaign_objective": "Type campagnedoelstelling",
    "type_message": "Typ een bericht",
    "unsavedChangesWarning": "Uw wijzigingen worden niet opgeslagen. Weet u zeker dat u wilt afsluiten?",
    "unsaved_changes": "Niet-opgeslagen wijzigingen",
    "unsubscribed": "Afgemeld",
    "unsuccessful": "Mislukt",
    "update_business_profile_details": "Werk de gegevens op het bedrijfsprofiel bij",
    "update_is_inprogress_visit_integrations_page_to_fi": "De update is bezig. Bezoek de integratiepagina om meer te vinden.",
    "update_url": "Werk de URL bij",
    "updated_date": "Datum herziening",
    "updates": " updates",
    "updating": "Updaten...",
    "upgrade_to_agency_pro": "Upgrade naar Agency Pro ",
    "upload": "Uploaden",
    "upload_a_file": "Upload een bestand",
    "usd": " USD",
    "use_this_for_zapier_and_api_integration": "Gebruik dit voor Zapier en API-integraties.",
    "user_email": "E-mailadres gebruiker",
    "user_permissions": "Gebruikersrechten",
    "user_role": "Gebruikersrol",
    "user_type": "Type gebruiker",
    "valid": "Geldig",
    "verification_status": "Verificatiestatus",
    "verify": "Verifiëren",
    "verify_email_using_otp": "E-mail verifiëren met een eenmalig wachtwoord",
    "view_less": " Minder bekijken ",
    "visiblehidden": "Zichtbaar/Verborgen",
    "visit_our_help_center_click_to_open_in_new_tab": "Bezoek ons Helpcentrum - klik om te openen in een nieuw tabblad",
    "voicemail": "Voicemail",
    "wave_integration": "Wave-integratie",
    "we_have_found_some_errors_in_your_contact_fields_c": "We hebben enkele fout(en) gevonden in uw contactvelden. Klik op de map om deze te bekijken en op te lossen.",
    "websites": "Websites",
    "wed": "Wo",
    "welcome_message": "Welkomstbericht",
    "whatsapp": " WhatsApp",
    "whatsapp_icon": "WhatsApp-pictogram",
    "when": "Wanneer",
    "when_selected_calls_will_be_routed_to_your_mobile_": "Wanneer geselecteerd, worden oproepen doorgestuurd naar uw mobiele app. (Ondersteund in zowel iOS als Android)",
    "when_selected_calls_will_be_routed_to_your_web_app": "Wanneer geselecteerd, worden oproepen doorgestuurd naar uw web-app.",
    "which_business_do_you_want_to_link_to_this_locatio": "Welk bedrijf wilt u aan deze locatie koppelen?",
    "widget_code": "Widgetcode",
    "will_give_you_about": " zal u ongeveer geven",
    "wordpress": "WordPress",
    "wordpress_icon": "WordPress-pictogram",
    "workflows": "Workflows",
    "xero_integration": "Xero-integratie",
    "you_need_to_complete_few_easy_steps_to_delete_this": "U moet een paar eenvoudige stappen uitvoeren om deze locatie te verwijderen",
    "you_are_not_authorized_to_perform_this_action_only": "U hebt geen machtiging om deze actie uit te voeren. Alleen beheerders van het agentschap kunnen subaccounts verwijderen.",
    "your_email_cost": "Uw e-mailkosten",
    "your_facebook_page_has_been_integrated_however_the": "Uw Facebookpagina is geïntegreerd. De volgende functies zullen echter niet werken omdat LeadConnector niet over de vereiste machtigingen beschikt: ",
    "your_outlook_connection_has_expired_please_disconn": "Uw Outlook-verbinding is verlopen. Verbreek de verbinding en maak vervolgens opnieuw verbinding met het account om de verbinding tot stand te brengen.",
    "zip_code": "Postcode",
    "zoom_connected_please_close_this_modal": "Zoom verbonden, sluit dit venster",
    "hidden": "Verborgen",
    "messageDetails": "Berichtdetails",
    "openOptions": "Opties openen",
    "progress": "Voortgang",
    "close": "Sluiten",
    "loading": "Aan het laden",
    "fullName": "Volledige naam",
    "languages": "Talen",
    "phoneNumber": "Telefoonnummer",
    "phoneNumberWithCountry": "Telefoonnummer met landcode",
    "sendMessage": "Bericht versturen",
    "services": "Services",
    "servicesProvided": "Aangeboden services",
    "pleaseProvideAValid": "Geef een geldig telefoonnummer op.",
    "copy": "Kopiëren",
    "editApiKey": "API-sleutel bewerken",
    "confirmPay": "Bevestigen en betalen",
    "contactUs": "Contact",
    "decline": "Afwijzen",
    "deleteSubaccount": "Subaccount verwijderen",
    "disabled1": "uitgeschakeld",
    "purchaseSummary": "Samenvatting van de aankoop",
    "subscriptionPlan": "Abonnementsplan",
    "businessName": "Bedrijfsnaam",
    "chooseOne": "Selecteer één optie...",
    "stateProvRegion": "Staat / Provincie / Regio",
    "streetAddress": "Adres",
    "timeZone": "Tijdzone",
    "website": "Website",
    "zipPostalCode": "Postcode",
    "apiKey": "API-sleutel",
    "createdAt": "Aangemaakt op",
    "deleteAllLocationApi": "Alle locatie api-sleutels verwijderen",
    "deleteApiKey": "API-sleutel verwijderen",
    "generatedBy": "Gegenereerd door",
    "lastUsedAt": "Laatst gebruikt op",
    "pageNavigation": "Paginanavigatie",
    "somethingWentWrong": "Er is iets misgegaan!",
    "clickHere": "Klik hier",
    "emailRebillingActive": "Opnieuw factureren via e-mail is actief",
    "saasSubscriptionActive": "Het SaaS-abonnement is actief",
    "scheduledForDeletion": "Ingepland voor verwijdering",
    "twilioRebillingActive": "Opnieuw factureren via Twilio is actief",
    "iAcknowledgeThisIs": "Ik erken dat dit een geldig subaccount is en ik heb het gebruik geverifieerd van het verzenden van meer dan {limit} {type} per dag",
    "iAcknowledgeThisIs1": "Ik erken dat dit een geldig sub-account is en ik heb het gebruik van verzenden geverifieerd, waardoor de sms-limiet is aangepast",
    "emailSentByLocation": "E-mail verzonden per locatie tot nu toe vandaag.",
    "goToSmsLimit": "Ga naar sms-limietinstellingen",
    "toIncreaseTheLimit": "Neem contact op met het ondersteuningsteam om de limiet verder te verhogen.",
    "newLimitOfLimit": "De nieuwe limiet van {limit} is ongeldig. Geef een waarde op tussen {min} en {max}",
    "typeLimitUpdatedSuccessfully": "{type} limiet succesvol bijgewerkt",
    "locationsCurrentLimitIs": "De huidige limiet van de locatie is {current}. U kunt hier alleen de limiet tussen {min} en {max} updaten. Voor elke limietwijziging na {maxAllowed} kunt u contact opnemen met het ondersteuningsteam.",
    "notNow": "Niet nu",
    "smsSentByLocation": "Sms verzonden per locatie tot nu toe vandaag.",
    "youHaveSuccessfullyUpdated": "U heeft de limiet geüpdatet",
    "willAutoUnlockIn": "Wordt automatisch ontgrendeld over",
    "contactType": "Type contactpersoon",
    "createdBy": "Aangemaakt door:",
    "createdOn": "Aangemaakt op:",
    "dateOfBirth": "Geboortedatum",
    "emailAddress": "E-mailadres",
    "firstName": "Voornaam",
    "lastName": "Achternaam",
    "twilioLookupMarkedThis": "Twilio Lookup heeft dit telefoonnummer als ongeldig gemarkeerd.",
    "twilioLookupStatedThis": "Twilio Lookup heeft aangegeven dat dit een {type}-nummer is, en geen sms zal ontvangen.",
    "accountSnapshot": "Account momentopname",
    "auditLogs": "Auditlogboeken",
    "account": "Account",
    "selectAccount": "Selecteer account",
    "facebookUrl": "Facebook-URL",
    "instagram": "Instagram",
    "linkedin": "LinkedIn",
    "twitter": "X (voorheen Twitter)",
    "twitterUrl": "Twitter-URL",
    "youtubeUrl": "YouTube-URL",
    "text": "Tekst",
    "allTagsLinkedTo": "Alle tags die aan de geselecteerde contactpersonen zijn gekoppeld, moeten worden verwijderd",
    "automation": "Automatisering",
    "bulkOperation": "Bulkbewerking",
    "campaign1": "Campagne",
    "created": "Aangemaakt",
    "dateTime": "Datum en tijd",
    "description1": "Beschrijving",
    "drip": "Druppelgewijs",
    "edit": "Bewerken",
    "someStatsAreNot": "Sommige Stats zijn niet beschikbaar als de aanbieder SMTP is. De nauwkeurigheid van de statistieken is afhankelijk van het domein van de ontvanger.",
    "error": "Fout",
    "from1": "Van",
    "immediately": "Onmiddellijk",
    "pause": "Onderbreken",
    "processed": "Verwerkt",
    "queued": "In de wachtrij",
    "restored": "Hersteld",
    "resume": "Hervatten",
    "sent": "Verzonden",
    "scheduled": "Ingepland",
    "success": "Succes",
    "templateName": "Naam van sjabloon",
    "total1": "Totaal",
    "totalAttempted": "Totaal aantal pogingen",
    "user": "Gebruiker",
    "viewDetails": "Details bekijken",
    "workflow": "Workflow",
    "company": "Bedrijf",
    "note": "Notitie",
    "perPage": "per pagina",
    "showing": "Weergeven",
    "task": "Taak",
    "tasks": "Taken",
    "customFields": "Aangepaste velden",
    "dueDate": "Vervaldatum",
    "tryNow": "Probeer het nu!",
    "archive": "Archiveren",
    "markAsRead": "Markeren als gelezen",
    "markAsUnread": "Markeren als ongelezen",
    "youNeedToAdd": "U moet een agenda toevoegen om afspraken te kunnen inplannen.",
    "additionalNotes": "Aanvullende notities",
    "appointmentStatus": "Afspraakstatus",
    "appointmentTitle": "Afspraaknaam",
    "contactName": "Naam contactpersoon",
    "contactTimezoneUsedFor": "Tijdzone contactpersoon (gebruikt voor herinnering)",
    "day": "Dag",
    "editAppointment": "Afspraak wijzigen",
    "nameRequired": "Naam vereist",
    "slotRequired": "Tijdsperiode vereist",
    "teamMemberIsRequired": "Teamlid vereist.",
    "meetingLocation": "Locatie bijeenkomst",
    "pickTeamMember": "Selecteer een teamlid",
    "phoneNumbers": "Telefoonnummers",
    "roundRobin": "Roulatiesysteem",
    "selectCalendar": "Agenda selecteren",
    "selectTeamMember": "Teamlid selecteren",
    "actionRequired": "Actie vereist",
    "scheduleAppointment": "Afspraak inplannen",
    "considerLeavingItBlank": "Als u ervoor kiest om de vooraf geconfigureerde afspraaknaam te gebruiken, kunt u overwegen om deze leeg te laten",
    "assignedTo": "Toegewezen aan",
    "download": "Downloaden",
    "loadingTranscription": "Transcriptie laden...",
    "mute": "Dempen",
    "playpause": "Afspelen/Onderbreken",
    "playbackSpeed": "Afspeelsnelheid",
    "remove": "Verwijderen",
    "stop": "Stop",
    "timePlayedTotalTime": "Gespeelde tijd: totale tijd",
    "viewTranscript": "Transcriptie bekijken",
    "below": "onder",
    "calls1": "Oproepen",
    "liveChat": "Live chat",
    "whatsapp1": "WhatsApp",
    "chatConversationAssigned": "Chatgesprek toegewezen",
    "youAreChoosingNot": "U kiest ervoor om de LC Telefoon-sub-account niet te verwijderen en niet af te sluiten, wat betekent dat u nog steeds voor het gebruik moet betalen, ongeacht of de locatie wel of niet in rekening wordt gebracht.",
    "thingsAreJustGetting": "Dit is enkel het begin, laten we onderzoeken hoe GHL kan helpen met het opbouwen van uw bedrijf.\nOndertussen kunt u naar hartenlust berichten blijven versturen",
    "wohooConversationsAreFlowing": "Yes! De communicatie loopt nu soepel",
    "conversationBegan": "Het gesprek is begonnen",
    "fetchOlderMessages": "Oudere berichten ophalen",
    "inboundDndHasBeen": "Inbound DND actief voor dit contact",
    "internalComment": "Interne opmerking",
    "confirmByTyping": "Bevestig door te typen",
    "iConfirmToDisconnect": "Ik bevestig dat ik de verbinding met het LC Phone-account voor deze locatie wil verbreken en het account wil sluiten. Ik ben me ervan bewust dat dit zou betekenen dat alle nummers en A2P-campagnes worden verwijderd en niet meer kunnen worden hersteld.",
    "iConfirmThatI": "Ik bevestig dat ik dit met mijn cliënt heb besproken en bevoegd ben om deze actie te ondernemen",
    "connect": "Verbinden",
    "disputeThisReview": "Maak bezwaar tegen deze recensie",
    "dndIsActiveFor": "DND actief voor gesprekken",
    "off": "UIT",
    "done": "Voltooid",
    "downloadFile": "Bestand downloaden",
    "AddAccount": "+ Account toevoegen",
    "attachFile": "Bestanden bijvoegen",
    "clickHereToAdd": "Klik hier om er een toe te voegen.",
    "customerName": "Naam klant",
    "customerPhone": "Telefoon van de klant",
    "orEnterAMessage": "Of voer een bericht in",
    "fromEmail": "Van e-mail",
    "fromName": "Van naam",
    "youDontHaveAny": "U heeft nog geen sjablonen.",
    "requestPayment": "Verzoek om betaling",
    "schedule": "Inplannen",
    "selectATemplate": "Selecteer een sjabloon",
    "sendNow": "Nu verzenden",
    "smtpProvidersHasSome": "SMTP-aanbieders hebben enkele beperkingen. Klik hier voor meer info.",
    "subject": "Onderwerp",
    "useATemplateSnippet": "Gebruik een sjabloon (Snippet)",
    "deliveredtotalDelivered": "{delivered}/{total} geleverd",
    "countMoreEmailsIn": "Nog {count} e-mails in de thread",
    "primary": "(Primair)",
    "reply": "Antwoord",
    "respond": "Reageren",
    "retry": "Probeer het opnieuw",
    "to": "Aan:",
    "fbCommentReplyDm": "Antwoord op FB-opmerking - DM",
    "fbMessage": "FB-bericht",
    "theseAttachmentsMayNot": "Deze bijlagen worden mogelijk niet meer ondersteund.",
    "urlCannotBeFound": "De Url kon niet worden gevonden",
    "activity": "Activiteit",
    "filters": "Filters",
    "goToPost": "Ga naar bericht",
    "inboundCall": "Inkomende oproep",
    "instagramDm": "Instagram DM",
    "internalChat": "Interne chat",
    "search2": "Zoeken...",
    "starred": "Met ster",
    "leftAVoicemail": "Heeft een voicemail ingesproken",
    "manual": "Handmatig",
    "mergeFields": "Velden samenvoegen",
    "addToDocuments": "Toevoegen aan documenten",
    "failedToAddAttachments": "Kon de bijlagen niet toevoegen aan de documenten",
    "attachmentsAddedToDocuments": "Bijlagen toegevoegd aan de documenten",
    "newCommentOnPagename": "Nieuwe reactie op {pageName}-bericht.",
    "outboundCall": "Uitgaande oproep",
    "replyAsDm": "Antwoord met DM",
    "replyingAsAPrivate": "Antwoorden als privé-DM is niet beschikbaar voor opmerkingen die ouder zijn dan 7 dagen.",
    "reportFeedbackForAi": "Feedback voor AI indienen",
    "storyMention": "Vermelding van story",
    "storyReply": "Antwoord op story",
    "bulkRequest": "Bulkverzoek",
    "eventsAreCurrentlyCaptured": "Gebeurtenissen worden momenteel alleen vastgelegd voor het e-mailadres van de contactpersoon.",
    "failed": "Mislukt",
    "gbpMessage": "GBP-bericht",
    "pageName": "Paginanaam",
    "unknown": "Onbekend",
    "typeAMessage": "Een bericht typen",
    "new": "Nieuw",
    "newAppointmentBookedBy": "Nieuwe afspraak geboekt door",
    "customerNameRequired": "Klantnaam is vereist",
    "messageIsRequired": "Bericht is vereist",
    "pickATemplateTo": "Kies een sjabloon om te gebruiken.",
    "newMessage": "Nieuw bericht",
    "newTask": "Nieuwe taak",
    "toMakeACall": "Voer een telefoonnummer in dit veld in om te bellen.",
    "primary1": "Primair",
    "provider": "Aanbieder",
    "refresh": "Vernieuwen",
    "resetPassword": "Wachtwoord opnieuw instellen",
    "thisReviewHasAlready": "Deze recensie is al geplaatst op {network}. Weet u zeker dat u deze opnieuw wilt plaatsen?",
    "seeThisReviewOn": "Bekijk deze recensie op GBP",
    "reviewResponse": "Antwoord op recensie",
    "searchUsers": "Zoeken naar gebruikers",
    "sendEmail": "E-mail verzenden",
    "sending": "Verzenden...",
    "thisSubaccountHasPhonenumberco": "Dit subaccount heeft {phoneNumberCount} nummer(s) en {campaignsCount} A2P-campagne(s). Het verwijderen van dit account zal nog steeds kosten met zich meebrengen indien het LC Phone System-account niet wordt losgekoppeld en gesloten.",
    "thisSubaccountDoesNot": "Dit sub-account heeft geen nummer- en A2P-campagnes. Er worden geen kosten in rekening gebracht als u dit account pauzeert, maar we adviseren u om de verbinding met uw LC Phone-account te verbreken en te sluiten.",
    "summary": "Samenvatting",
    "unassigned": "Niet toegewezen",
    "viewSubmission": "Indiening bekijken",
    "contactSupport": "Neem contact op met de ondersteuning",
    "create": "Maken",
    "illDoThisLater": "Ik zal dit later doen",
    "enterBusinessName": "Bedrijfsnaam invoeren",
    "firstNameOfThe": "Voornaam van de eigenaar van het bedrijf",
    "mobileBusinessPhone": "Mobiele / zakelijke telefoon",
    "iDontHaveA": "Ik heb geen website",
    "clientName": "Klantnaam",
    "letUsSetupYour": "Laat ons uw eigen account of uw eerste klant aanmaken",
    "clientNameIsRequired": "Naam klant is vereist",
    "pleaseEnterAValid": "Voer een geldig e-mailadres in",
    "emailAddressIsRequired": "E-mailadres is vereist",
    "firstNameIsRequired": "Voornaam is vereist",
    "lastNameIsRequired": "Achternaam is vereist",
    "phoneNumberIsRequired": "Telefoonnummer is vereist",
    "copyOfName": "Kopie van {name}",
    "goToDashboard": "Ga naar dashboard",
    "permissionsNotEnabled": "Machtigingen zijn niet ingeschakeld!",
    "createAndSellCustom": "Aangepaste producten maken en verkopen met print-on-demand dropshipping",
    "viewApp": "App bekijken",
    "seamlessFulfillmentRealtimeShi": "Naadloze fulfillment- en realtime verzendtarieven voor uw e-commercewinkels",
    "learnMore": "Meer informatie",
    "activateFormMapping": "Formuliertoewijzing activeren",
    "avatarName": "Avatarnaam",
    "formFields": "Formuliervelden",
    "formName": "Naam van het formulier",
    "mapFields": "Folder",
    "update": "Updaten",
    "pauseSubaccount": "Subaccount pauzeren",
    "pausing": "Pauzeren...",
    "subaccount": "subaccount",
    "howItWorks": "Hoe het werkt",
    "uponCompletingThisAction": "Na voltooiing van deze actie wordt het overdrachtsverzoek naar de ontvangende instantie ({relNo}) gestuurd. Het sub-account wordt onmiddellijk overgedragen nadat het is geaccepteerd. Houd er rekening mee dat deze actie niet ongedaan kan worden gemaakt.",
    "ejectSubaccount": "Subaccount verwijderen",
    "newAgencyCreationMail": "E-mail voor het aanmaken van een nieuw agentschap verzonden naar de geselecteerde gebruiker. De gebruiker kan een nieuw agentschap aanmaken door op de link in de e-mail te klikken.",
    "unableToTransferSubaccount": "Subaccount kan niet worden overdragen naar dit agentschap.",
    "nominateAccountOwnerFor": "Accounteigenaar nomineren voor het nieuwe account",
    "pleaseConfirmOwnershipWill": "Bevestig dat het eigendom zal worden overgedragen aan",
    "scheduledDate": "Geplande datum",
    "thisDateIsBased": "Deze datum is gebaseerd op de tijdzone van dit bedrijf, nml. {timezone}",
    "campaignName": "Campagnenaam",
    "copyCampaign": "Campagne kopiëren",
    "endTime": "Eindtijd",
    "event10xEmail4": "Gebeurtenis: 10X e-mail 4 (Vermeldingsdistributie) ",
    "10xEmail1Reviews": "10X E-mail 1 (recensies)",
    "fromAddress": "Van adres",
    "leadValue": "Waarde lead",
    "option1": "Optie 1",
    "option2": "Optie 2",
    "option3": "Optie 3",
    "preview": "Voorbeeldweergave",
    "selectCampaign": "Campagne selecteren",
    "startTime": "Begintijd",
    "time": "Tijd",
    "users": "Gebruikers",
    "noRecordsFound": "Geen gegevens gevonden",
    "pageDetail": "Detail van de pagina",
    "selectAll": "Alles selecteren",
    "submission": "Indiening",
    "addProduct": "Product toevoegen",
    "visitors": "bezoekers",
    "By": " door",
    "conversions": "Conversion Rate ",
    "liveReviews": "Live recensies",
    "liveVisitors": "Live bezoekers",
    "pageVisits": "Paginabezoeken",
    "stream": "Stream",
    "addOneOrMore": "Voeg één of meer pagina-URL's toe of kopieer ze rechtstreeks uit uw webbrowser.",
    "WeWillAutomatically": " We volgen uw websitebezoekers automatisch in realtime. ",
    "connectYourLocationsFacebook": "Verbind het Facebookaccount van uw locatie",
    "connected": "Verbonden!",
    "Contains": " bevat ",
    "expression": "Expressie",
    "facebookAccount": "Facebookaccount",
    "wowYouDontNeed": "Wauw! U hoeft hier niets te configureren, u kunt verdergaan.",
    "Regex": " regex ",
    "selectUrlMatchType": "Selecteer URL-matchtype",
    "Simple": " eenvoudig ",
    "LivePreview": " Live voorbeeldweergave",
    "seconds": "seconden",
    "launch": "Lanceren ",
    "decorativeVector1": "Decoratieve vector 1",
    "showingFromToTo": "Weergeven {from} tot {to} van {total} vermeldingen",
    "cloneProduct": "Product klonen",
    "connectFacebookInstagram": "Facebook en Instagram koppelen",
    "connectPage": "Pagina koppelen!",
    "everythingIn": "Alles in",
    "agentChat25": "Chat met agent (~ 2-5 min. wachttijd)",
    "aiSupportChat": "AI-ondersteuningschat",
    "startChat": "Start de chat",
    "locations1": "locaties",
    "phone1": "telefoon",
    "slack": "Slack",
    "segments1": "segmenten",
    "areYouSureYou": "Weet u zeker dat u deze map wilt verwijderen?",
    "verified": "Geverifieerd",
    "highlevelPrice": "HighLevel-prijs",
    "howDoesItWork": "Hoe werkt het?",
    "payNow": "Nu betalen",
    "priceMustBeMore": "De prijs moet hoger of gelijk zijn aan de HighLevel-prijs",
    "saving2": "Opslaan",
    "yourPrice": "Uw prijs",
    "yourProfit": "Uw winst",
    "youNeedToComplete": "U moet een paar eenvoudige stappen voor naleving voltooien om de SaaS-modus voor deze locatie uit te schakelen",
    "youAreNotAuthorized": "U hebt geen machtiging om deze actie uit te voeren. Alleen beheerders van het agentschap kunnen dit uitvoeren.",
    "disableSaasModeFor": "SaaS-modus uitschakelen voor {name}",
    "companyBilling": "Bedrijfsfacturering",
    "bccEmailsCommaDelimited": "BCC-e-mails (komma-gescheiden)",
    "unableToDeleteMailgun": "Het is niet gelukt om uw Mailgun-account te verwijderen. Neem contact op met support.",
    "forwardingAddress": "Doorstuuradres",
    "forwardingAddressesCommaDelimi": "Doorstuuradressen (door komma's gescheiden)",
    "amount": "Bedrag",
    "billingDate": "Factuurdatum",
    "debugWalletTransactionsTotal": "DEBUG-portemonneetransacties, totaal: {count}",
    "detailedTransactions": "Gedetailleerde transacties",
    "transactionsOnlyAfter26th": "Alleen transacties na 26 april 2022 kunnen worden weergegeven en geëxporteerd",
    "someRecordsMayTake": "Het kan 24 uur duren voordat sommige records hier worden vernieuwd.",
    "totalBalance": "Totaal saldo",
    "walletTransactions": "Transacties portemonnee",
    "walletTransactionsAllDate": "Transacties portemonnee - Alle - {date}",
    "enterMessage": "Bericht invoeren",
    "applyThisChangeTo": "Pas deze wijziging toe op alle subaccounts.",
    "characters": "Tekens",
    "iConfirmThatI1": "Ik bevestig dat ik dit met mijn cliënt heb besproken en dat ik hun goedkeuring heb.",
    "iConfirmThatI2": "Ik bevestig dat ik ervoor zal zorgen dat alle sms-berichten die vanaf dit account worden verzonden, in overeenstemming zijn met het huidige beleid.",
    "theContentsOfThis": "De inhoud van dit bericht zal automatisch worden toegevoegd aan de eerste sms die via bulkberichten wordt verzonden.",
    "iConfirmThatSms": "Ik bevestig dat sms-berichten alleen worden verzonden naar contactpersonen die zich hebben aangemeld voor het ontvangen van sms.",
    "quickTip": "Snelle tip",
    "messageWillBeAppended": "Het bericht wordt toegevoegd aan de eerste sms van een conversie als het geen opt-out taal bevat",
    "readMore": "Lees meer",
    "noncompliantActivityMayLead": "Niet-conforme activiteit kan leiden tot de opschorting van de sms- en spraakgerelateerde eigenschappen van uw account.",
    "typeConfirmBelowTo": "Typ hieronder Bevestigen om door te gaan",
    "products": "Producten",
    "chooseCountry": "Land selecteren...",
    "email2": "E-mail*",
    "firstName1": "Voornaam*",
    "lastName1": "Achternaam*",
    "brandDetails": "Merkgegevens",
    "brandName": "Merknaam*",
    "useEitherLegalName": "Gebruik de juridische naam van de organisatie die de berichten verstuurt, of uw eigen naam als dit merk niet voor een organisatie is.",
    "businessIndustry": "Bedrijfssector*",
    "chooseVertical": "Selecteer verticaal...",
    "mobileNumberForOtp": "Mobiel nummer voor OTP-verificatie (met landcode)*",
    "pleaseProvideAMobile": "Geef een mobiel nummer op waartoe u toegang hebt, zodat u de OTP-verificatie kunt bevestigen. Alleen Amerikaanse/Canadese nummers worden geaccepteerd. U mag geen CPaaS-telefoonnummer gebruiken, zoals een nummer verkregen van LeadConnector. U kunt niet hetzelfde mobiele nummer gebruiken om meer dan 3 Sole Proprietor-merken te registreren. Deze beperking wordt beheerd door TCR.",
    "increasedDeliveryRate": "Verhoogd leveringspercentage",
    "sendUpto3000Segments": "Verzend tot 3000 segmenten per dag",
    "businessDetails": "Bedrijfsgegevens",
    "thereWasSomeIssue": "Er was een probleem bij het indienen van het profiel.",
    "yourProfileSubmissionFailed": "Het indienen van uw profiel is mislukt.",
    "endUserConsent": "Toestemming van de eindgebruiker",
    "minLength40Characters": "Minimale lengte: 40 tekens. Maximale lengte: 2048 tekens.",
    "closeExamples": "Voorbeelden sluiten",
    "sampleMessage1": "Voorbeeldbericht #1*",
    "seeExamples": "Voorbeelden bekijken",
    "enterCampaignDetails": "Campagnegegevens invoeren",
    "youWillReceiveAn": "U ontvangt een OTP-bericht op het door u opgegeven mobiele nummer ter verificatie van TCR. Gelieve binnen 24 uur na ontvangst van de sms met \"Yes\" te reageren.",
    "brandNameIsRequired": "Merknaam is vereist.",
    "businessVerticalIsRequired": "Bedrijfsverticaal is vereist.",
    "mobileNumberIsRequired": "Mobiel nummer is vereist.",
    "hideDetail": "Details verbergen",
    "showDetail": "Details weergeven",
    "people": "mensen",
    "person": "persoon",
    "after": "na",
    "before": "vóór",
    "hour": "uur",
    "hours": "uren",
    "minute": "minuut",
    "minutes": "minuten",
    "triggerLinksEmbeddedIn": "Triggerlinks (ingesloten in bericht) waarop wordt geklikt als % van verzonden berichten",
    "addNewEvent": "Nieuwe gebeurtenis toevoegen",
    "addTask": "Taak toevoegen",
    "manualCall": "Handmatige oproep",
    "manualSms": "Handmatige sms",
    "messenger": "Messenger",
    "wait": "Wacht",
    "webhook": "Webhook",
    "about": "Over",
    "accessRestricted": "Toegang beperkt",
    "addPartner": "Partner toevoegen",
    "addPartnerForm": "Partnerformulier toevoegen",
    "affiliatePortal": "Partnerportaal",
    "badges": "Badges",
    "aBriefBio": "Een korte biografie",
    "dashboard": "Dashboard",
    "experience": "Ervaring",
    "industryServed": "Bediende sector",
    "instagramAccount": "Instagram-account",
    "invoiceHistory": "Factuurgeschiedenis",
    "englishGermanHindi": "Engels, Duits, Hindi",
    "linkToWebsite": "link naar website",
    "linkedinAccount": "LinkedIn-account",
    "locationId": "Locatie-id",
    "partnerName": "Partnernaam",
    "partnerStatus": "Partnerstatus",
    "paymentDetails": "Betalingsgegevens",
    "paymentHistory": "Betalingsgeschiedenis",
    "profilePhoto": "Profielfoto",
    "profilePhotoUrl": "URL profielfoto",
    "promoterReports": "Promotorrapporten",
    "searchPartner": "Partner zoeken",
    "twitterAccount": "X-account (voorheen Twitter)",
    "updatePartner": "Partner updaten",
    "updatePartnerForm": "Partnerformulier updaten",
    "yearOfExperience": "jaar ervaring",
    "youtubeAccount": "YouTube-account",
    "serviceProvided": "Service geleverd",
    "controlTheSubaccountSettings": "Beheer de instellingen van de subaccount",
    "generalInfo": "Algemene informatie",
    "okay": "Oké",
    "proceed": "Doorgaan",
    "addCard": "Kaart toevoegen",
    "makeThisCardPrimary": "Maak deze kaart primair",
    "nameOnCard": "Naam op de kaart",
    "chargedToCustomer": "In rekening gebracht aan de klant:",
    "clientBillingPage": "pagina voor facturering aan klanten",
    "companyStripeIntegrationPage": "Pagina voor Stripe-integratie",
    "enableRebilling": "Opnieuw factureren inschakelen",
    "enabling": "Inschakelen...",
    "forMoreDetails": "voor meer details.",
    "youreOnTheFreelancer": "U hebt het Freelancer-abonnement, waarmee u beperkt bent tot een opslag van 1,05x.",
    "minimumAmountShouldBe": "Het minimale bedrag moet tussen de ${min} en ${max} liggen.",
    "beforeEnablingThisFeature1": "Voordat u deze functie inschakelt, moet u uw Stripe-account koppelen aan de",
    "planToSetYour": "plan om uw marges hoger in te stellen.",
    "rebillAmount": "Bedrag voor opnieuw factureren",
    "supportDoc": "ondersteuningsdocument",
    "10WillGiveYou": "$ 10 geeft u ongeveer",
    "minimumMustBeBetween": "Minimum moet tussen 0,0001 en 0,005 liggen",
    "sorryYouCannotRebillAtTheMarkup": "U kunt helaas niet opnieuw factureren met de opslag van het Freelancer-abonnement,",
    "modifyingTheseSettingsWillChange": "Als u deze instellingen wijzigt, zullen de kosten voor uw klanten veranderen.",
    "pleaseDoNotModifyThese": "Wijzig deze instellingen niet als u niet zeker bent van de gevolgen.",
    "theseSettingsWillApply": "Deze instellingen zijn voortaan van toepassing op uw nieuwe klanten",
    "congratulationsYourDedicatedIp": "Gefeliciteerd! Uw doorverkoop van statische IP's is opgeslagen.",
    "youHaveAgreedToProvide": "U bent akkoord gegaan met het rechtstreeks leveren van statische IP's aan een subaccount. Het agentschap zal de kosten namens de subaccount dekken.",
    "youHaveDiscontinuedToProvide": "U bent gestopt met het rechtstreeks leveren van statische IP's aan een subaccount. Het agentschap zal de kosten niet langer dekken namens de subaccount.",
    "oopsSomethingWentWrongAndWeCouldnt": "Oeps! Er ging iets mis waardoor we uw configuratie voor het doorverkopen van statische IP-adressen niet konden opslaan. Probeer het later opnieuw.",
    "pleaseAgreeToTheTerms": "Gaat u alstublieft akkoord met de voorwaarden",
    "errorWhileFetchingDomains": "Fout tijdens het ophalen van domeinen",
    "sameStripeCustomerProfileCantBeMapped": "Hetzelfde Stripe-klantprofiel kan niet aan meer dan één subaccount worden gekoppeld.",
    "pleasePickADifferentStripeCustomer": "Kies een ander Stripe-klantprofiel of gebruik de optie 'Deel een link', zodat we een nieuw Stripe-klantprofiel voor dit subaccount kunnen aanmaken.",
    "clickNextToChooseAPlan": "Klik op 'Volgende' om een abonnement te kiezen en een nieuwe abonnement aan te maken.",
    "youDontHaveAnyActiveSubscriptions": "U hebt geen actieve abonnementen",
    "youCanEitherSelectAnExistingSubscription": "U kunt een bestaand abonnement selecteren, of in de volgende stap een nieuw abonnement aanmaken.",
    "useCommasToSeparateMultipleEmails": "Gebruik komma's om meerdere e-mailadressen te scheiden.",
    "useCommasToSeparateMultiplePhoneNumbers": "Gebruik komma's om meerdere telefoonnummers te scheiden.",
    "noUserFoundInThisLocation": "Er is geen gebruiker gevonden op deze locatie",
    "noPhoneNumberAttached": "Geen telefoonnummer toegevoegd",
    "pleaseUseTheFollowingLinkToAttachYourPaymentMethod": "Gebruik de volgende link om uw betaalmethode toe te voegen.",
    "allowDuplicateContact": "Dubbele contacten toestaan",
    "allowDuplicateOpportunity": "Dubbele verkoopgelegenheid toestaan",
    "mergeFacebookContactsByName": "Facebook-contacten samenvoegen op naam",
    "onlyIncomingMessagesFromFacebookWillBeMerged": "Alleen inkomende berichten van Facebook worden samengevoegd als ze overeenkomen met de naam van een bestaande contactpersoon. Namen zijn hoofdlettergevoelig.",
    "disableContactTimezone": "Tijdzone van contactpersoon uitschakelen",
    "markEmailsAsInvalidDueToHardBounce": "E-mails als ongeldig markeren vanwege een harde bounce",
    "contactsEmailsWillBeMarkedAsInvalid": "E-mails van contactpersonen worden automatisch als vervallen gemarkeerd wanneer ze hard bouncen. E-mailacties in automatiseringen worden overgeslagen voor contactpersonen met ongeldige e-mailadressen.",
    "gatherIntelligenceOnUnknownPhoneNumbers": "Verzamel inlichtingen over onbekende telefoonnummers",
    "makeSmsCompliantByAddingAnOptOutMessage": "Maak SMS conform door een afmeldbericht toe te voegen.",
    "ifActivatedTheOptOutMessageWillBeAutomaticallyAdded": "Indien geactiveerd, wordt het opt-out-bericht automatisch toegevoegd aan de eerste sms die via bulkberichten wordt verzonden om naleving te garanderen en de bezorgingspercentages te verhogen.",
    "platformLanguage": "Taal platform",
    "outboundCommunicationLanguageForCustomValues": "Taal voor uitgaande communicatie voor aangepaste waarden",
    "updateInformation": "Informatie bijwerken",
    "upgradeToTheAgency": "Upgraden naar Agency Pro",
    "yourCost": "Uw prijs",
    "addACalendarTo": "Voeg een agenda toe om afspraken te maken.",
    "addselectAContactTo": "Voeg een contactpersoon toe/selecteer een contactpersoon om afspraken te plannen",
    "appointmentSlotIsNot": "Afspraaktijd is nog niet gekozen",
    "loading1": "Aan het laden . . .",
    "teamMemberIsRequired1": "Teamlid is vereist",
    "currentPlan": "Huidig plan",
    "features1": "Eigenschappen",
    "upgrade": "Upgraden",
    "viewLess": "Minder bekijken",
    "viewMoreCount": "Meer weergeven (+{count})",
    "cardNumber": "Kaartnummer",
    "expiryDate": "Vervaldatum",
    "paymentMethods": "Betaalmethoden",
    "primaryCard": "Primaire kaart",
    "removeCurrentCard": "Huidige kaart verwijderen",
    "AddBalance": "+ Saldo toevoegen",
    "complimentaryCredits": "Gratis tegoed:",
    "expiringOnDate": "Verloopt op {date}",
    "apiVersion": "API-versie",
    "application": "Applicatie",
    "ipAddress": "IP-adres",
    "related": "Gerelateerd",
    "request": "Verzoek",
    "yourAccountIncludingAll": "Uw account, inclusief alle uitgaande activiteiten zoals geplande berichten en e-mails, wordt onmiddellijk stopgezet.",
    "yourAccountIncludingAll1": "Uw account, inclusief alle uitgaande activiteiten zoals geplande berichten en e-mails, wordt onmiddellijk stopgezet.",
    "nextBillingDateDate": "Volgende factuurdatum: {date}",
    "scheduledForCancellation": "Ingepland om te worden geannuleerd",
    "abandoned": "Verlaten",
    "add1": "Toevoegen",
    "addOpportunity": "Lead toevoegen --",
    "addOpportunityName": "Voeg de naam van de lead toe",
    "Task": "+ Taak",
    "bookupdateAppointment": "Afspraak boeken/vernieuwen",
    "companyName": "Bedrijfsnaam",
    "areYouSureYou1": "Weet u zeker dat u deze lead wilt verwijderen?",
    "contactInfo": "Contactgegevens",
    "editOpportunity": "Lead bewerken --",
    "enterValue": "Waarde invoeren",
    "goToContactDetail": "Ga naar de pagina Contactgegevens",
    "leads": "Leads",
    "lost": "Verloren",
    "nameIsRequired": "Naam is vereist.",
    "youreNotAllowedTo": "U mag de klantnaam niet wijzigen! Controleer uw machtigingen bij de beheerder van het agentschap.",
    "open": "Open",
    "opportunity": "Lead",
    "opportunityAlreadyExistsIn": "Lead bestaat al in deze pijplijn",
    "opportunityInfo": "Info lead",
    "opportunityName": "Naam lead",
    "opportunitySource": "Bron lead",
    "owner": "Eigenaar",
    "pipeline": "Pijplijn",
    "removeOwner": "Eigenaar verwijderen",
    "selectPipeline": "Pijplijn selecteren",
    "selectStage": "Fase selecteren",
    "stage": "Stadium",
    "countTasks": "{count} taken",
    "won": "Gewonnen",
    "and": "en ",
    "addASubscription": "Voeg een abonnement toe",
    "noSaasPlanEnabled": "Geen SaaS-plan ingeschakeld",
    "per": "per",
    "assignTo": "Toewijzen aan",
    "assignedTo1": "Toegewezen aan:",
    "areYouSureYou2": "Weet u zeker dat u deze taak wilt verwijderen?",
    "due": "Vervaldatum:",
    "dueDateIsRequired": "Vervaldatum is vereist",
    "dueIn": "Verschuldigd in",
    "dueToday": "Vandaag verschuldigd",
    "late": "Te laat",
    "notAssigned": "Niet toegewezen",
    "taskDescription": "Taakbeschrijving",
    "taskTitle": "Titel van de taak",
    "annually": "jaarlijks",
    "attachments": "Bijlage(n)",
    "areYouSureYou3": "Weet u zeker dat u dit bulkverzoek wilt verwijderen?",
    "startImmediately": "Begin onmiddellijk",
    "customers": "Klanten",
    "tag": "Tag",
    "pickType": "Type selecteren",
    "whoShouldItRun": "Voor wie moet dit worden uitgevoerd?",
    "addBulkRequest": "Bulkverzoek toevoegen",
    "editBulkRequest": "Bulkverzoek bewerken",
    "scheduledDateIsRequired": "Geplande datum is vereist",
    "newCampaignName": "Nieuwe campagnenaam",
    "areYouSureYou4": "Weet u zeker dat u deze campagne wilt verwijderen?",
    "moveToFolder": "Verplaatsen naar map",
    "pleaseRename": "Naam wijzigen",
    "removeFromFolder": "Verwijderen uit map",
    "photoPreview": "foto voorbeeldweergave",
    "pleaseWait": "Een ogenblik geduld...",
    "customValues": "Aangepaste waarden",
    "whatActionShouldWe": "Welke actie moeten we uitvoeren?",
    "entitynameName": "{entityName} naam",
    "useLcEmail": "Gebruik LC Email",
    "21Jun2018": "21-06-2018",
    "930Am": "09.30",
    "Via": " via ",
    "createdTrackingNumbers": "Aangemaakte trackingnummers",
    "iUnderstandImBuyingadding": "Ik begrijp dat ik {count} nieuwe telefoonnummers koop/toevoeg.",
    "forwardCallsTo": "Oproepen doorschakelen naar",
    "numberName": "Nummer naam",
    "numberPoolName": "Naam nummerpool",
    "numberToSwap": "Nummer om om te wisselen",
    "sameAsForwardingNumber": "Hetzelfde als het doorsturen van het nummer",
    "callFromSource": "Bellen met [Source]",
    "callRecording": "Gespreksopname",
    "84Complete": "84% voltooid",
    "thisCallWillBe": "Dit gesprek zal worden opgenomen voor kwaliteitsdoeleinden.",
    "whisperMessage": "Fluisterbericht",
    "allExceptDirect": "Alle behalve Direct",
    "allExceptDirectOrganic": "Alle behalve Direct en Organisch",
    "allSearch": "Alle zoekopdrachten",
    "allVisitorsRecommended": "Alle bezoekers (aanbevolen)",
    "bing": "Bing",
    "direct": "Direct",
    "visitorsWithoutAReferring": "Bezoekers zonder verwijzende website",
    "for": "voor",
    "google": "Google",
    "landingPageOrUrl": "Landingspagina of URL-parameter",
    "organic": "Organisch",
    "paid": "Betaald",
    "pickOneYouCan": "Kies één optie - u kunt dit later wijzigen.",
    "ppcSearch": "PPC-zoeken",
    "visitorsFromGoogleBing": "Bezoekers Van Google, Bing en Yahoo PPC zoeken",
    "referringPage": "Verwijzende pagina",
    "visitorsFrom": "Bezoekers van",
    "visitorsFromGoogleAds": "Bezoekers van Google Ads",
    "visitorsWhoAreReferred": "Bezoekers die worden doorverwezen van",
    "visitorsWhoLandOn": "Bezoekers die terechtkomen op",
    "whichVisitorsDoYou": "Welke bezoekers wilt u volgen?",
    "yahoo": "Yahoo",
    "17Complete": "17% voltooid",
    "callTimeoutS": "Time-out gesprek(ken)",
    "callWhisper": "Fluistergesprek",
    "disableVoicemailDetect": "Schakel voicemaildetectie uit",
    "eventName": "Naam gebeurtenis",
    "timeoutSeconds": "Timeout (seconden)",
    "editCall": "Gesprek bewerken",
    "callWillPatchInstantly": "Het gesprek wordt direct gepatcht, we zullen niet luisteren of de voicemail aan de kant van de leads is opgepikt. Dit betekent dat de campagne als beantwoord wordt gemarkeerd, zelfs als de voicemail wordt opgepikt.",
    "thisIsTheMessage": "Dit is het bericht dat u wilt dat de persoon die de telefoon opneemt te horen krijgt, u kunt aangepaste variabelen gebruiken om dit aan te passen.",
    "pleaseCheckTheLinks": "Controleer de links met een aangepaste waarde. Er is een extra '%20' tussen de {{ en de custom_values.",
    "anErrorOcurredPlease": "Er is een fout opgetreden. Opnieuw proberen.",
    "pleaseInsertATo": "Voer een afleveradres in.",
    "pickEmailTemplate": "E-mailsjabloon selecteren",
    "sendTest": "Test verzenden",
    "composeEmail": "E-mail opstellen",
    "composeEmailTemplate": "E-mailsjabloon opstellen",
    "toAddress": "Naar adres",
    "addFileThroughUrl": "Document toevoegen via URL",
    "appCharacters": "App-tekens:",
    "approximateCost": "Geschatte prijs:",
    "estimatedCostForUs": "Geschatte kosten alleen voor sms-berichten van de VS naar de VS.",
    "mobilePhoneNumber": "Mobiel telefoonnummer",
    "numSegments": "Num. segmenten",
    "pickMessageTemplate": "Kies een berichtsjabloon",
    "pleaseProvideAPhone": "Geef een telefoonnummer op om de test naar toe te sturen.",
    "composeEventtype": "{eventType} opstellen",
    "composeEventtypeTextTemplate": "Tekstsjabloon voor {eventType} opstellen",
    "unsupportedSmsContentType": "Niet-ondersteund sms-inhoudstype {fileType}",
    "countOfTheProvided": "{count} van de uitgegeven URL-bijlagen {plural} zijn geen afbeelding. Dit kan fouten in Twilio veroorzaken. Wilt u toch opslaan?",
    "dropFileHereOr": "Sleep het bestand hierheen of klik om te uploaden",
    "ifYouHaveAdditional": "Raadpleeg bij verdere vragen de FAQ over Voicemail Drop in de helpsectie.",
    "editVoicemail": "Voicemail bewerken",
    "selectAMp3Or": "Selecteer een mp3- of wav-bestand, we ondersteunen geen andere indelingen.",
    "voicemailFile": "Voicemailbestand",
    "warningVoicemailDropsAre": "Voicemailberichten werken volgens een systeem dat in ongeveer 70% van de gevallen succesvol is.",
    "youNeedToPick": "U moet minstens 1 dag selecteren",
    "editWait": "Wachttijd bewerken",
    "url": "URL",
    "customTime": "Aangepast tijd",
    "executeThisActionIf": "Voer deze actie uit als de huidige tijd in dit venster valt, als de huidige tijd buiten dit venster valt, sla deze stap dan over en ga door naar de volgende actie.",
    "pickDays": "Dagen selecteren",
    "pickTime": "Tijd selecteren",
    "noRecordsFound1": "Geen records gevonden.",
    "formAnalyze": "Formulier analyseren",
    "totalSubmission": "Totaal aantal inzendingen",
    "forgotPassword": "Wachtwoord vergeten?",
    "orContinueWith": "Of ga door met",
    "signIn": "Aanmelden",
    "signIntoYourAccount": "Log in op uw account",
    "thePasswordYouPicked": "Het door u geselecteerde wachtwoord",
    "yourEmailAddress": "Uw e-mailadres",
    "newEmailFrom": "Nieuwe e-mail van",
    "newMessageFrom": "Nieuw bericht van",
    "hasLeftANew": "heeft een nieuwe recensie achtergelaten.",
    "repliedToTheReview": "heeft op de recensie geantwoord.",
    "loaded": "Geladen",
    "snapshot": "Snapshot",
    "appointment": "Afspraak",
    "appointmentDueInMinutes": "Afspraak over {minutes} min. voor {contactName}",
    "appointmentReminder": "Afspraakherinnering",
    "completedCount": "Voltooid: {count}",
    "conversation": "Gesprek",
    "facebookReview": "Facebookrecensie",
    "failedCount": "Mislukt: {count}",
    "googleReview": "Google-recensie",
    "internalChatMessage": "Intern chatbericht",
    "usernameMentionedYouIn": "{userName} heeft u vermeld in een gesprek met {contactName}",
    "newAppointmentAssigned": "Nieuwe afspraak toegewezen",
    "aNewAppointmentWith": "Er is een nieuwe afspraak met {contactName} aan u toegewezen.",
    "newAppointmentBooked": "Nieuwe afspraak geboekt",
    "youHaveNewAppointment": "U heeft een nieuwe afspraak geboekt met {contactName}",
    "newCall": "Nieuw gesprek",
    "aNewChatWith": "Er is een nieuwe chat met {contactName} aan u toegewezen.",
    "newEmail": "Nieuwe e-mail",
    "newMention": "Nieuwe vermelding",
    "newReviewReceivedFrom": "Nieuwe recensie ontvangen van {contactName}",
    "aNewTypeIs": "Er is een nieuw {type} ontvangen van {contactName}",
    "notification": {
      "noRecentActivity": "Geen recente activiteit"
    },
    "subAccount": "Subaccount",
    "subaccount1": "Subaccount:",
    "titleOnDateAt": "{title} op {date} om {time} voor {contactName}",
    "titleDueInDuetime": "{title} verschuldigd in {dueTime} {unitOfTime} voor {contactName}",
    "taskReminder": "Herinnering taak",
    "youHaveCountTasks": "U hebt {count} taken die vandaag moeten worden voltooid",
    "youHaveCountTasks1": "U hebt {count} taken die momenteel achterstallig zijn",
    "droppedVoicemailTo": "Voicemail achtergelaten bij",
    "errorWhileCloningProduct": "Fout bij het klonen van het product!",
    "productName": "Productnaam",
    "selectLocations": "Selecteer locaties",
    "selectUptoMaxselectablelocatio": "Selecteer maximaal {maxSelectableLocations} locaties",
    "highlevelInc": "HighLevel Inc.",
    "CountMore": "+ {count} meer",
    "emails": "E-mails",
    "accountNotification": "Accountnotificatie",
    "customerCare": "Klantenservice",
    "deliveryNotification": "Afleveringsnotificatie",
    "fraudAlertMessaging": "Waarschuwingsberichten fraude",
    "higherEducation": "Hoger onderwijs",
    "lowVolumeMixedRecommended": "Laag volume gemengd (aanbevolen)",
    "mixed": "Gemengd",
    "pollingAndVoting": "Peilingen en stemmen",
    "publicServiceAnnouncement": "Publieke dienstmededeling",
    "securityAlert": "Beveiligingswaarschuwing",
    "mixedRecommended": "Gemengd (Aanbevolen)",
    "australiaCompanyNumberFrom": "Australië: Bedrijfsnummer van ASIC (ACN)",
    "canadaCanadianBusinessNumber": "Canada: Canadees Bedrijfsnummer (CBN)",
    "indiaCorporateIdentityNumber": "India: Bedrijfsidentificatienummer",
    "greatBritainCompanyNumber": "Groot-Brittannië: Bedrijfnummer",
    "usaEmployerIdentificationNumbe": "VS: Identificatienummer werkgever (EIN)",
    "other": "Anders",
    "israelRegistrationNumber": "Israël: Registratienummer",
    "estoniaVatNumber": "Estland: Btw-nummer",
    "cooperative": "Coöperatief",
    "corporation": "Bedrijf",
    "limitedLiabilityCompanyOr": "Vennootschap met beperkte aansprakelijkheid of eenmanszaak",
    "nonprofitCorporation": "Bedrijf zonder winstoogmerk",
    "partnership": "Partnerschap",
    "ceo": "CEO",
    "cfo": "CFO",
    "director": "Directeur",
    "generalCounsel": "Algemeen adviseur",
    "onlineTrainingEducation": "Online cursussen en onderwijs",
    "financialServices": "Financiële dienstverlening",
    "fitnessLifestyle": "Fitness en lifestyle",
    "healthMedical": "Gezondheid en medisch",
    "homeServices": "Diensten aan huis",
    "legalServices": "Juridische diensten",
    "marketingAdvertising": "Marketing",
    "others": "Overige",
    "realEstate": "Onroerend goed",
    "restaurants": "Restaurants",
    "retailEcommerce": "Detailhandel en e-commerce",
    "yourInformationHasBeen": "Uw informatie is ingediend.",
    "somethingWentWrong1": "Er ging iets mis",
    "newPassword": "Nieuw wachtwoord",
    "proceedToLogin": "Doorgaan naar inloggen",
    "anyTime": "elk moment.",
    "callUsHighlevelSupport": "Bel de ondersteuning van HighLevel op",
    "troubleLoggingIn": "Problemen met inloggen?",
    "sendSecurityCode": "Beveiligingscode verzenden",
    "sendCodeToEmail": "Stuur code naar e-mail",
    "verifySecurityCode": "Beveiligingscode verifiëren",
    "privacyPolicy": "Privacybeleid",
    "businessProfile": "Bedrijfsprofiel",
    "reserveWithGoogleIntegration": "Reserveren met Google-integratie",
    "friendlyName": "Beschrijvende naam",
    "updateCallerId": "Beller-ID updaten",
    "internationalFormat": "Internationale indeling",
    "localFormat": "Lokale indeling",
    "poolNumbers": "Poolnummers",
    "swappingNumbers": "Nummers wisselen",
    "selectField": "Selecteerveld",
    "surveyAnalyze": "Enquête analyseren",
    "locationIsRequired": "Locatie is vereist.",
    "newSurveyName": "Nieuwe enquêtenaam",
    "copySurvey": "Kopieer enquête",
    "primaryCalendar": "Primaire agenda",
    "cloneEntityname": "{entityName} klonen",
    "youHaveSuccessfullySubmitted": "U hebt de documenten ingediend",
    "addCustomValue": "Aangepaste waarde toevoegen",
    "value": "Waarde",
    "youHaveSuccessfullyDeleted": "U hebt het pakket verwijderd.",
    "bundleDeletedSuccessfully": "Bundel verwijderd",
    "thereIsAnIssue": "Er is een probleem met een van uw ondersteunende documenten. Controleer de ondersteunende documenten en de reden(en) voor afwijzing.",
    "connect1": "Verbinden!",
    "itSeemsEitherThe": "Het lijkt erop dat de Google-verbinding is verbroken of dat deze niet is verbonden op de huidige locatie. Controleer de integratie-instellingen en integreer opnieuw als de verbinding al bestaat.",
    "selectPage": "Selecteer een pagina",
    "somethingWentWrongPlease": "er ging iets mis, probeer het opnieuw",
    "accept": "Accepteren",
    "moreThan1Phone": "Meer dan 1 telefoonnummer toegestaan",
    "byContinuingToUse": "Door het HighLevel-platform te blijven gebruiken, gaat u akkoord met deze nieuwe {termsLink} en {privacyLink}.",
    "byContinuingToUse1": "Door het HighLevel-platform te blijven gebruiken, gaat u akkoord met deze nieuwe",
    "termsOfService": "Servicevoorwaarden",
    "weHaveUpdatedOur": "We hebben onze Servicevoorwaarden en Privacyverklaring bijgewerkt. Neem ze zeker even door!",
    "newTriggerName": "Nieuwe triggernaam",
    "triggerName": "Naam trigger",
    "disableDndForSpecific": "Niet storen uitschakelen voor specifieke kanalen",
    "selectAdAccount": "Advertentieaccount selecteren",
    "selectAppointmentStatus": "Afspraakstatus selecteren",
    "below1": "onder.",
    "Required": "* vereist",
    "whenYouGetA": "Wanneer u een nieuwe recensie ontvangt, plaatsen we deze automatisch op uw Facebookpagina. Onthoud dat de beste praktijk is om niet meer dan 3 recensies per dag op uw account te plaatsen.",
    "skip": "Overslaan",
    "copyShareLink": "Deellink kopiëren",
    "agencyRelationshipNumbers": "Relatienummers van agentschap",
    "alteast1AgencyRelationship": "Minimaal 1 relatienummer agentschap vereist.",
    "alteast1SubaccountId": "Ten minste 1 subaccount-ID is vereist.",
    "somethingWentWrongWhile": "Er is iets misgegaan bij het opslaan. Probeer het later opnieuw!",
    "5PerPage": "5 per pagina",
    "10PerPage": "10 per pagina",
    "amountMustGreaterOr": "Aantal moet groter of gelijk zijn aan 1 dollar AUD.",
    "regions": {
      "africa": "Afrika",
      "asia_pacific": "Azië / Stille Oceaan",
      "europe": "Europa",
      "latin_america": "Latijns-Amerika",
      "usa_and_canada": "Verenigde Staten en Canada",
      "asia": "Azië",
      "latinAmerica": "Latijns-Amerika",
      "usaCanada": "Verenigde Staten en Canada"
    },
    "expandIcon": "►",
    "noEntriesToShow": "Er zijn geen vermeldingen om te tonen",
    "clear": "Wissen",
    "filter": "Filteren",
    "test": "Test",
    "createNewTwilioSubAccountText": "U moet een nieuw Twilio-account aanmaken, de inloggegevens voor dit account bijwerken onder de Twilio-instellingen en telefoonnummers verplaatsen voordat u herfacturering kunt inschakelen.",
    "viewing": "Bekijken",
    "makeSmsCompliantByAddingASenderInformation": "Maak dit SMS-compliant door afzenderinformatie toe te voegen.",
    "makeEmailCompliantByAddingAnUnsubscribeLinkInYourEmail": "Maak e-mail compliant door een afmeldlink toe te voegen in uw e-mail",
    "enableMissedCallTextBack": "Sms terugsturen inschakelen voor gemiste oproepen",
    "productInventory": "Productinventaris",
    "viewProductVariants": "Bekijk de productvarianten",
    "smtpSettings": "SMTP-instellingen",
    "locationOPMTrafficStatis": "Locatie OPM Verkeersstatistieken",
    "locationGPMTrafficStatis": "Locatie GPM Verkeersstatistieken",
    "blacklistMonitorReports": "Rapporten zwarte lijstmonitoring",
    "twoFactorAuthentication": "Tweefactorauthenticatie (2FA)",
    "recent": "Recent",
    "noPermission": "U heeft geen toestemming om de sjablonen voor dit product te beheren. Doorverwijzing naar dashboard.",
    "tasksNowHave": "Taken hebben nu",
    "option": "Optie",
    "facebookAdsReporting": "Rapportage Facebook-advertenties",
    "googleAdsReporting": "Google Ads-rapportage",
    "adsDatePicker": "Ads datumkiezer",
    "feedbackSubmitBtn": "Feedback Verzenden Knop",
    "ifYouThinkMistakePleaseContact": "Als u denkt dat dit een fout is, neem dan contact op met",
    "forResolution": "voor resolutie.",
    "live": "Live",
    "payouts": "Uitbetalingen",
    "greatChoice": "Goede keuze!",
    "toNavigate": "navigeren",
    "teams": "Teams",
    "role": "Rol",
    "searchAccounts": "Accounts zoeken",
    "searchByNameEmailPhone": "Zoeken op naam, e-mail of telefoonnummer",
    "addEmployee": "Medewerker toevoegen",
    "removeFromLocation": "Verwijderen uit locatie",
    "knowMore": "Meer info",
    "usingNumberPool": "Nummerpool gebruiken",
    "numbers": {
      "zero": "0",
      "one": "1"
    },
    "multiplier": "x",
    "reviewer": "Recensent",
    "cancel1": "Annuleren",
    "delete1": "Verwijderen",
    "call1": "Oproep",
    "message1": "Bericht",
    "name1": "Naam",
    "voicemail1": "Voicemail",
    "title1": "Titel",
    "choose_one": "Selecteer één optie",
    "select_page": "Pagina selecteren",
    "confirm1": "Bevestigen",
    "conversations1": "Gesprekken",
    "copied1": "Gekopieerd",
    "timeOfDay": {
      "am": "AM",
      "pm": "PM"
    },
    "back1": "Terug",
    "details1": "Details",
    "month1": "/maand",
    "select1": "Selecteren",
    "share1": "Delen",
    "facebook1": "Facebook",
    "sidebar": {
      "blacklistMonitorReports": "Rapporten zwarte lijstmonitoring",
      "domainPurchase": "Aankoop van een domein"
    },
    "confirmDelete": "Weet u zeker dat u {name} wilt verwijderen?",
    "clicked1": "Geklikt",
    "delivered1": "Afgeleverd",
    "invalid1": "Ongeldig",
    "open_options": "Opties openen",
    "_add_account": "Account toevoegen",
    "setTimezoneWarning": "Stel de tijdzone in voor uw locatie om de juiste vrije tijdvakken te krijgen.",
    "save1": "Opslaan",
    "action1": "Actie",
    "actions1": "Acties",
    "all1": "Alle",
    "previous1": "Vorige",
    "results1": "Resultaten",
    "next1": "Volgende",
    "payments1": "Betalingen",
    "settings1": "Instellingen",
    "total_js_heap": "Totale JS-heap",
    "table": {
      "pagination": {
        "previous": "Vorige",
        "next": "Volgende"
      },
      "rowsSelected": "{count} rijen geselecteerd",
      "cantRearrange": "{type} kan niet opnieuw worden ingedeeld"
    },
    "ivrCall": "IVR-oproep",
    "sms": "Sms",
    "username": "Gebruikersnaam",
    "stay": "Blijven",
    "placeholders": {
      "selectCountry": "Selecteer uw land",
      "nameOfBusiness": "Bedrijfsnaam",
      "line1": "Regel 1",
      "line2": "Regel 2",
      "enterState": "Provincie invoeren",
      "enterCity": "Stad invoeren",
      "enterPostalCode": "Postcode invoeren",
      "chooseCountry": "Selecteer een land..."
    },
    "addressLine1": "Adresregel 1",
    "addressLine2": "Adresregel 2",
    "postalCode": "Postcode",
    "nameOfBusiness": "Bedrijfsnaam",
    "dispute_this_review": "Maak bezwaar tegen deze recensie",
    "story_mention": "Storyvermelding",
    "story_reply": "Antwoord op story",
    "no": "Nee",
    "yes": "Ja",
    "annual": "jaarlijks",
    "plan": "Plan",
    "errors": {
      "somethingWrong": "Er ging iets mis"
    },
    "zero": "0",
    "perMonth": "per maand",
    "emailCheckLinks": "Controleer de links waar u een aangepaste waarde heeft. Er bevindt zich een extra \"%20\" tussen de {{ en de custom_values.",
    "fileSizeTooLarge": "De bestandsgrootte is groter dan 5 MB",
    "fileSizeTooLargeDescription": "Het bestand dat u probeert te uploaden is te groot. Probeer het met een kleiner bestand.",
    "minMaxLength40Characters2048Characters": "Minimale lengte: 40 tekens. Maximale lengte: 2048 tekens.",
    "sampleMessage2": "Voorbeeldbericht #2*",
    "pleaseSelectWorkflow": "Selecteer een workflow",
    "childrens": "Kinderen",
    "brandAndCampaignRegistration": "Er wordt eenmalig $ 20,95 in rekening gebracht voor de registratie van het merk en de campagne. Er geldt een extra campagnevergoeding van maximaal $ 2,25 per maand in overeenstemming met de TCR-regels.",
    "einRequiredForRegistration": "EIN vereist voor registratie",
    "changed_props": "Gewijzigde props",
    "total_memory": "Totaal geheugen",
    "total_store_size": "Totale winkeloppervlakte",
    "total_watchers": "Totaal aantal volgers",
    "update_count": "Aantal bijwerken"
  },
  "contacts": {
    "bulkRequests": {
      "bulkActions": "Bulkacties",
      "clickHere": "Klik hier om de lijst met bulkactiviteiten te bekijken.",
      "mergedMessage": "Deze pagina is samengevoegd met de lijst met bulkactiviteiten.",
      "title": "Contactverzoeken"
    }
  },
  "conversations": {
    "noConversationsFound": "Geen {status} gesprekken gevonden",
    "create_new": "Maak een nieuw bericht aan​",
    "validations": {
      "minCharsRequired": "Minimaal 3 tekens vereist",
      "twoMoreCharsRequired": "2 extra tekens vereist",
      "oneMoreCharRequired": "Nog 1 teken vereist"
    },
    "sortLabels": {
      "latestAllMessages": "Nieuwste - Alle berichten",
      "oldestAllMessages": "Oudste - Alle berichten",
      "latestManualMessages": "Nieuwste - Handmatige berichten",
      "oldestManualMessages": "Oudste - Handmatige berichten",
      "latestAll": "Laatste-Alles",
      "oldestAll": "Oudste-Alles",
      "latestManual": "Nieuwste-Handmatig",
      "oldestManual": "Oudste-Handmatig",
      "highToLow": "{name} (hoog naar laag)",
      "manualMessagesTooltip": "De sorteeroptie is van toepassing op berichten na 18 mei 2023."
    },
    "deleteConversation": {
      "title": "Bevestiging",
      "confirmWithName": "Weet u zeker dat u het gesprek met {name} voorgoed wilt verwijderen? Dit kan niet ongedaan worden gemaakt.",
      "confirmWithoutName": "Weet u zeker dat u dit gesprek voorgoed wilt verwijderen? Dit kan niet ongedaan worden gemaakt."
    },
    "makeCall": {
      "enterPhoneNumber": "Voer een telefoonnummer in dit veld in om te bellen.",
      "invalidPhoneNumber": "Twilio Lookup heeft dit telefoonnummer als ongeldig gemarkeerd."
    },
    "actions": {
      "markAsStarred": "Markeer als Met ster",
      "unarchive": "Uit het archief halen",
      "unmarkAsStarred": "Markering Met ster ongedaan maken"
    },
    "send": {
      "perMonthPerIp": "/ Maand / IP",
      "perIp": "/ IP",
      "replyingTo": "Beantwoorden aan",
      "requestClientsPaymentDetails": "Betalingsgegevens van de klant opvragen",
      "saasModeCreditCardRequired": "Voor de SaaS-modus is een geregistreerde creditcard van de klant vereist.",
      "please": "Ga",
      "firstBeforeEnablingSaaS": "eerst voordat u de SaaS-modus inschakelt.",
      "shareALink": "Deel een link",
      "shareLinkInstructions": "Deel een link met uw klant om hun betaalgegevens te verzamelen.",
      "requestViaEmail": "Verzoek via e-mail",
      "twilioRebillingDescription": "Factureer de kosten van Twilio ({twilioCopy}) aan uw klanten en voeg een toeslag toe",
      "seeHow": "Bekijk hoe",
      "phoneRebillingCardInfoRequired": "Voor telefonische herfacturering zijn de kaartgegevens van de klant vereist.",
      "clientsCompanyBillingPage": "factureringspagina van het bedrijf van de klant",
      "ifYouPayForTwilioKeepUsing": "Blijf hetzelfde Twilio-account gebruiken als u voor Twilio betaalt",
      "ifClientPaysForTwilioCreateNew": "Maak een nieuw Twilio-account aan als de klant voor Twilio betaalt",
      "learnHow": "Leer hoe",
      "createNewTwilioAccountInstructions": "Maak een nieuw Twilio-account aan voor deze locatie",
      "learnHowToMovePhoneNumbers": "Leer hoe u telefoonnummers kunt verplaatsen",
      "thisIsMyClientsTwilioCreateNew": "Dit is de Twilio van mijn klant, maak een nieuw account aan",
      "featureUnderDevelopment": "Deze functie is in ontwikkeling",
      "emailRebillingDescription": "Reken de e-mailkosten aan uw klanten door en voeg een toeslag toe",
      "emailRebillingCardInfoRequired": "Voor herfacturering er e-mail is de kaartinformatie van de klant vereist.",
      "emailRebillingMarginsDescription": "Dit zijn marges die aan uw klanten worden gefactureerd bovenop de kosten voor e-mail.",
      "provider": "Aanbieder",
      "morePlanCustomizationsAvailable": "Meer aanpassingen voor het plan beschikbaar",
      "plansAndPricing": "Plannen en prijzen",
      "connectYourStripeAccountFirst": "Verbind eerst uw Stripe-account",
      "createRecommendedPlansOnStripe": "Aanbevolen plannen aanmaken op Stripe",
      "createdPlanInStripe": "Plan aangemaakt in Stripe",
      "customizeYourSaasPlans": "Pas uw SaaS-plannen aan",
      "youCanOfferRecommendedPlansOrBuildYourOwn": "U kunt aanbevolen plannen aanbieden of uw eigen plannen samenstellen",
      "trialPeriod": "Proefperiode",
      "enterNumberOfDaysForTrial": "Voer het aantal dagen voor de proefperiode in",
      "nameCantBeEmpty": "Naam mag niet leeg zijn",
      "showStripeProductDetails": "Productdetails van Show Stripe",
      "addEmail": "E-mail toevoegen",
      "resetMountCounts": "Aantallen koppelingen resetten",
      "connectReconnectGoogleForGbp": "Google voor GBP verbinden of opnieuw verbinden",
      "downloadFile": "Document downloaden",
      "showOnlySlowQueries": "Toon alleen trage queries",
      "gmbMessagingAvailable": "GMB-berichten zijn nu beschikbaar",
      "reconnectGbpPageToEnable": "Verbind uw GBP-pagina opnieuw om berichten in te schakelen",
      "failedPaymentsCheckBilling": "Mislukte betalingen gedetecteerd. Controleer uw facturatie.",
      "onlyAgencyAdminsCanSeeWarning": "Alleen beheerders van het agentschap kunnen deze waarschuwing zien.",
      "filter": "Filter",
      "stopDeleteOperation": "Verwijdering stoppen",
      "summary": "Samenvatting",
      "enableTracking": "Schakel Tracering in",
      "exportAll": "Alles exporteren",
      "newConversationStarted": "Nieuw gesprek gestart",
      "startNewConversation": "Een nieuw gesprek starten",
      "subAccountScheduledForDeletion": "Subaccount gepland voor verwijdering",
      "deleteSubAccountOnScheduledTime": "Subaccount op geplande tijd verwijderen",
      "componentUpdatesDebuggerAlpha": "Debugger voor updates van onderdelen (Alpha)",
      "componentUpdateTrackingDisabled": "Bijwerken van onderdelen is uitgeschakeld",
      "deleteSubAccount": "Subaccount verwijderen",
      "subAccountHasNumbersAndCampaigns": "Dit subaccount heeft {phoneNumberCount} telefoonnummer(s) en {campaignsCount} campagne(s).",
      "subAccountNoNumbersOrCampaigns": "Dit subaccount heeft geen telefoonnummers of campagnes.",
      "areYouSureDeleteSubAccount": "Weet u zeker dat u dit subaccount wilt verwijderen?",
      "confirmDiscussedWithClient": "Ik bevestig dat ik dit met mijn cliënt heb besproken",
      "understandActionIrreversible": "Ik begrijp dat deze actie niet ongedaan kan worden gemaakt",
      "confirmDisconnectCloseLcPhone": "Ik bevestig dat ik het LC Phone-account wil verbreken en afsluiten",
      "choosingNotDeleteLcPhoneWarning": "Waarschuwing: Als u het LC Phone-account niet verwijdert, zullen er verder kosten in rekening worden gebracht voor de aan dit subaccount gekoppelde telefoonnummers.",
      "deleteAccount": "Account verwijderen",
      "send": "Verzenden",
      "typeMessage": "Typ een bericht",
      "requestPayment": "Verzoeken om betaling",
      "reply": "Antwoord",
      "retry": "Opnieuw proberen",
      "analyzeMemory": "Geheugen analyseren",
      "memoryAnalysisApproximate": "🚧 Geheugenanalyse is bij benadering en niet 100% nauwkeurig.",
      "subAccountScheduledForDeletionItWillBeDeleted": "Dit sub-account is ingepland voor verwijdering. Het wordt verwijderd door",
      "youCanChangeYourMindBeforeThisTime": "U kunt voor die tijd van gedachten veranderen.",
      "sms": {
        "errors": {
          "skipStayPrompt": "Overslaan",
          "cannotIdentifyContact": "Kan de contactpersoon en de locatie ervan niet identificeren.",
          "contactNotSelected": "De contactpersoon is niet geselecteerd.",
          "messageRequired": "Voer een bericht of een geselecteerd sjabloon in.",
          "noPhoneNumber": "De contactpersoon heeft geen telefoonnummer.",
          "genericError": "{message}",
          "stayPrompt": "Blijven"
        },
        "scheduledSuccess": "E-mail ingepland",
        "confirmDelete": "Weet u zeker dat u {name} wilt verwijderen?"
      },
      "clear": "Wissen",
      "edit": "Bewerken",
      "sendNow": "Nu verzenden",
      "schedule": "Inplannen",
      "useTemplate": "Gebruik een sjabloon (Snippet)",
      "mergeFields": "Velden samenvoegen",
      "customVariablesError": "Er zijn problemen in uw aangepaste variabelen, los deze op voordat u deze verzendt.",
      "sendLater": "Later verzenden",
      "scheduledFor": "Ingepland voor {date}",
      "call": "Oproep",
      "leftVoicemail": "Heeft een voicemail ingesproken",
      "pleaseSelectCampaign": "Selecteer een campagne",
      "whatsapp": {
        "no24HourMessage": "U kunt alleen sjabloonberichten verzenden buiten het 24-uursvenster. Selecteer alstublieft een sjabloon om te verzenden."
      },
      "attachFile": "Bestanden bijvoegen",
      "email": {
        "fromEmail": "Van e-mail",
        "fromName": "Van naam",
        "smtpWarning": "SMTP-providers hebben enkele beperkingen. Klik hier voor meer info.",
        "subject": "Onderwerp",
        "errors": {
          "cannotIdentifyContact": "Kan de contactpersoon en de locatie ervan niet identificeren.",
          "contactNotSelected": "De contactpersoon is niet geselecteerd.",
          "genericError": "{message}",
          "bodyRequired": "De e-mail vereist een hoofdtekst om te kunnen worden verzonden.",
          "noEmailAddress": "De contactpersoon heeft geen e-mailadres."
        },
        "scheduledSuccess": "E-mail ingepland"
      },
      "addCalendarToSchedule": "U moet een agenda toevoegen om afspraken te kunnen inplannen.",
      "slotRequired": "Tijdsvenster vereist",
      "teamMemberRequired": "Teamlid vereist."
    },
    "added": "toegevoegd",
    "loadMore": "Meer laden",
    "admin": "Beheerder",
    "aiEmployee": {
      "popupBlockedAlert": "U hebt pop-ups uitgeschakeld. Sta pop-ups toe voor deze site om automatisch door te verwijzen naar een Zoom-gesprek. Klik op Nu deelnemen om rechtsreeks doorgestuurd te worden naar het Zoom-gesprek."
    },
    "alsoCloseAssociatedSubAccount": "Ook nauw geassocieerd",
    "analyzeMemory": "Analyseer Geheugen",
    "announcements": "Aankondigingen",
    "apply": "Aanmelden",
    "appointment": {
      "pickDay": "Selecteer een dag",
      "pickSlot": "Selecteer een tijdsperiode voor uw afspraak",
      "selectDate": "Datum selecteren",
      "selectSlot": "Selecteer een tijdsperiode",
      "slot": "Tijdsperiode",
      "day": "Dag"
    },
    "areYouReallySureDeleteSubAccount": "Weet u echt zeker dat u dit subaccount wilt verwijderen?",
    "areYouSureDeleteSubAccount": "Weet u zeker dat u dit subaccount wilt verwijderen?",
    "assignedContactOwner": "Toegewezen ({contact} Eigenaar)",
    "assignedToMe": "Aan mij toegewezen",
    "audio": {
      "browserNotSupported": "Uw browser ondersteunt het audio-element niet.",
      "loadingTranscription": "Transcriptie aan het laden...",
      "viewTranscript": "Transcriptie bekijken",
      "stop": "Stop",
      "playPause": "Afspelen/Onderbreken",
      "timePlayed": "Gespeelde tijd: totale tijd",
      "mute": "Dempen",
      "playbackSpeed": "Afspeelsnelheid",
      "download": "Downloaden",
      "remove": "Verwijderen"
    },
    "automated": "Geautomatiseerd",
    "avatar": {
      "aiGenerated": "Dit bericht is gegenereerd door Conversation AI",
      "messengerAutomation": "Messenger automatisering",
      "workflowGenerated": "Dit bericht is gegenereerd door een Conversation AI-workflowactie",
      "messageByAI": "Dit bericht is gegenereerd door Conversation AI",
      "messageByWorkflow": "Dit bericht is gegenereerd door een Conversation AI-workflowactie",
      "agentPrefix": "E-",
      "unknownFallback": "?"
    },
    "bePartOfFastestGrowingCommunity": "Maak deel uit van de snelst groeiende community.",
    "callHighlevelAt": "Bel HighLevel op +1(888)732-4197",
    "callQueueTooltip": "Deze oproep staat in de wachtrij van de gebruiker.",
    "callTranscript": "Transcript gesprek",
    "clearFilters": "Filters wissen",
    "clientsCompanyBillingPage": "factureringspagina van het bedrijf van de klant",
    "closeChat": "Chat afsluiten",
    "closeConversation": "Gesprek afsluiten",
    "component": {
      "dismissMessage": "Negeer dit bericht",
      "unblock": "Deblokkeren",
      "inboundDndActive": "Inbound DND is actief voor dit contact",
      "fetchOlderMessages": "Oudere berichten ophalen",
      "conversationBegan": "Het gesprek is begonnen",
      "celebrationTitle": "Wohoo! Communicatie loopt nu soepel",
      "celebrationBody": "Het begint nog maar net, laten we onderzoeken hoe GHL kan helpen met het opbouwen van uw bedrijf.Ondertussen kunt u naar hartenlust berichten blijven versturen"
    },
    "componentUpdateTrackingDisabled": "Het bijhouden van onderdelenupdates is momenteel uitgeschakeld.",
    "componentUpdatesDebuggerAlpha": "🚧 Component Updates Debugger (Alpha) - Werk in uitvoering",
    "confirmDelete": "Gesprek(ken) verwijderen?",
    "confirmDeleteTextLine11": "Weet u zeker dat u dit gesprek wilt verwijderen? Deze actie kan niet ongedaan worden gemaakt.",
    "confirmDeleteTextLine12": "gesprekken geselecteerd",
    "confirmDeleteTextLine21": "Deze actie kan niet ongedaan worden gemaakt. Wilt u nog steeds doorgaan?",
    "confirmDisconnectedAllIntegrations": "Ik bevestig dat ik alle integraties heb losgekoppeld, zoals Twilio, Mailgun, Gmb, domeinen, Facebook, Zoom, enz.",
    "confirmStoppedAllAutomations": "Ik bevestig dat ik alle automatiseringen in dit account heb onderbroken",
    "connectReconnectGoogleForGbp": "Verbind / Herverbind uw Google om GBP-berichten te ontvangen!",
    "connectWithCertifiedAdmin": "Neem contact op met een Gecertificeerde beheerder",
    "connectWithTeamForHelp": "Neem contact op met ons team voor hulp via een live videogesprek!",
    "connectWithUs": "Neem contact met ons op",
    "connectZoomAccount": "Zoom account koppelen",
    "contactEngagementScore": "Betrokkenheidsscore {contact}",
    "dailyBrainstormingSessions": "Dagelijkse brainstormsessies met HighLevel",
    "deleteAccount": "Account verwijderen",
    "deleteSubAccountOnScheduledTime": "Subaccount op geplande tijd verwijderen",
    "disableSaasMode": "Schakel de SaaS-modus uit",
    "dnd": {
      "configure": "CONFIGUREREN",
      "status": {
        "on": "AAN",
        "partial": "Gedeeltelijk"
      }
    },
    "editAppointment": {
      "updateButton": "Afspraak bijwerken",
      "scheduleAppointment": "Afspraak inplannen",
      "editAppointment": "Afspraak wijzigen",
      "calendar": "Agenda",
      "selectCalendar": "Agenda selecteren",
      "roundRobin": "Roulatiesysteem",
      "pickTeamMember": "Selecteer een teamlid",
      "selectTeamMember": "Selecteer teamlid",
      "teamMemberRequired": "Teamlid is vereist.",
      "slotRequired": "Tijdsperiode vereist",
      "appointmentTitle": "Afspraaknaam",
      "appointmentTitleTooltip": "Als u ervoor kiest om de vooraf geconfigureerde afspraaknaam te gebruiken, kunt u overwegen om deze leeg te laten",
      "contactName": "Naam contactpersoon",
      "name": "Naam",
      "nameRequired": "Naam vereist",
      "emailAddress": "E-mailadres",
      "phoneNumber": "Telefoonnummer",
      "phoneNumbers": "Telefoonnummers",
      "dateOfBirth": "Geboortedatum",
      "contactTimezone": "Contacttijdzone (gebruikt voor herinnering)",
      "chooseOne": "Selecteer er één.",
      "meetingLocation": "Vergaderlocatie",
      "meetingLocationTooltip": "Overweeg om dit leeg te laten, mocht u ervoor kiezen om de vooraf geconfigureerde bijeenkomstlocatie te gebruiken",
      "status": "Status",
      "appointmentStatus": "Afspraakstatus",
      "additionalNotes": "Aanvullende notities",
      "notes": "Notities",
      "actionRequired": "Actie vereist",
      "confirmed": "Bevestigd",
      "invalid": "Ongeldig",
      "cancelled": "Geannuleerd",
      "showed": "Aanwezig",
      "noShow": "Niet aanwezig",
      "busy": "Niet beschikbaar",
      "free": "Beschikbaar",
      "noCalendarMessage": "U moet een agenda toevoegen om afspraken te kunnen inplannen."
    },
    "email": {
      "errors": {
        "bodyRequired": "De e-mail vereist een bodytekst om te uploaden.",
        "cannotIdentifyContact": "Kan contactpersoon en locatie niet identificeren.",
        "contactNotSelected": "De contactpersoon is niet geselecteerd.",
        "noEmailAddress": "De contactpersoon heeft geen e-mailadres."
      },
      "thread": {
        "failedToFetch": "Kan de e-mailinhoud niet ophalen",
        "forward": "Doorsturen"
      },
      "reply": "Beantwoorden",
      "share": "Delen",
      "facebook": "Facebook",
      "twitter": "X (voorheen Twitter)",
      "addAccount": "+ Account toevoegen",
      "respond": "Reageren",
      "retry": "Probeer het opnieuw",
      "moreEmailsInThread": "Nog {count} e-mails in de thread",
      "fromName": "Van naam",
      "fromEmail": "Van e-mail",
      "subject": "Onderwerp",
      "attachFile": "Bestanden bijvoegen",
      "useTemplate": "Gebruik een sjabloon (Snippet)",
      "requestPayment": "Verzoeken om betaling",
      "clear": "Wissen",
      "sendNow": "Nu verzenden",
      "schedule": "Inplannen",
      "send": "Verzenden",
      "smtpWarning": "SMTP-providers hebben enkele beperkingen. Klik hier voor meer info.",
      "chooseOne": "Selecteer er één.",
      "deliveredCount": "{delivered}/{total} geleverd",
      "typeMessage": "Typ een bericht",
      "sendLater": "Later verzenden",
      "scheduledFor": "Ingepland voor {date}"
    },
    "emailRebillingCardInfoRequired": "Om herfacturering pet e-mail in te schakelen, moet u de kaartgegevens van uw klant invoeren op",
    "emailRebillingDescription": "Hiermee kunt e-mailkosten opnieuw aan uw klanten factureren en een toeslag opnemen.",
    "emailRebillingMarginsDescription": "Dit zijn marges die aan uw klanten worden gefactureerd voor de door u gemaakte kosten",
    "enableTracking": "Schakel tracking in",
    "exploreHighlevelExperts": "Ontdek HighLevel-experts die u kunnen helpen bij het opzetten van uw systeem, het automatiseren van workflows of het aanpassen van uw project.",
    "exportAll": "Alles exporteren",
    "facebook": {
      "errors": {
        "generalError": "Er is een fout opgetreden. Probeer opnieuw of controleer de Facebook-integratie. Foutmelding",
        "noFacebookId": "De contactpersoon heeft geen Facebook-id."
      }
    },
    "failedPaymentsCheckBilling": "Eén of meerdere betalingen zijn mislukt. Controleer uw factuurgeschiedenis.",
    "fbMessengerDM": "FB Messenger DM",
    "filters": {
      "above": "Boven",
      "aiActionLogs": "AI-actielogboeken",
      "inRange": "In bereik",
      "invoice": "Factuur",
      "messageDirectionTooltip": "Het filter zal van toepassing zijn op berichten post 9 mei 2023",
      "appointments": "Afspraken"
    },
    "followed": "Gevolgd door",
    "followedByMe": "Gevolgd door mij",
    "followedBySpecificUser": "Gevolgd door een specifieke gebruiker",
    "follower": "Volger",
    "followerAssignmentContact": "Volger ({contact} toewijzing)",
    "gbp": {
      "errors": {
        "generalError": "Er is een fout opgetreden. Probeer opnieuw of controleer de Google Business Profile-integratie. Foutmelding",
        "noGBPId": "De contactpersoon heeft geen GBP-id."
      }
    },
    "gbpChatNoLongerAvailable": "Google Business Profile Chat is niet langer beschikbaar",
    "getAccessToHighlevelWelcomeCourse": "Krijg toegang tot de HighLevel-welkomstcursus",
    "getPriorityTroubleshooting": "Krijg prioriteit bij probleemoplossing, professionele begeleiding en rechtstreekse toegang tot ons technische team via Slack.",
    "gmbMessagingAvailable": "Google Business Messaging is beschikbaar voor uw account.",
    "googleMeet": "Google Meet",
    "googleReview": {
      "rating": "Waardering:",
      "replyDate": "Antwoorddatum:",
      "replyFrom": "Antwoord van:",
      "review": "Beoordelen",
      "reviewDate": "Recensiedatum:",
      "reviewFrom": "Recensie van:"
    },
    "highlevelEvents": "HighLevel-gebeurtenissen",
    "igMessengerDM": "IG Messenger DM",
    "includeSignatureBeforeQuotedText": "Voeg deze handtekening toe vóór de geciteerde tekst in antwoorden",
    "instagram": {
      "errors": {
        "generalError": "Er is een fout opgetreden. Probeer opnieuw of controleer de Instagram-integratie. Foutmelding",
        "noInstagramId": "De contactpersoon heeft geen Instagram-id."
      }
    },
    "joinOurFacebookGroup": "Word lid van onze Facebookgroep",
    "keepUpToDateWithLatestNews": "Blijf op de hoogte van het meest recente nieuws en de nieuwste releases!",
    "lastMessageChannel": "Laatste bericht kanaal",
    "lastMessageDirection": "Laatste bericht richting",
    "lastOutboundMessageType": "Type laatste uitgaand bericht",
    "learnHow": "Leer hier meer",
    "leftComment": "een opmerking achtergelaten",
    "leftPanel": {
      "recents": "Recent",
      "unread": "Ongelezen",
      "createNewMessage": "Nieuw bericht aanmaken",
      "minCharsRequired": "Minimaal 3 tekens vereist",
      "twoMoreCharsRequired": "Er zijn nog 2 tekens vereist",
      "oneMoreCharRequired": "Nog 1 teken vereist"
    },
    "liveChat": {
      "endLiveChat": "Live chat beëindigen",
      "errors": {
        "generalError": "Er is een fout opgetreden. Probeer opnieuw of controleer de Google My Business-integratie. Foutmelding"
      },
      "requestContact": "Verzoek contactpersoon"
    },
    "live_chat_message": "Live Chatbericht",
    "made": "aangemaakt",
    "memoryAnalysisApproximate": "🚧 Geheugenanalyse is bij benadering en niet 100% nauwkeurig.",
    "mentioned": "Vermeld aan",
    "mentions": "Vermeldingen",
    "mentionsOfMe": "Vermeldingen van mij",
    "mentionsOfSpecificUser": "Vermeldingen van specifieke gebruiker",
    "message": {
      "replyAll": "Iedereen beantwoorden",
      "details": "Details",
      "reply": "Beantwoorden",
      "unsuccessful": "Mislukt",
      "pending": "In afwachting",
      "inboundCall": "Inkomende oproep",
      "outboundCall": "Uitgaande oproep",
      "ivrCall": "IVR-oproep",
      "leftVoicemail": "Heeft een voicemail ingesproken",
      "storyReply": "Antwoord op story",
      "storyMention": "Vermelding van story",
      "replyAsDM": "Antwoord met DM",
      "newCommentOnPost": "Nieuwe reactie op {pageName}-bericht.",
      "goToPost": "Ga naar bericht",
      "replyNotAvailable": "Antwoorden met een privé-DM is niet mogelijk voor opmerkingen die ouder zijn dan 7 dagen.",
      "addToDocuments": "Toevoegen aan documenten",
      "attachmentsAddedSuccess": "Bijlagen toegevoegd aan documenten",
      "attachmentsAddedFailed": "Kon bijlagen niet toevoegen aan documenten",
      "reportFeedbackForAI": "Feedback voor AI rapporteren",
      "sms": "Sms"
    },
    "messageDetails": {
      "bcc": "BCC",
      "cancelScheduleConfirm": "Weet u zeker dat u deze planning wilt annuleren?",
      "cancelScheduledMessage": "Wilt u het ingeplande bericht annuleren?",
      "cancelSend": "Verzenden annuleren",
      "cancelScheduledSuccess": "Ingepland bericht geannuleerd",
      "cancelScheduledError": "Er is een fout opgetreden bij het annuleren van het geplande bericht",
      "cc": "CC",
      "channel": "Kanaal",
      "createdBy": "Gemaakt door",
      "direction": "Richting",
      "emailCampaign": "E-mailcampagne",
      "facebookMessage": "Facebook-bericht",
      "instagramMessage": "Instagram-bericht",
      "messageId": "Bericht-id",
      "messageIdLabel": "Bericht-ID: ",
      "trigger": "Trigger",
      "unanswered": "Onbeantwoord",
      "yes": "Ja",
      "messageDetails": "Berichtdetails",
      "from": "Van",
      "fromLabel": "Van:",
      "to": "Aan",
      "toLabel": "Aan:",
      "unknown": "Onbekend",
      "unknownFrom": "Onbekend van",
      "unknownTo": "Onbekend aan",
      "unknownDirection": "Onbekende richting",
      "dateUnknown": "Datum onbekend",
      "emailFromUnknown": "E-mail van Onbekend",
      "smsFromUnknown": "SMS van onbekend",
      "callFromUnknown": "Bellen van onbekend",
      "voicemailFromUnknown": "Voicemail van onbekend",
      "emailToUnknown": "E-mail naar onbekend",
      "smsToUnknown": "SMS naar onbekend",
      "callToUnknown": "Oproep naar onbekend",
      "voicemailToUnknown": "Voicemail naar onbekend",
      "failed": "Mislukt",
      "datetime": "Datum en tijd",
      "manual": "Handmatig",
      "automation": "Automatisering",
      "workflow": "Workflow",
      "campaign": "Campagne",
      "bulkRequest": "Bulkverzoek",
      "delivered": "Geleverd",
      "bounced": "Gebounced",
      "opened": "Geopend",
      "sent": "Verzonden",
      "scheduled": "Ingepland",
      "pageName": "Paginanaam",
      "gbpMessage": "GBP-bericht",
      "no": "Nee",
      "eventsTrackedForContactOnly": "Gebeurtenissen worden momenteel alleen vastgelegd voor het e-mailadres van de contactpersoon.",
      "completed": "Voltooid",
      "voicemail": "Voicemail",
      "busy": "Bezet",
      "pending": "In behandeling",
      "read": "Lezen",
      "nativeIntegrations": "Native integraties",
      "smtp": "SMTP",
      "twilio": "Twilio",
      "leadConnector": "LeadConnector",
      "email": "E-mail",
      "sms": "Sms",
      "phoneCall": "Telefoongesprek",
      "voiceMail": "Voicemail",
      "facebookMessenger": "Facebook Messenger",
      "instagramMessenger": "Instagram Messenger",
      "gbpMessenger": "GBP Messenger",
      "reviews": "Recensies",
      "others": "Overige",
      "partialDetailsWarning": "Gedeeltelijke details zullen beschikbaar zijn voor berichten voorafgaand aan 15 juli 2022.",
      "agencySystem": "Agentschapssysteem",
      "reply": "Antwoord"
    },
    "multiplePhone": {
      "chooseNumber": "Selecteer een nummer om de chat te beginnen:",
      "continue": "Doorgaan",
      "noPhones": "Er zijn geen telefoonnummers beschikbaar"
    },
    "myChat": "Mijn Chat",
    "myInbox": "Mijn Postvak In",
    "newConversationStarted": "Nieuw gesprek gestart",
    "newMessage": {
      "title": "Nieuw bericht:",
      "errors": {
        "phoneRequired": "Telefoonnummer is vereist"
      }
    },
    "noConversationSelected": "Geen gesprek geselecteerd",
    "noResultsToShow": "Geen resultaten om weer te geven",
    "onboardingVideoTutorials": "Videotutorials onboarding",
    "onlyAgencyAdminsCanSeeWarning": "Alleen agentschapbeheerders kunnen deze waarschuwing zien. Voor meer informatie",
    "onlyVisibleToUsers": "Alleen zichtbaar voor gebruikers",
    "perMonthPerIp": "/ maand / IP",
    "phone": {
      "call": "Bel {name}",
      "callingOptions": "{count} belopties",
      "phoneNumbers": "Telefoonnummers",
      "callOptions": "{count} belopties",
      "dndActive": "DND actief voor gesprekken",
      "primary": "Primair"
    },
    "pleaseDisableSaasMode": "Schakel de SaaS-modus uit voor dit subaccount",
    "pleaseSelectCampaign": "Selecteer een campagne",
    "premiumSupport": "Premiumondersteuning",
    "quickFilters": "Snelle filters",
    "reconnectGbpPageToEnable": "Herstel de verbinding met uw GBP-pagina om deze te activeren.",
    "replyAsDMTooltip": "Antwoord op deze opmerking als een privé-DM.",
    "replyingTo": "Antwoord voor",
    "resetMountCounts": "Aantallen koppelingen resetten",
    "review": {
      "errors": {
        "generalError": "Er is een fout opgetreden. Foutmelding",
        "googleIntegrationError": "Kan niet reageren op die recensie. Er lijkt een probleem te zijn met uw Google-integratie. Koppel deze opnieuw onder Instellingen -> Integraties.",
        "noReviewId": "Het gesprek heeft geen recensie-Id."
      },
      "reviewPostTo": "Bericht beoordelen op {network}",
      "sharedOn": "Recensie gedeeld op {network}",
      "disputeReview": "Maak bezwaar tegen deze recensie",
      "learnHow": "(Leer hoe?)",
      "seeOnGBP": "Bekijk deze recensie op GBP",
      "alreadyShared": "Deze recensie is al geplaatst op {network}. Weet u zeker dat u deze opnieuw wilt plaatsen?"
    },
    "reviewId": "Recensie-id",
    "schedule": {
      "sendSchedule": "Planning verzenden",
      "timezone": "Tijdzone ({heading})",
      "title": "Plan uw {type} in"
    },
    "scheduling": "Inplannen...",
    "seeHow": "Bekijk hoe",
    "selectFilter": "Filter selecteren",
    "selected": "geselecteerd",
    "sendEmail": {
      "recipientPlaceholder": "recipient{'@'}example.com",
      "subject": "Onderwerp:",
      "subjectPlaceholder": "E-mailonderwerp",
      "to": "Aan:",
      "sending": "Verzenden...",
      "sendButton": "E-mail verzenden"
    },
    "setupAccountWithFreeTutorials": "Stel gratis tutorials in voor uw account",
    "showOnlySlowQueries": "Toon alleen langzame queries (>{threshold}ms)",
    "sms": {
      "confirmSending": "Bevestig het verzenden van het bericht",
      "editModal": {
        "compose": "SMS opstellen"
      },
      "errors": {
        "customVariablesIssue": "Er zijn problemen in uw aangepaste variabelen, los deze op voordat u ze verzendt.",
        "messageOrTemplateRequired": "Voer een bericht of een geselecteerd sjabloon in.",
        "noPhoneNumber": "De contactpersoon heeft geen telefoonnummer."
      },
      "scheduledSuccessfully": "Sms is ingepland",
      "sendAnyway": "Toch verzenden",
      "spamWarning": "Uw sms-inhoud kan verwijzingen bevatten naar Cannabis, SHAFT, Vape of andere verboden onderwerpen. Het versturen van dergelijke inhoud via sms is ten strengste verboden en kan leiden tot accountbeperkingen. Lees uw inhoud zorgvuldig door vooraleer verder te gaan.",
      "send": "Verzenden"
    },
    "startNewConversation": "Beginnen een nieuw gesprek",
    "subAccountAndDeleteAllPhoneNumbers": "subaccount en verwijder alle telefoonnummers",
    "subAccountScheduledForDeletion": "Dit sub-account is ingepland voor verwijdering",
    "subAccountScheduledForDeletionItWillBeDeleted": "Dit sub-account is ingepland voor verwijdering. Het wordt verwijderd op",
    "teamInbox": "Postvak In voor het team",
    "threshold": "Drempel",
    "understandActionIrreversible": "Ik begrijp dat deze actie niet ongedaan kan worden gemaakt en alle gegevens in dit subaccount verloren zullen gaan",
    "unstarred": "Zonder ster",
    "use_a_template": "Gebruik een sjabloon",
    "userAvailability": "Beschikbaarheid voor gebruikers",
    "userCalendarConfiguration": "Configuratie van gebruikersagenda",
    "userInfo": "Gebruikersinformatie",
    "userRoles": "Gebruikersrollen",
    "viewSupportTickets": "Bekijk uw supporttickets, onze supportartikelen en nuttige veelgestelde vragen!",
    "visitOurHelpCenter": "Raadpleeg ons helpcentrum",
    "welcomeCourse": "Welkomstcursus",
    "whatsapp_logo": "WhatsApp-logo",
    "youCanChangeYourMindBeforeThisTime": "U kunt voor die tijd van gedachten veranderen.",
    "zoomAccount": "Zoom-account",
    "deleteEmails": "Verwijder {count} e-mail(s)",
    "fileAttachment": {
      "urlNotFound": "Url kan niet worden gevonden",
      "unsupportedAttachment": "Deze bijlagen worden mogelijk niet meer ondersteund.",
      "downloadFile": "Bestand downloaden"
    },
    "composer": {
      "internalComment": "Interne opmerking"
    },
    "dropdown": {
      "openOptions": "Open opties",
      "messageDetails": "Berichtdetails"
    },
    "respond": "Reageren",
    "selectTemplate": "Sjabloon selecteren",
    "settings": {
      "aiEmployeePromo": {
        "popupBlockedMessage": "U hebt pop-ups uitgeschakeld. Sta pop-ups toe voor deze site om automatisch door te verwijzen naar een Zoom-gesprek. Klik op Nu meedoen om direct doorgestuurd te worden naar het Zoom-gesprek.",
        "helpAndSupport": "Help & Ondersteuning",
        "summerOfAI": "Zomer van AI"
      }
    },
    "celebration": {
      "dismiss": "Sluiten",
      "body": "Dit is enkel het begin, laten we onderzoeken hoe GHL kan helpen met het opbouwen van uw bedrijf.\nOndertussen kunt u gewoon berichten blijven versturen",
      "title": "Wohoo! Communicatie loopt nu soepel"
    }
  },
  "cookies": {
    "thirdPartyWarning": {
      "helpArticle": "helpartikel hier",
      "message": "Schakel cookies van derden in om deze pagina correct te bekijken. U kunt verwijzen naar ons",
      "ok": "Oké",
      "title": "Cookies van derden werken niet"
    }
  },
  "crash": {
    "message": "Sorry, er is iets onverwachts gebeurd. Probeer de pagina opnieuw te laden.",
    "refresh": "Pagina vernieuwen",
    "title": "Oeps! Er is iets misgegaan"
  },
  "deleteLocation": {
    "abortModal": {
      "abortingDeletion": "Het afbreken van de verwijdering voor {name}",
      "confirmAbort": "Ja, annuleren",
      "keepDeleting": "Nee, ga door met verwijderen",
      "message": "Weet u zeker dat u wilt annuleren?",
      "scheduledForDeletion": "Deze locatie is ingepland voor verwijdering op {date}.",
      "title": "Verwijdering annuleren",
      "warning": "Let op: De locatie wordt verwijderd op de geplande datum, tenzij u de verwijdering afbreekt."
    }
  },
  "fileUpload": {
    "dropzone": {
      "defaultMessage": "Plaats hier bestanden om te uploaden",
      "uploadError": "Netwerkfout: Kon geen verzoek naar AWS sturen. (Misschien een fout in de CORS)"
    }
  },
  "funnel": {
    "acceptShare": {
      "add": "{entityName} toevoegen",
      "clonedMessage": "{entityName} Gedupliceerd! Schakel over naar een account waar het is gekloond en zoek het onder het tabblad {entityName}.",
      "errorGettingDetails": "Er lijkt een fout te zijn opgetreden bij het ophalen de gegevens van van {entityName}. Controleer de Link-URL of probeer het opnieuw!",
      "permissionError": "Machtigingsfout: Dit is een beschermde trechter en kan hier niet worden aangemaakt."
    }
  },
  "integrations": {
    "googleCalendar": {
      "logo": "GoogleCalendar Logo"
    },
    "printful": {
      "logo": "Printful Logo",
      "title": "Printful: Print on Demand"
    },
    "printify": {
      "logo": "Printify-logo",
      "title": "Printify: POD"
    },
    "shipStation": {
      "logo": "ShipStation-logo",
      "title": "Shipstation"
    },
    "shippo": {
      "logo": "Shippo-logo",
      "title": "Shippo: Integratie van verzending"
    },
    "tikTok": {
      "accountNotConnected": "Account niet verbonden",
      "accountNotConnectedMessage": "Uw account is niet gekoppeld aan het TikTok-advertentieaccount. Voltooi de integratie om formulieren te bekijken en velden toe te wijzen.",
      "advertiserId": "Adverteerder-ID",
      "companyFields": "{companyName} velden",
      "editFields": "Velden bewerken",
      "errorSubscribing": "Fout bij het abonneren op pagina.",
      "formsNotAvailable": "Formulieren niet beschikbaar",
      "mandatoryFieldsNote": "Let op: Koppel een van de volgende verplichte velden om succesvol leads in uw account te ontvangen. Velden: Voornaam, Achternaam, E-mailadres, Telefoonnummer",
      "noFormsMessage": "U hebt momenteel geen leadgeneratieformulier aangemaakt in uw TikTok-advertentieaccount. Ga naar uw TikTok-advertentieaccount en maak er een aan om te beginnen.",
      "pageId": "Pagina-ID",
      "selectAdvertiserAccount": "Selecteer adverteerdersaccount"
    }
  },
  "launchpad": {
    "duda": "Duda",
    "joomla": "Joomla",
    "otherOrIDontKnow": "Overig / Ik weet het niet",
    "shopify": "Shopify",
    "squarespace": "SquareSpace",
    "weebly": "Weebly",
    "wordpress": "WordPress"
  },
  "location": {
    "suspend": {
      "instructionText": "U moet enkele eenvoudige stappen uitvoeren om dit sub-account te pauzeren"
    },
    "transfer": {
      "chooseDescription": "Kies uw overdrachtsmethode",
      "chooseMethod": "Zet dit sub-account over",
      "eject": {
        "description": "Verdien 40% terugkerende provisie op het abonnement van het nieuwe account.",
        "title": "Verwijderen als nieuw account"
      },
      "modal": {
        "confirmDetails": "Bevestig de details voordat u overzet",
        "confirmNomineePrefix": "Nomineer een eigenaar voor",
        "confirmTransfer": "Overdracht bevestigen",
        "consentText": "Ik heb de bovenstaande handleiding gelezen en begrepen en ga akkoord met alle beperkingen",
        "ejectErrorTitle": "Kan sub-account niet verwijderen.",
        "ejectGenericError": "Het sub-account dat u probeert te verwijderen, kan niet worden verwijderd. Neem contact op met support.",
        "ejectGuidelines": "Richtlijnen voor het verwijderen van sub-accounts",
        "ejectSubject": "Het verwijderen van een sub-account kan alleen plaatsvinden als de gebruiker het verzoek accepteert om een nieuw bureau aan te maken.",
        "ejectSuccessTitle": "Verzoek om sub-account te verwijderen naar de geselecteerde gebruiker verzonden",
        "enterPassword": "Voer uw wachtwoord in om te bevestigen",
        "genericError": "Het sub-account dat u probeert over te dragen, kan niet worden overgedragen. Neem contact op met support.",
        "guidelines": "Richtlijnen voor het overzetten van sub-accounts",
        "guidelinesConsent": "Lees en geef goedkeuring aan",
        "hipaaDisclaimer": "Disclaimer",
        "hipaaText": "U kunt dit sub-account laten weten dat zij nu HIPAA-dekking ontvangen, maar mogelijk niet dezelfde dekking krijgen bij het bureau waarnaar zij worden overgeplaatst.",
        "noUsersDescription": "Er zijn geen gebruikers gekoppeld aan dit sub-account. Voeg een gebruiker met een sub-account toe en ga verder.",
        "noUsersSearch": "Geen gebruikers gevonden.",
        "noUsersTitle": "Geen gebruikers gevonden",
        "nomineeInstructions": "De genomineerde krijgt een link om zich te registreren voor HighLevel",
        "passwordError": "Ongeldig wachtwoord",
        "passwordErrorDescription": "Het ingevoerde wachtwoord is ongeldig. Probeer het opnieuw.",
        "relationshipError": "Voer het juiste relatienummer in",
        "relationshipNumber": "Relatienummer van de ontvangende instantie",
        "relationshipPlaceholder": "0-123-456",
        "requestTransfer": "Overdracht aanvragen",
        "seeAllRequests": "Alle verzoeken bekijken",
        "successMessage": "Het sub-account wordt overgezet zodra het ontvangende bureau uw verzoek tot overboeking heeft geaccepteerd.",
        "successTitle": "Verzoek tot overdracht van sub-account verzonden naar ontvangend bureau",
        "title": "Sub-account overzetten",
        "transferSubject": "Sub-accountoverdracht is afhankelijk van de acceptatie door de ontvangende instantie.",
        "confirmNomineeSuffix": " naar "
      },
      "transferExisting": {
        "description": "Zet dit volledige sub-account over naar een andere account.",
        "title": "Overzetten naar een bestaand account"
      }
    }
  },
  "marketing": {
    "bulkRequests": {
      "nextExecution": "Volgende uitvoering",
      "title": "Bulkverzoeken"
    },
    "campaign": {
      "account": "Account",
      "accountBuffer": "Account Buffer",
      "accountBufferDescription": "Er is geen limiet aan het aantal ontvangers dat elke dag aan deze campagne wordt toegevoegd (uit een lijst).",
      "accounts": "Accounts",
      "activity": "Activiteit",
      "acquire": "Verwerven",
      "acquisitionDescription": "Met klantwervingscampagnes kunt u meer 'hete' verkoopleads genereren die klaar zijn om in te gaan op uw aanbod.",
      "addEvent": "Gebeurtenis toevoegen",
      "addUser": "Gebruiker toevoegen",
      "allMarket": "De hele markt",
      "allowMultiple": "Sta meerdere toe",
      "assignedToTooltip": "Toen deze campagne begon, werd dit contact toegewezen aan deze gebruiker. Wijzigingen in de Toegewezen Aan van de contactpersoon zullen op de gebeurtenissen weerspiegelen, maar deze initiële waarde niet.",
      "atLeastOneEvent": "Er is minimaal één gebeurtenis vereist.",
      "automations": "Automatiseringen",
      "automationsPlaceholder": "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Welke gevolgen heeft het voor rerum, id, als onze accusantium magnam nemo perferendis eveniet quos perspiciatis molestiae explicabo reprehenderit nesciunt recusandae, quod onderscheidende vero en omdat alles? Corporis omnis, ipsa in, quae iste libero Min, voluptatem perferendis molestiae consectetur nam odio eligendi enim consequuntur! Dit is een van de redenen dat er sprake is van molestiae. Quaerat voluptatibus distinctio sed nisi aliquam, laboriosam laudantium fugiat dolores. Corporis suscipit modi corrupti. Delectus assumenda perspiciatis asperiores porro ipsam quaerat nesciunt provident sit non distinctio veritatis tempora omnis fugit dicta minima nisi aliquam ducimus rem, nobis cum.",
      "bounced": "Gebounced",
      "buffering": "Bufferen",
      "campaignActivity": "Campagne Activiteit",
      "campaignConfiguration": "Campagneconfiguratie",
      "campaignConfigurationWarning": "Campagneconfiguratie beïnvloedt alle markten. Zorg ervoor dat u deze instellingen moet aanpassen.",
      "campaignCreation": "Campagne aanmaken",
      "campaignId": "Campagne-ID",
      "campaignStatusByRecipients": "Campagnestatus per ontvangers",
      "clickThroughRate": "Doorkliksnelheid",
      "clickedThrough": "Doorgeklikt",
      "conditionIfExplanation": "Voer deze campagne of gebeurtenis uit als de huidige tijd in dit venster valt; als de huidige tijd buiten dit venster valt, sla de campagne of het evenement dan over en ga door naar het volgende.",
      "conditionWhenExplanation": "Voer de gebeurtenissen in deze campagne wanneer de huidige tijd in dit venster valt, anders wacht u tot het volgende venster om de gebeurtenissen te doen.",
      "createCampaign": " Campagne maken",
      "ctr": "CTR",
      "customerAcquisition": "Klantenwerving",
      "dateAdded": "Datum toegevoegd",
      "dateAddedTooltip": "De exacte datum en tijd waarop het contact aan deze campagne werd toegevoegd. De starttijd van de eerste gebeurtenis kan variëren, afhankelijk van de configuratie.",
      "deletedRestorePrompt": "Deze campagne is verwijderd! Wilt u deze herstellen?",
      "delivered": "Geleverd",
      "deliveryRate": "Leveringspercentage",
      "draftMode": "Conceptmodus",
      "draftModeDescription": "Deze campagne is een concept. Deze kan niet worden gebruikt totdat hij is gepubliceerd.",
      "dropped": "Stopgezet",
      "emailActivity": "E-mailactiviteit",
      "emailActivityFilterExample": "E-mailactiviteit: doorgeklikt",
      "event": "Gebeurtenis",
      "eventFilterExample": "Evenement: 10X e-mail 4 (Vermelding Distributie)",
      "filters": "Filters",
      "emailPerformanceByAccount": "E-mailprestaties per account",
      "emailsNotSentOnDays": "E-mails worden niet verzonden op zaterdag en zondag.",
      "emailsSentOnDays": "E-mails worden verzonden op maandag, dinsdag, woensdag, donderdag en vrijdag.",
      "eventStartDate": "Startdatum gebeurtenis",
      "exampleAddress": "801 7th Avenue North, Saskatoon, SK",
      "exampleCompanyName": "City Perks Koffiehuis",
      "exampleDate": "8 mei 2017 13:27 uur",
      "exampleEmail": "dstumph{'@'}vendasta.com",
      "exampleEmailDescription": "Zorg ervoor dat de gegevens niet ouder zijn dan 30 dagen",
      "exampleEventName": "10X E-mail 4 (vermelding distributie)",
      "getMoreCustomers": "Meer klanten krijgen",
      "inProgress": "In uitvoering",
      "includedDays": "Inbegrepen dagen",
      "internalSource": "Interne bron",
      "lastUpdate": "Bijgewerkt op",
      "leadValuePlaceholder": "$ Waarde van lead",
      "loopDetected": "Deze campagne is vergrendeld in de conceptstatus omdat het een lus veroorzaakt. Neem contact op met support om deze campagne te activeren.",
      "market": "Markt",
      "moreDetails": "Meer details",
      "myCampaigns": "Mijn campagnes",
      "na": "N.v.t.",
      "newFolder": " Nieuwe map",
      "nextCampaign": "Volgende Campagne",
      "nextExecutionTime": "Volgende uitvoeringstijd",
      "opened": "Geopend",
      "openRate": "Openingspercentage",
      "option2": "Optie 2",
      "option3": "Optie 3",
      "pageNavigation": "Voorbeeld van paginanavigatie",
      "processed": "Verwerkt",
      "published": "Gepubliceerd",
      "recipient": "Ontvanger",
      "recipients": "Ontvangers",
      "sampleCampaign": "Voorbeeldcampagne ",
      "scheduling": "Planning",
      "seeHotLeads": "Bekijk 'hot' potentiële klanten",
      "selectDateRange": "Selecteer datumbereik",
      "selectTimeZone": "Selecteer Tijdzone",
      "separator": " / ",
      "showingCount": "{current} van {total} weergeven",
      "spamReport": "Spamrapport",
      "startByAddingEvent": "Beginnen door een gebeurtenis aan deze campagne toe te voegen.",
      "stopOnResponse": "Stop bij reactie",
      "stopped": "Gestopt",
      "time": "Tijd",
      "timeConditionNote": "Opmerking: Als de eerste stap in campagnes op 'Direct' staat, geldt de tijdsvoorwaarde niet voor die eerste stap.",
      "timeZoneDescription": "Deze instelling beïnvloedt de tijd waarop uw content wordt verzonden.",
      "totalLeads": "Totaal aantal potentiële klanten",
      "undeliverable": "Onbestelbaar",
      "unsubscribe": "Afmelden",
      "upNext": "Volgende",
      "utc": "UTC",
      "window": "Venster"
    },
    "embed": {
      "copyLinkInstructions": "Kopieer onderstaande link om deze overal te delen.",
      "embed": "Insluiten",
      "iframeEmbed": "Iframe insluiten",
      "integrateInstructions": "Gebruik de volgende opties om uw aangepaste formulier in uw website te integreren",
      "integrateYourForm": "Integreer uw formulier",
      "link": "Link",
      "saveAndExit": "Opslaan en afsluiten"
    },
    "jotbox": {
      "deleteSubmission": "Inzending verwijderen",
      "downloadPdf": "Pdf downloaden",
      "ofSubmissions": " van {total} inzendingen",
      "pages": "pagina's",
      "records": "records",
      "searchPlaceholder": "Zoeken op naam, e-mail, telefoonnummer en contactpersoon-ID",
      "selectYourForm": "Selecteer uw formulier",
      "timeSigned": "Tijd ondertekend:",
      "totals": "Totalen:"
    },
    "survey": {
      "createNewSurvey": "Nieuwe enquête aanmaken",
      "integrateYourSurvey": "Integreer uw enquête",
      "noSurveysForAnalyze": "U hebt nog geen enquêtes. Maak eerst een enquête aan om hier stats te kunnen bekijken.",
      "noSurveysForSubmission": "U hebt nog geen enquêtes. Maak eerst een enquête aan om hier de inzending te zien.",
      "noSurveysYet": "U hebt nog geen enquêtes.",
      "refreshData": "Gegevens vernieuwen",
      "searchSurveys": "Zoek Enquêtes",
      "surveyBuilder": "Enquêtebouwer",
      "toCreateFirstSurvey": "om uw eerste enquête te maken."
    }
  },
  "membership": {
    "acceptShare": {
      "clonedMessage": "Product gedupliceerd! Schakel over naar een Account waar het is gekloond en ontdek het onder het tabblad Abonnement > Producten.",
      "errorGettingDetails": "Er lijkt een fout te zijn opgetreden bij het ophalen de productgegevens. Controleer de Link-URL of probeer het opnieuw!"
    },
    "resetPassword": {
      "title": "Wachtwoord opnieuw instellen",
      "button": "Wachtwoord opnieuw instellen",
      "newPassword": "Nieuw wachtwoord",
      "generateStrongPassword": "Maak een sterk wachtwoord aan",
      "sendEmailNotification": "Stuur ook een melding per e-mail.",
      "errorMessage": "Er is een fout opgetreden tijdens het opnieuw instellen van het wachtwoord. Probeer het opnieuw.",
      "updating": "Updaten..."
    }
  },
  "notifications": {
    "psBubble": {
      "byText": "⚡ via",
      "combo": {
        "signedUp": "aangemeld voor ProveSource in de afgelopen 24 uur",
        "verifiedBy": "geverifieerd door "
      },
      "conversions": {
        "recentlyBought": "kocht onlangs dit",
        "timeAgo": "in de afgelopen 16 minuten ",
        "visitorsCount": "50 bezoekers"
      },
      "pageVisits": {
        "description": "lijken ook honger te hebben.",
        "timeAgo": "in de afgelopen 21 minuten                        ",
        "title": "50 fijnproevers"
      },
      "proveSource": "ProveSource",
      "review": {
        "proofMessage": " Bewijsbericht",
        "rating": "5-sterrenbeoordeling",
        "recently": "Onlangs",
        "reviewerName": "Varun Vairavan",
        "starIcon": "⚡"
      },
      "stream": {
        "action": "aangemeld voor ProveSource",
        "location": "(Londen, Verenigd Koninkrijk)",
        "name": "Mike ",
        "timeAgo": "40 minuten geleden                        "
      },
      "visitors": {
        "description": "muziekliefhebbers online"
      }
    },
    "step1": {
      "combo": {
        "description": "Laat het totale aantal mensen zien dat een specifieke actie heeft uitgevoerd gedurende 24 uur, 7 of 30 dagen.",
        "title": "Combo"
      },
      "conversions": {
        "description": "Creëer sociale validatie door weer te geven hoeveel klanten een bepaalde actie hebben uitgevoerd."
      },
      "liveReviews": {
        "description": "Laat uw bezoekers realtime recensies met 4+ sterren zien van de afgelopen 6 maanden."
      },
      "liveVisitors": {
        "beta": "Bèta",
        "description": "Laat in realtime zien hoeveel bezoekers uw hele website momenteel bekijken."
      },
      "pageVisits": {
        "description": "Laat uw bezoekers zien dat ze niet de enigen zijn op het feest door recente paginabezoeken te markeren."
      },
      "stream": {
        "description": "Wat is er beter dan die sociale bewijskracht een gezicht te geven? Laat uw recente klanten en hun acties zien."
      }
    },
    "step2": {
      "captureDescription2": "Elke pagina URL moet een e-mailformulierveld bevatten",
      "captureDescription3": " en ProveSource geïnstalleerd. ",
      "comboType": "Combo Type",
      "connectAccounts": "Zorg ervoor dat u de accounts koppelt waarvan u recensies wilt ophalen",
      "connectGoogleAccount": "Verbind het Google-account van uw locatie",
      "formSubmissions": "Formulierinzendingen",
      "googleAccount": "Google Account",
      "howToTrack": "Hoe bijhouden",
      "howToTrackDescription": "Hoe moeten we uw conversies bijhouden?",
      "pageUrl": "Pagina-URL",
      "productPurchase": "Product kopen",
      "trackAllUrls": "Volg alle pagina-URL's die de volgende uitdrukking bevatten. ",
      "trackVisitors": "Volg bezoekers",
      "trackVisits": "Bezoeken bijhouden",
      "urlTip": " We behandelen http://, https://, www en non-www als aparte versies van de URL en pagina. ",
      "urlValidationError": "U moet ten minste één URL toevoegen. Ongeldige URL. Zorg ervoor dat u http:// of https:// toevoegt.",
      "userSignup": "Gebruikersaanmelding",
      "visits": " Bezoeken",
      "webhookDescription": "Bel het volgende eindpunt om ons te informeren over een gebeurtenis of conversie die aan uw kant heeft plaatsgevonden en die verband houdt met deze melding, wij doen de rest.",
      "webhookRequest": "Webhookverzoek",
      "whatToTrack": "Wat wilt u bijhouden?",
      "whereToCapture": "Waar vast te leggen",
      "whereToCaptureDescription": "Waar legt u conversies vast?",
      "whichPagesToTrack": "Welke pagina's wilt u dat we volgen?",
      "yourWebhookUrl": "Uw Webhook-URL"
    },
    "step3": {
      "allPages": " Alle pagina's",
      "displayOnAllPages": "Weergeven op alle pagina-URL's die de volgende uitdrukking bevatten: ",
      "whereToDisplay": "Waar Weergeven",
      "whereToDisplayActivity": "Waar wilt u dat we deze activiteit weergeven?"
    },
    "step4": {
      "icons8": "Icons8.com",
      "icons8Instructions": "voor mooie pictogrammen (klik met de rechtermuisknop op een pictogram -> Kopieer afbeeldingsadres)",
      "messageSettings": "Berichtinstellingen",
      "messageText": "Tekstberichten",
      "referToVisitorsAs": "Verwijs naar bezoekers als",
      "visitIcons8": "Bezoek"
    },
    "step5": {
      "allowUsersToClose": " Laat gebruikers de melding sluiten ",
      "behavior": "Gedrag",
      "bottomLeft": "Linksonder",
      "bottomRight": "Rechtsonder",
      "clickableNotification": " Klikbare melding ",
      "customizeDescription": "Wijzig de volgende instellingen om het gedrag en het uiterlijk van uw melding aan te passen",
      "design": "Design",
      "displayNotificationFor": "Toon melding voor",
      "displayRules": "Regels weergeven",
      "hideOnMobileScreens": " Verbergen op mobiele schermen ",
      "linkRelativeNote": " Als http:// wordt weggelaten, opent de link relatief ten opzichte van de weergegeven pagina ",
      "minimumEventsToDisplay": "Minimale gebeurtenissen om weer te geven",
      "notificationLink": "Meldingslink",
      "notificationPosition": "Positie melding",
      "openLinkInNewTab": "Link openen in een nieuw tabblad",
      "selectPosition": "Selecteer positie",
      "showOnlyOncePerSession": " Slechts één keer per sessie weergeven ",
      "titleBackground": "Titel achtergrond",
      "titleColor": "Kleur kop",
      "topLeft": "Linksboven",
      "topRight": "Rechtsboven",
      "typeUrlHere": "Typ hier de URL"
    },
    "step6": {
      "identifyNotification": "Identificeer uw melding",
      "launchMessage": "We staan op het punt om te vertrekken, neem plaats en doe uw veiligheidsgordel om.",
      "notificationName": "Naam melding",
      "notificationNamePrompt": "Wat is de naam van uw melding?",
      "wellDone": "Goed gedaan."
    },
    "wordpress": {
      "subscriptionCreatedSuccessfully": "Abonnement succesvol aangemaakt",
      "youCanNowSetupWordPress": "U kunt nu uw WordPress-site instellen",
      "subscriptionFailed": "Abonnement mislukt",
      "resubscriptionSuccessful": "Herinschrijving geslaagd",
      "successfullyReactivated": "Uw WordPress-abonnement is succesvol opnieuw geactiveerd.",
      "reactiveSub": "Kan het abonnement niet opnieuw activeren",
      "resubscriptionFailed": "Herinschrijving mislukt"
    },
    "v2": {
      "viewDetails": "Details bekijken",
      "chatConversationAssigned": "Chatgesprek toegewezen",
      "internalChat": "Interne chat",
      "newTask": "Nieuwe taak",
      "appointmentReminder": "Afspraakherinnering",
      "facebookReview": "Facebookrecensie",
      "googleReview": "Google-recensie",
      "internalChatMessage": "Intern chatbericht",
      "newAppointmentAssigned": "Nieuwe afspraak toegewezen",
      "newAppointmentBooked": "Nieuwe afspraak geboekt",
      "newCall": "Nieuw gesprek",
      "newEmail": "Nieuwe e-mail",
      "newMention": "Nieuwe vermelding",
      "newReviewReceived": "Nieuwe recensie ontvangen van {contactName}",
      "taskReminder": "Herinnering taak",
      "completed": "voltooid",
      "failed": "mislukt",
      "subAccount": "Subaccount",
      "newMessage": "Nieuw bericht",
      "newAppointmentBookedWith": "Nieuwe afspraak geboekt met {contactName}",
      "newAppointmentAssignedTo": "Nieuwe afspraak toegewezen aan {contactName}",
      "appointmentDueIn": "Afspraak over {minutes} minuten met {contactName}",
      "newTypeReceived": "Nieuwe {type} ontvangen van {contactName}",
      "newChatAssigned": "Nieuwe chat toegewezen door {contactName}",
      "taskDueDate": "Taak '{title}' moet worden voltooid op {date} om {time} voor {contactName}",
      "tasksDueToday": "{count} taken die vandaag moeten worden afgerond",
      "tasksOverdue": "{count} taken zijn achterstallig",
      "taskDueIn": "Taak '{title}' verschuldigd over {dueTime} {unitOfTime} voor {contactName}",
      "mentionedInConversation": "{userName} vermelde u in gesprek met {contactName}",
      "now": "nu"
    }
  },
  "onboarding": {
    "landscapeMode": {
      "altTexts": {
        "logo": "Logo bedrijf"
      },
      "bestExperience": "beste ervaring.",
      "optimizedFor": "Deze pagina is geoptimaliseerd voor",
      "portraitMode": "portretmodus",
      "toGiveYou": "om u de"
    }
  },
  "pagination": {
    "goToFirstPage": "Ga naar de eerste pagina",
    "goToLastPage": "Ga naar de laatste pagina",
    "goToNextPage": "Ga naar de volgende pagina",
    "goToPreviousPage": "Ga naar de vorige pagina",
    "itemsSelected": "{count} items geselecteerd",
    "showingEntries": "Weergeven {from} tot {to} van {total} vermeldingen"
  },
  "pmd": {
    "0": "0",
    "10": "10",
    "_min": "/ min",
    "_please_add_a_payment_method_for": "! Voeg een betaalmethode toe voor",
    "_segment": "/ segment",
    "ad_manager": "Advertentiemanager",
    "add": "[TOEVOEGEN:",
    "ai_employee": "AI-medewerker",
    "billing": {
      "incompleteBillingInfo": "U heeft onvolledige factureringsinformatie op dit account. Werk dit zo mogelijk onmiddellijk bij.",
      "updateNow": "Nu vernieuwen"
    },
    "charge": "Prijs",
    "contactLimit": {
      "message": "Met het toevoegen van {contact} heeft u de limiet van uw huidige plan bereikt. Om door te gaan dient u uw plan te upgraden en extra capaciteit vrij te maken.",
      "upgradeNow": "Nu upgraden",
      "warningMessage": "U heeft {current} contactperso(o)n(en), terwijl uw plan er slechts {limit} toestaat.",
      "warningTitle": "Accountgebruik is boven de limiet. Om ononderbroken te kunnen blijven werken dient u te upgraden."
    },
    "cost_borne_by_you": "door u gedragen kosten",
    "dedicated_ip": "Dedicated IP",
    "electeditem": "electedItem",
    "feedback": "Feedback:",
    "hello": "Hallo",
    "helpDrawer": {
      "aiSupportAssistant": "AI Support Assistent",
      "clickToCopy": "Klik om het relatienummer te kopiëren",
      "clickToCopyToClipboard": "Klik om het relatienummer naar het klembord te kopiëren",
      "companyRelationshipNumber": "Relatienummer van bedrijf",
      "hiImHighly": "Hallo, ik ben Highly!",
      "implementation": "Implementatie",
      "joinImplementationVideo": "Meedoen aan de Implementatie videobellen",
      "joinTrialZoom": "Doe mee aan proef-Zoom-gesprek",
      "kickoff": "kick-off",
      "needHelpChatVideo": "Hulp nodig? Start nu een chat of videogesprek met ons!",
      "openAIAssistant": "AI-ondersteuningsassistent openen",
      "premium": "Premium",
      "priority": "Prioriteit",
      "raiseSupportTicket": "Dien een supportticket in",
      "raiseTicket": "Dien een ticket in",
      "relationshipNumber": "Relatienummer",
      "startAISupportChat": "Start een AI-ondersteuningschat",
      "startAgentChatWait": "Begin de agentchat met een wachttijd van 2-5 minuten",
      "startChatChoose": "Start chat - kies tussen AI-ondersteuning of agentchat",
      "startImplementationVideo": "Start implementatie Videogesprek",
      "startZoom": "Start Zoom",
      "startZoomCall": "Zoom-gesprek starten",
      "subtitle": "Of u nu met ons of de community wilt praten of zelfstandig wilt leren, bij ons bent u aan het juiste adres!",
      "title": "Help & Ondersteuning",
      "trialExperience": "Proefperiode-ervaring",
      "useButtonsBelow": "Gebruik een van de onderstaande knoppen om hulp te krijgen!",
      "videoCallReward": "Neem deel aan een videogesprek om uw account te configureren — en ontvang {amount} in uw portemonnee wanneer u aanwezig bent.",
      "videoCallType": "Neem deel aan een videogesprek met mij voor uw {type}-gesprek.",
      "yourPremiumSupportSpecialist": "Uw {type} supportspecialist",
      "yourSpecialist": "Uw {type}-specialist",
      "yourSupportSpecialist": "Uw supportprofessional",
      "videoCall": "Videogesprek",
      "active": "Actief",
      "announcementsAria": "Aankondigingen - klik om te openen in een nieuw tabblad",
      "chat": "Chat",
      "accessWelcomeCourseAria": "Klik om toegang te krijgen tot de HighLevel-welkomstcursus",
      "clickToUpgrade": "Klik om te upgraden",
      "connectCertifiedAdminAria": "Neem contact op met een gecertificeerde beheerder - klik om te openen in een nieuw tabblad",
      "connectWithUsAria": "Contacteer ons - start de live chat",
      "contactUsAria": "Neem contact met ons op - bel HighLevel op +1(888)732-4197",
      "copied": "Gekopieerd",
      "highlevelEventsAria": "Highlevel Events - klik om te openen in een nieuw tabblad",
      "joinFacebookGroupAria": "Word lid van onze Facebookgroep - klik om te openen in een nieuw tabblad",
      "onboardingVideoTutorialsAria": "Videotutorials onboarding - klik om te openen in een nieuw tabblad",
      "recommended": "Aanbevolen",
      "visitHelpCenterAria": "Bezoek ons Helpcentrum - klik om te openen in een nieuw tabblad",
      "contactUs": "Contact",
      "agentChatWaitTime": "Chat met agent (~ 2-5 min. wachttijd)",
      "aiSupportChat": "Chat met AI-ondersteuning",
      "startChat": "Start de chat",
      "announcements": "Aankondigingen",
      "fastestGrowingCommunity": "Maak deel uit van de snelst groeiende community.",
      "callHighlevelPhone": "Bel HighLevel op +1(888)732-4197",
      "connectCertifiedAdmin": "Neem contact op met een Gecertificeerde Beheerder",
      "connectTeamVideoCall": "Neem contact op met ons team voor hulp via een live videogesprek!",
      "connectWithUs": "Neem contact met ons op",
      "dailyBrainstormingSessions": "Dagelijkse brainstormsessies met HighLevel",
      "certifiedAdminDescription": "Ontdek HighLevel-experts die u kunnen helpen bij het opzetten van uw systeem, het automatiseren van workflows of het aanpassen van uw project.",
      "getAccessWelcomeCourse": "Krijg toegang tot de HighLevel-welkomstcursus",
      "premiumSupportDescription": "Krijg prioriteit bij probleemoplossing, deskundige begeleiding en rechtstreekse toegang tot ons technische team via Slack.",
      "highlevelEvents": "HighLevel-gebeurtenissen",
      "joinFacebookGroup": "Word lid van onze Facebookgroep",
      "onboardingVideoTutorials": "Videotutorials onboarding",
      "premiumSupport": "Premiumondersteuning",
      "setupAccountFreeTutorials": "Stel uw account in met gratis tutorials",
      "viewSupportTicketsArticles": "Bekijk uw supporttickets, onze supportartikelen en nuttige veelgestelde vragen!",
      "visitHelpCenter": "Raadpleeg ons helpcentrum",
      "welcomeCourse": "Welkomstcursus",
      "beta": "Bèta",
      "closeHelpSupportDrawer": "Sluit de Help- en ondersteuningslade",
      "upgradePlanToEnable": "U moet uw abonnement upgraden om deze functie te kunnen gebruiken",
      "premiumSupportActive": "Uw premiumondersteuning is actief",
      "premiumSupportClickUpgrade": "Premiumondersteuning - Klik om uw plan te upgraden",
      "premiumSupportActiveAria": "Premium ondersteuning - Uw premium ondersteuning is actief",
      "keepUpToDateNews": "Blijf op de hoogte van het meest recente nieuws en de nieuwste releases!"
    },
    "hi": "Hallo",
    "is_scheduled_for_deletion_on": "is gepland voor verwijdering op",
    "k": "K",
    "limit_updated_from": "limiet bijgewerkt van",
    "minimum_must_be": "Minimum moet zijn",
    "more_emails_in_thread": "Meer e-mails in de conversatie",
    "multipleUsers": {
      "chooseAccount": "Kies een account om door te gaan"
    },
    "must_be_in_range_of_0": "Moet binnen het bereik vallen van 0-",
    "numbers_and": "aantal(en) en",
    "premiumSupport": {
      "assigningManager": "Technisch accountmanager toewijzen...",
      "bookCall": "Boek een gesprek",
      "hiIm": "Hallo, ik ben {name}",
      "joinZoomNow": "Neem nu deel aan Zoom-gesprek",
      "quickActions": "Snelle ondersteuningsacties",
      "quickLinks": "Snelle links",
      "raiseFeatureRequest": "Functieverzoek indienen",
      "slackChannelCreating": "Even geduld—uw Premium Slack-platform wordt opgestart! 🚀",
      "technicalAccountManager": "Technisch Account Manager",
      "viewRoadmap": "Bekijk de productroadmap"
    },
    "prospecting": "Prospectie",
    "reloadPopup": {
      "message": "We hebben gemerkt dat je de pagina al een tijd niet hebt vernieuwd. Laad de pagina opnieuw om de beste ervaring met de app te krijgen.",
      "refreshNow": "Nu vernieuw"
    },
    "resell_settings": "Instellingen voor doorverkoop",
    "row": "rij",
    "select_upto": "Selecteer maximaal",
    "seo": "SEO",
    "supportCalendar": {
      "description": "Krijg speciale ondersteuning wanneer het u uitkomt.",
      "title": "Plan een gesprek met Highlevel support"
    },
    "these_are_margins_that_are_billed_to_your_clients_": "Dit zijn marges die aan uw klanten worden gefactureerd over de",
    "twilioSetup": {
      "autoSetup": {
        "benefit1": "Laat ons Twilio probleemloos voor u beheren",
        "benefit2": "Ons supportteam helpt u graag met uw Twilio-problemen",
        "button": "Doe het voor mij",
        "drawback": "Betaal {price} extra aan VAS in vergelijking met het zelf doen",
        "title": "Wij doen het voor u"
      },
      "lowCreditsMessage": "U moet een Twilio-account koppelen om oproepen en sms-berichten te beheren die naar of van HighLevel worden verzonden of ontvangen.",
      "lowCreditsTitle": "Uw gratis Twilio-credits zijn bijna op, maar wij staan voor u klaar!",
      "selfSetup": {
        "benefit1": "Beheer uw uitgaven",
        "benefit2": "Krijg meer controle over uw Twilio-service",
        "button": "Ik krijg het voor elkaar",
        "drawback1": "Huur iemand in om de Twilio-service te beheren",
        "drawback2": "Neem contact op met de ondersteuning van Twilio wanneer iets niet werkt.",
        "title": "Doe het zelf"
      },
      "wip": {
        "button": "Stel Twilio nu in",
        "fallback": "Voorlopig moet u uw eigen Twilio-account beheren.",
        "message": "Bedankt dat u voor ons heeft gekozen, maar we zijn nog steeds bezig met het ontwikkelen van deze functie. U hoort van ons zodra we dit voor uw account kunnen uitrollen.",
        "title": "We zijn er nog steeds mee bezig!"
      }
    },
    "uiComponents": {
      "loadingMoreOptions": "Meer opties aan het laden...",
      "noElementsFound": "Oeps! Geen elementen gevonden. Overweeg om de zoekvraag te wijzigen.",
      "noLocationsFound": "Geen locaties gevonden. Probeer een andere zoekopdracht.",
      "typeToSearch": "Typ om te zoeken",
      "enterUserEmail": "Voer het e-mailadres van de gebruiker in"
    },
    "updating": "Updaten...",
    "usd": "USD",
    "useTemplate": {
      "useTemplate": "Sjabloon gebruiken"
    },
    "validEmail": {
      "andYouCan": "En u kunt",
      "as": "als",
      "canReverify": "U kunt uw e-mail opnieuw verifiëren",
      "emailIs": "Deze e-mail is",
      "emailMarkedAs": "Deze email gemarkeerd als",
      "markedAsInvalid": "Deze email is gemarkeerd als",
      "notVerified": "Niet geverifieerd",
      "reverifyHere": "Hier opnieuw verifiëren",
      "verifyHere": "Hier verifiëren"
    },
    "will_give_you_about": "zal u ongeveer geven",
    "checkout": {
      "confirm": "Bevestigen",
      "cardInformation": "Kaartgegevens",
      "cardNumberInvalid": "Uw kaartnummer is ongeldig.",
      "commitment": "verplichting",
      "paymentConsent": "Door te bevestigen, geeft u LeadConnector toestemming om uw kaart te belasten voor deze betaling.",
      "subscriptionConsent": "Door uw abonnement te bevestigen, geeft u LeadConnector toestemming om uw kaart te belasten voor deze betaling en toekomstige betalingen voor dit abonnemen",
      "endingIn": "eindigend op",
      "month": "maand",
      "pay": "Betalen",
      "payWithCard": "betaal met kaart",
      "paymentBeingProcessed": "Uw betaling wordt verwerkt. Niet opnieuw laden of op de terugknop drukken",
      "proceedWithExistingCard": "Doorgaan met de huidige kaart",
      "proceedWithNewCard": "Doorgaan met een nieuwe kaart",
      "purchase": "aankoop",
      "subscribe": "Abonneren",
      "subscribeTo": "Abonneer u op",
      "pleaseUpdateCardDetails": "Update de kaartgegevens",
      "zip": "postcode",
      "retry": "probeer opnieuw",
      "initialChargesProrated": "De initiële kosten worden naar rato berekend en de reguliere facturering start vanaf...",
      "youWillBeChargedFor": "U zult kosten in rekening gebracht krijgen",
      "days": "dagen",
      "rightNowForPeriodTill": "op dit moment voor de periode tot",
      "startGettingChargedFullAmount": "dan wordt het volledige bedrag van",
      "perMonthStartingFrom": "/maand vanaf",
      "nameOnCard": "Naam op de kaart",
      "somethingWentWrong": "Er ging iets mis",
      "errorImg": "fout img",
      "networkError": "Netwerkfout, probeer het later opnieuw",
      "paymentCouldNotBeProcessed": "De betaling kon niet worden verwerkt. Probeer opnieuw een kaart toe te voegen."
    },
    "deleteLocation": {
      "back": "Terug",
      "delete": "Verwijderen",
      "completeStepsToDelete": "U moet een paar eenvoudige stappen uitvoeren om deze locatie te verwijderen.",
      "alsoCloseAssociated": "Ook nauw geassocieerd",
      "scheduling": "Inplannen...",
      "subAccountAndDeletePhoneNumbers": "subaccount en verwijder alle telefoonnummers",
      "somethingWentWrongTryAgain": "Er is iets misgegaan. Probeer het later opnieuw.",
      "deleteSubAccount": "Subaccount verwijderen",
      "scheduleForDeletion": "Schema voor verwijdering"
    },
    "productRebilling": {
      "enableRebilling": "Opnieuw factureren inschakelen",
      "ratesMayDifferUK": "Tarieven kunnen verschillen per regio. De getoonde berekeningen zijn volgens de tarieven voor het VK,",
      "examplePricingGpt4oMini": "Voorbeeldprijzen - GPT-4o Mini",
      "input": "Invoer",
      "output": "Uitvoer",
      "supportDoc": "ondersteunend document",
      "unsavedChanges": "Niet-opgeslagen wijzigingen",
      "to": "naar",
      "chargedToCustomerLower": "In rekening gebracht aan de klant",
      "model": "Model",
      "profit": "Winst",
      "saving": "Opslaan...",
      "type": "Type",
      "updating": "Updaten...",
      "clickHere": "Klik hier",
      "chargedToCustomer": "In rekening gebracht aan de klant",
      "enabling": "Inschakelen...",
      "forMoreDetails": "voor meer details.",
      "tenDollarsWillGive": "$ 10 geeft u ongeveer",
      "yourCost": "Uw kosten",
      "seeHow": "Bekijk hoe",
      "clientCompanyBillingPage": "factureringspagina van het bedrijf van de klant",
      "connectStripeToEnable": "Om refacturering in te schakelen, moet u uw Stripe-account verbinden",
      "companyStripeIntegrationPage": "pagina voor de Stripe-integratie van het bedrijf",
      "enterClientCardInfo": "Om herfacturering in te schakelen, moet u de kaartgegevens van uw klant invoeren op",
      "gpt4oMini": "GPT-4o-mini",
      "for750kWords": "(voor 750.000 woorden)",
      "words": "woorden",
      "yourCostLower": "Uw kosten",
      "and": "en",
      "or": "of",
      "minimumMustBeBetween": "Het minimum moet tussen {0} en {1} liggen",
      "upgradeToAgencyPro": "Upgrade naar Agency Pro",
      "planToSetMargins": "plan om marges in te stellen"
    },
    "m": "m",
    "label": "Label",
    "company_email_": "Zakelijke e-mail (",
    "me_": "Mij (",
    "automation_type": "Automatiseringstype",
    "calendar_groups": "Agendagroepen",
    "length_": ".length }}"
  },
  "products": {
    "noProducts": "Geen producten beschikbaar",
    "selectProduct": "Selecteer een product"
  },
  "reselling": {
    "common": {
      "additionalMessagesInfo": ". Extra {product} -berichten worden niet in rekening gebracht bij de locaties. Schakel de SaaS-modus en opnieuw factureren in om de klant opnieuw te factureren.",
      "agreementPrefix": "Ik ga akkoord met het inschakelen",
      "agreementSuffix": "voor deze klant zonder doorverkopen en begrijp dat mij kosten in rekening gebracht zullen worden",
      "buildResellerOffer": "Stel uw doorverkoopaanbod samen",
      "deployDirectlyDescription": "Gebruik deze optie als u {product} aanbiedt als onderdeel van uw aanbod of als u uw klant extern wilt factureren",
      "deployPrefix": "Implementeren",
      "directlySuffix": "Rechtstreeks",
      "learnMore": "Meer informatie.",
      "offerPrefix": "Aanbod",
      "resellPrefix": "Doorverkopen",
      "resellingPrefix": "Doorverkopen",
      "subscriptionRestriction": "Kan de instelling niet wijzigen omdat de locatie al is geabonneerd",
      "zero": "0",
      "highlevelPrice": "HighLevel-prijs",
      "howDoesItWork": "Hoe werkt het?",
      "payNowButton": "Nu betalen",
      "priceValidationError": "De prijs moet hoger of gelijk zijn aan de HighLevel-prijs",
      "saving": "Opslaan",
      "yourPrice": "Uw prijs",
      "yourProfit": "Uw winst"
    },
    "whatsapp": {
      "inboundMessagesInfo": "Het ontvangen van inkomende berichten en deze beantwoorden door gebruik te maken van een gratis tekst in het chatvenster is gratis. Extra doorvoerkosten worden in rekening gebracht voor uitgaande sjabloonberichten, indien deze worden verzonden.",
      "whatsappLocation": "WhatsApp-locatie"
    },
    "agencyResellingPage": {
      "seo": {
        "subscriptionRestriction": "Kan de configuratie niet wijzigen omdat de locatie al is geabonneerd",
        "offerPrefix": "Aanbod ",
        "poweredByPrefix": " (Mogelijk gemaakt door Search Atlas)",
        "toggleTooltipDisable": "Deze actie schakelt de SEO-tool uit voor alle subaccounts.",
        "toggleTooltipEnable": "Deze actie schakelt de SEO-widget in voor alle sub-accounts.",
        "resellPrefix": "Doorverkopen ",
        "howDoesItWork": "Hoe werkt het?",
        "buildResellerOffer": "Stel uw doorverkoopaanbod samen",
        "yourPrice": "Uw prijs",
        "highlevelPrice": "HighLevel-prijs",
        "yourProfit": "Uw winst",
        "priceValidationError": "De prijs moet hoger of gelijk zijn aan de HighLevel-prijs",
        "saving": "Opslaan",
        "save": "Opslaan",
        "deployPrefix": "Implementeren ",
        "directlySuffix": "Rechtstreeks",
        "deployDirectlyDescription": "Gebruik deze optie als u SEO aanbiedt als onderdeel van uw aanbod of als u uw klant extern wilt factureren.",
        "agreementPrefix": "Ik ga akkoord met het inschakelen ",
        "agreementSuffix": " voor deze klant zonder doorverkopen en ik erken dat mij kosten in rekening gebracht zullen worden",
        "payNowButton": "Nu betalen",
        "subscriptionCreating": "Abonnement wordt gemaakt.<br/>Niet opnieuw laden of op de terugknop drukken",
        "subscriptionCreated": "Abonnement aanmaken gelukt. Een ogenblik geduld...",
        "subscriptionError": "Kan geen abonnement maken, neem contact op met de ondersteuning"
      },
      "adManager": {
        "subscriptionRestriction": "Kan de configuratie niet wijzigen omdat de locatie al is geabonneerd",
        "offerPrefix": "Aanbod ",
        "resellingPrefix": "Doorverkopen",
        "resellPrefix": "Doorverkopen ",
        "howDoesItWork": "Hoe werkt het?",
        "bookACall": "Boek een gesprek",
        "bookCallTooltip": "Boek een gesprek met ons team om meer te leren over Ad Manager",
        "buildResellerOffer": "Stel uw doorverkoopaanbod samen",
        "yourPrice": "Uw prijs",
        "highlevelPrice": "HighLevel-prijs",
        "yourProfit": "Uw winst",
        "priceValidationError": "De prijs moet hoger of gelijk zijn aan de HighLevel-prijs",
        "loading": "Aan het laden...",
        "save": "Opslaan",
        "deployPrefix": "Implementeren ",
        "directlySuffix": "Rechtstreeks",
        "deployDirectlyDescription": "Gebruik deze optie als u Ad Manager als onderdeel van uw aanbod aanbiedt of als u uw klant extern wilt factureren.",
        "agreementPrefix": "Ik ga akkoord met het inschakelen ",
        "agreementMiddle": " voor deze klant zonder doorverkopen en ik erken dat mij kosten in rekening gebracht zullen worden",
        "agreementSuffix": " per maand",
        "stripeNotConnectedLocationWarning": "Stripe is niet verbonden met deze locatie. Koppel Stripe om deze functie in te schakelen.",
        "stripeNotConnectedAgencyWarning": "Stripe is niet verbonden met dit agentschap. Verbind Stripe om deze functie in te schakelen.",
        "underSubAccountReselling": "per maand onder sub-account wederverkoop"
      },
      "dedicatedIp": {
        "description": "Hiermee kunt u dedicated IP-adressen (gebruikt voor uitgaande verzending van e-mail) opnieuw factureren voor de kosten voor uw klanten en een toeslag opnemen",
        "numberOfIps": "Aantal IP's:",
        "yourCost": "Uw kosten:",
        "chargedToCustomer": "In rekening gebracht aan de klant:",
        "profit": "Winst:",
        "monthlyProfit": "Maandelijkse winst:",
        "loading": "Aan het laden...",
        "save": "Opslaan",
        "revokeDedication": "Opdracht herroepen",
        "revokeDescription": "Gebruik deze optie om te stoppen met het aanbieden van nieuwe statische IP's aan uw klant zonder dat er kosten voor in rekening worden gebracht",
        "existingSubscriptionsNote": "Huidige IP-abonnementen worden niet beïnvloed",
        "revoke": "Herroepen",
        "provideDirectlyTitle": "Bied meteen een statisch IP-adres voor e-mail aan",
        "provideDirectlyDescription": "Gebruik deze optie om Dedicated IP aan uw klant te geven zonder dat er kosten in rekening worden gebracht",
        "agreeToProvideText": "Ik ga ermee akkoord om IP voor deze klant te leveren zonder upselling",
        "acknowledgeChargeText": "Ik begrijp dat er $ 59 / maand / IP in rekening zal worden gebracht",
        "agree": "Akkoord",
        "yourMonthlyCost": "Uw maandelijkse IP-prijs:",
        "monthlyChargeToCustomer": "Maandelijkse prijs voor de klant:",
        "resellingSettingsSuffix": " Instellingen voor doorverkoop",
        "ipRebillingAmount": "IP herfactureringsbedrag"
      }
    }
  },
  "saas": {
    "disable": {
      "complianceModal": {
        "clientApproval": "Ik bevestig dat ik dit met mijn cliënt heb besproken en dat ik hun goedkeuring heb.",
        "confirmQuestion": "Weet u zeker dat u de SaaS-modus voor dit account wilt uitschakelen?",
        "dataLossAck": "Ik erken dat alle herfactureringsgegevens, SaaS-abonnementsgegevens en transactieboek verloren zullen gaan",
        "disableSaas": "SaaS uitschakelen",
        "irreversibleAck": "Ik begrijp dat deze actie onomkeerbaar is"
      },
      "confirmationModal": {
        "cancelSubscription": "Annuleer ook het bijbehorende SaaS-abonnement",
        "confirmDisable": "Bevestig uitschakelen",
        "confirmQuestion": "Weet u zeker dat u de SaaS-modus wilt uitschakelen?",
        "somethingWentWrong": "Er is iets misgegaan. Probeer het later opnieuw."
      },
      "processingModal": {
        "closeNow": "Nu afsluiten",
        "closeWindowInstructions": "U kunt dit venster afsluiten. We brengen u via e-mail op de hoogte zodra het proces is voltooid",
        "title": "SaaS wordt binnenkort uitgeschakeld voor deze locatie.",
        "typicalTime": "Dit duurt doorgaans 10 minuten of minder."
      }
    }
  },
  "settings": {
    "customFields": {
      "addCustomField": "Aangepast veld toevoegen",
      "fieldKey": "Veldsleutel",
      "fieldName": "Veldnaam",
      "idWillBeAdded": "ID wordt toegevoegd nadat de verloren reden is aangemaakt",
      "lostReasonID": "Verloren reden-ID",
      "placeholder": "Plaatshouder"
    },
    "locationMailGun": {
      "bccAddress": "BCC-contactpersoon",
      "clearError": "Fout wissen",
      "deleteConfirmationMessage": "Met deze actie wordt de Mailgun-verbinding verwijderd.",
      "deleteConnection": "Verwijder verbinding",
      "domain": "Domein",
      "domainsAvailable": "{count} beschikbaar",
      "invalidApiKey": "Ongeldige API-sleutel",
      "selectDomain": "Selecteer domein"
    },
    "locationWallet": {
      "fetchTransactionDetailsError": "Fout bij het ophalen van transactiegegevens",
      "transactions": "Transacties"
    },
    "noShowSMS": {
      "smsWithImage": "No-show SMS met afbeelding",
      "title": "Recensie-sms aanpassen"
    },
    "optOut": {
      "addKeywords": "Voeg een van de volgende opt-out keywords toe: STOP, ALLES STOPPEN, UITSCHRIJVEN, ANNULEREN, AFSLUITEN.",
      "customizeTitle": "Opt-out bericht aanpassen",
      "disableConfirm": "Weet u zeker dat u het Opt Out-bericht wilt uitschakelen?",
      "disableOptOut": "Opt-out uitschakelen",
      "disableTitle": "Afmeldingsbericht uitschakelen?",
      "optInConfirmClient": "Ik bevestig dat ik ervoor zal zorgen dat sms-berichten alleen worden verzonden naar de contacten die zich hebben aangemeld.",
      "quickTipMessage": "De Starter post die u naar een persoon uploadt, moet een van de volgende normale opt-out zoekwoorden bevatten: STOP, ALLES STOPPEN, UITSCHRIJVEN, ANNULEREN, AFSLUITEN of QUIT.",
      "reallyDisableConfirm": "Weet u echt zeker dat u het afmeldbericht wilt uitschakelen?"
    },
    "payments": {
      "logViewer": {
        "requestPostBody": "POST-body opvragen",
        "requestQueryParameters": "Queryparameters opvragen",
        "responseBody": "Responsbody"
      },
      "logs": "Logs",
      "logsPage": {
        "clearAll": "Alles wissen",
        "loadMore": "Meer laden",
        "price": "Prijs",
        "product": "Product",
        "tabsAriaLabel": "Tabbladen met betalingslogboeken"
      }
    },
    "senderInfo": {
      "addGeneralTextAt": "Voeg algemene tekst toe aan",
      "beginning": "Begin",
      "complianceConfirm": "Ik bevestig dat ik ervoor zal zorgen dat alle sms-berichten die vanaf dit account worden verzonden, in overeenstemming zijn met het huidige beleid.",
      "customizeTitle": "Algemene tekst aanpassen",
      "disableConfirm": "Weet u zeker dat u SenderID wilt uitschakelen?",
      "disableSenderID": "Afzender-ID uitschakelen",
      "disableTitle": "SenderID uitschakelen?",
      "end": "Einde",
      "pleaseAdd": "Voeg {text} toe zoals vermeld in de snelle tip.",
      "quickTipMessage": "Het eerste bericht dat u naar een persoon stuurt, moet de identificatiegegevens van de afzender bevatten. Voeg {text} toe in het algemene tekstvak.",
      "reallyDisableConfirm": "Weet u echt zeker dat u SenderID wilt uitschakelen?",
      "senderID": "Afzender-ID"
    },
    "shopify": {
      "adminApiAccessToken": "Admin API-toegangstoken",
      "apiTokenRequired": "API-toegangstoken is vereist",
      "checkDocumentation": "Controleer deze documentatie voor meer informatie",
      "checkmark": "✓",
      "cross": "✗",
      "customAppApiAccessToken": "Aangepaste App API toegangstoken",
      "deleteWarning": "Als u dit verwijdert, wordt de bestaande verbinding verwijderd.",
      "existStoreAlertTitle": "Shopify-winkelintegratie bestaat al",
      "integration": "Shopify-integratie",
      "integrationHealth": "Integratiegezondheid",
      "orders": "Bestellingen",
      "scopePermissionsWarning": "Zorg ervoor dat uw app rechten krijgt die met een rood kruis zijn gemarkeerd",
      "scopes": "Bereiken",
      "scopesDescription": "Autorisatiescopes zijn vereist om toegang te krijgen tot de Shopify-informatie. Door recente wijzigingen in Shopify is de read_customers nu verplicht om alle informatie van klanten te verkrijgen, vanwege de door Shopify beschermde klantgegevens.",
      "storeConnectedMessage": "Shopify-winkel al verbonden met sub-account {locationName}",
      "storeNameHelp": "De naam van uw winkel is te vinden op de URL van uw Shopify-account -- na https:// en vóór .myshopify.",
      "storeNameLabel": "Naam van uw Shopify-winkel",
      "storeNamePlaceholder": "winkelnaam",
      "storeNameRequired": "De naam van de winkel is vereist",
      "typeRemoveConfirm": "Typ 'VERWIJDEREN' om te bevestigen",
      "webhooks": "Webhooks",
      "webhooksDescription": "Om alle gebeurtenissen van Shopify te ontvangen, moeten we deze Shopify-webhooks registreren tijdens het integratieproces. Deze webhooks zijn belangrijk om de goede werking van Shopify-eigenschappen te waarborgen."
    },
    "slack": {
      "accountConnected": "gekoppelde account",
      "accountsConnected": "gekoppelde accounts",
      "accountsList": "Lijst van alle Slack-accounts",
      "added": "Toegevoegd {date}",
      "connectChannel": "Verbind uw Slack-platform",
      "description": "Ontvang rechtstreekse meldingen op uw Slack-platform. Klik op 'Koppelen' om een Slack-kanaal toe te voegen.",
      "manage": "Beheren",
      "manageAccounts": "Slack-account beheren",
      "noIntegrations": "Er zijn geen Slack-integraties gevonden."
    },
    "smtpService": {
      "addFirstService": "Voeg uw eerste SMTP-service toe.",
      "addService": "Service toevoegen",
      "bccEmails": "BCC-e-mails",
      "cannotDeleteDefaultProvider": "U kunt de standaard aanbieder niet verwijderen.",
      "contactDeveloper": "Neem contact op met de ontwikkelaar van deze app.",
      "customProvider": "Aangepaste aanbieder",
      "defaultProvider": "Standaard aanbieder",
      "defaultProviderUpdated": "De standaard aanbieder is succesvol geüpdatet!",
      "emailDomain": "E-mail / Domein",
      "emailService": "E-MAIL-service",
      "enableReplyTracking": "Antwoorden bijhouden inschakelen",
      "forwardToAssignedUser": "Doorsturen naar toegewezen gebruiker",
      "providerType": "Type aanbieder",
      "smtpConnectionIssue": "Er is een probleem met deze SMTP-verbinding. Verbind deze integratie opnieuw.",
      "useLcEmailMessage": "Gebruik LC Email om e-mails te versturen voor uw agentschap en uw klanten."
    },
    "socialPosting": {
      "automaticPostingEnabled": "Automatisch plaatsen ingeschakeld",
      "dailyPostLimit": "Dagelijkse postinglimiet",
      "directoriesDescription": "Wanneer u een nieuwe review ontvangt, plaatsen we deze automatisch in 80+ online directories die uw merk en SEO helpen groeien.",
      "directoriesTitle": "80+ Directories en Websites",
      "fivePosts": "5 posts",
      "fiveStars": "5 sterren",
      "fourPosts": "4 posts",
      "fourStars": "4 sterren",
      "googlePlus": "Google+",
      "manageSettingsDescription": "Aanpassen hoe en wanneer uw recensies automatisch op elk van uw sociale media worden geplaatst.",
      "manageSettingsTitle": "Beheer uw instellingen voor social postings",
      "postReviewsForRating": "Deel recensies voor deze sterwaardering of hoger.",
      "searchEngines": "Zoekmachines",
      "threePosts": "3 posts",
      "threeStars": "3 sterren",
      "title": "Social postings plaatsen"
    },
    "tags": {
      "addNewTag": "Nieuwe tag toevoegen",
      "allTags": "Alle tags",
      "deletedTags": "Tags verwijderen",
      "here": "hier.",
      "newTag": "Nieuwe tag",
      "noTagsYet": "Nog geen tags om te tonen",
      "searchTags": "Tags zoeken",
      "viewDeletedTags": "U kunt verwijderde zoekwoorden bekijken en terugzetten op de pagina Auditlogboeken"
    },
    "templateMessage": {
      "addEmailTemplate": "E-mailsjabloon toevoegen (Snippet)",
      "addTemplate": "Sjabloon toevoegen (Snippet)",
      "addTextTemplate": "Tekstsjabloon toevoegen (Snippet)",
      "body": "Body",
      "deleteTemplateConfirmation": "Weet u zeker dat u dit sjabloon wilt verwijderen?",
      "templatesCount": "{count} sjablonen",
      "title": "Berichtsjablonen (Snippets)"
    },
    "unsubscribe": {
      "content": "Content",
      "contentTooltip": "De inhoud van dit bericht zal automatisch aan alle e-mails worden toegevoegd.",
      "customizeTitle": "Afmeldinhoud aanpassen",
      "disableConfirm": "Weet u zeker dat u de afmeldlink uit e-mail wilt uitschakelen?",
      "disableTitle": "Afmeldlink uitschakelen?",
      "disableUnsubscribe": "Afmelden uitschakelen",
      "pleaseAddTag": "Voeg de tag /*uitschrijven*/ toe",
      "reallyDisableConfirm": "Weet u echt zeker dat u de afmeldlink in de e-mail wilt uitschakelen?",
      "subscribedConfirm": "Ik bevestig dat e-mails alleen worden verzonden naar contactpersonen die zich hebben geabonneerd op het ontvangen van e-mails.",
      "subscribedConfirmClient": "Ik bevestig dat ik ervoor zal zorgen dat e-mails alleen worden verzonden naar contacten die zich hebben geabonneerd op het ontvangen van e-mails.",
      "suspensionWarning": "Niet-conforme activiteiten kunnen leiden tot de opschorting van de e-mailfuncties van uw account.",
      "tagRequirement": "De eerste e-mail die u naar een individu stuurt, moet de tag /*uitschrijven*/ bevatten."
    },
    "callAndVoicemailSettings": {
      "defaultVoicemailMessage": "Dit is het standaard voicemailbericht voor alle Twilio-nummers op de locatie, tenzij het is aangepast onder",
      "forwardCallsToWebApp": "Uw oproepen doorsturen naar de webapp",
      "forwardCallsToMobileApp": "Gesprekken doorschakelen naar mobiele app",
      "dedicatedNumberRequiredInfo": "Dit is alleen nodig als de gebruiker een speciaal nummer nodig heeft. Niet vereist voor voicemail of voor het doorverbinden van de oproep naar de toegewezen gebruiker.",
      "voicemailMessageInfo": "Dit voicemailbericht zal worden afgespeeld in plaats van het bericht van de telefoonprovider. Wij raden een timeout van 20 seconden of minder aan.",
      "noTimeout": "Geen timeout",
      "10Secs": "10 sec.",
      "20Secs": "20 seconden",
      "voicemailMessageDuration": " We zullen een voicemail opnemen als de oproep niet binnen deze duur wordt beantwoord",
      "saveCallSettings": "Belinstellingen opslaan"
    },
    "elizaFAQSetting": {
      "bypassElizaNote": "Wanneer de contactpersoon deze tag heeft, zullen die berichten NIET bij Eliza worden afgeleverd",
      "sendToElizaNote": "Standaard worden alle gesprekken naar Eliza verzonden. Als deze tag is geconfigureerd, <br />worden de nieuwe gesprekken alleen naar Eliza verzonden, wanneer een contactpersoon deze tag heeft.<br /> Als zowel de Eliza-bypasstag als de Send to Eliza-tag zijn geconfigureerd, wordt alleen de Send to Eliza-tag gehonoreerd.",
      "permissionNote": "Uw gebruikersrechten zijn niet ingeschakeld voor deze pagina. <br />Neem contact op met uw beheerder",
      "addFAQ": "FAQ toevoegen"
    },
    "locationSettings": {
      "ownCardWarning": "Voeg uw eigen kaart niet toe aan sub-accounts!",
      "addClientCardWarning": "Voeg de kaart van uw klant (subaccount) toe en niet uw eigen kaart, aangezien deze kaart gebruikt zal worden om uw klant namens u te factureren.",
      "stripeConnectMissing": "Stripe Connect ontbreekt",
      "pleaseContactAgencyToAddPaymentMethods": "Neem contact op met het agentschap ({email}) om betaalmethodes toe te voegen."
    },
    "integrations": {
      "connectWaveAccount": "Verbind de Wave-account van uw locatie",
      "connectXeroAccount": "Verbind de Xero-account van uw locatie"
    },
    "gmbSettings": {
      "gbpCallTrackingEnabledOnAnotherSubAccount": "GBP-gesprekstracering is ingeschakeld op een ander subaccount. Gesprekstracering kan slechts op één subaccount tegelijk worden ingeschakeld.",
      "gbpCallTrackingEnabledOnAnotherPage": "GBP-gesprekstracering is ingeschakeld op een andere pagina ({pageName}). Gesprekstracering kan op één subaccount en één pagina per locatie tegelijk worden ingeschakeld.",
      "gbpCallsProperlySetup": "GBP-gesprekken zijn correct ingesteld en gesprekken komen binnen via",
      "tooManyEditsToPrimaryPhone": "U heeft te veel aanpassingen voor de primaire telefoon voor dit bedrijf doorgevoerd. Probeer het later opnieuw.",
      "setupTwilioToStartCallTracking": "Stel Twilio in om gesprekken te beginnen volgen",
      "twoSecondaryNumbersSetupAlready": "U heeft al 2 secundaire nummers ingesteld, u kunt het nummer niet wisselen.",
      "yourAgentIDIs": "Uw agent-ID is"
    },
    "numberPool": {
      "title": "Wat te Volgen",
      "tracking": {
        "percentComplete": "34% voltooid",
        "searchLower": "zoeken"
      },
      "create": {
        "title": "Trackingnummer aanmaken"
      }
    },
    "phoneNumbers": {
      "title": "Wat te volgen",
      "tracking": {
        "percentComplete": "34% voltooid",
        "heading": "Trackingnummer aanmaken"
      }
    }
  },
  "smartList": {
    "filterMultiInput": {
      "enterValue": "* Voer een waarde in",
      "selectOption": "* Selecteer een optie"
    },
    "filterMultiSelections": {
      "atLeastOneRequired": "* Minimaal één {filterName} is vereist",
      "select": "Selecteer {filterName}"
    },
    "newEmailStats": {
      "timeStamp": "Tijdstempel"
    },
    "recordsNav": {
      "clickToReloadList": "Klik om de lijst opnieuw te laden"
    },
    "reviewRequestActions": {
      "emailReviewReq": "E-mailverzoeken om recensies",
      "smsReviewReq": "Sms-verzoek om feedback",
      "whatsappReviewReq": "WhatsApp-verzoek om feedback"
    },
    "smartListFilters": {
      "clearAllFilters": "Alle filters wissen",
      "noneFound": "geen gevonden",
      "saveChangesToList": "Filterwijzigingen opslaan in deze slimme lijst",
      "saveCombinationAsNew": "Combinatie van filters, kolommen en sortering opslaan als nieuwe slimme lijst",
      "saveCurrentAsNew": "Huidige filters opslaan als nieuwe slimme lijst",
      "searchAndAddFilter": "Zoeken en filter toevoegen",
      "searching": "zoeken...",
      "undoUnsavedChanges": "Niet-opgeslagen wijzigingen ongedaan maken"
    },
    "smsStatsPanel": {
      "smsStats": "Sms-statistieken"
    },
    "manageDuplicates": "Beheer duplicaten",
    "emailAction": {
      "attachFiles": "Bestanden bijvoegen",
      "customValues": "Aangepaste waarden",
      "triggerLinks": "Triggerlinks"
    },
    "atLeastOneRequired": "* Minimaal één {filterName} is vereist",
    "arrayInput": {
      "searchPlaceholder": "Zoek {filterName}",
      "searching": "Zoeken..."
    }
  },
  "snapshots": {
    "common": {
      "errorWhileFetchingSnapshotContents": "Fout bij het ophalen van de inhoud van snapshots",
      "overwriteAll": "Alles overschrijven",
      "skipAll": "Alles overslaan",
      "somethingWentWrongWhileFindingConflicts": "Er is iets misgegaan bij het vinden van conflicten",
      "step": "Stap"
    },
    "confirmOverwrite": {
      "confirmButton": "Overschrijven bevestigen",
      "description": "Deze actie is onomkeerbaar en kan de instellingen van campagnes, potentiële klanten, trechters, enz. wijzigen. Bevestig uw actie door Volgend in het feedbackveld te typen.",
      "title": "Weet u zeker dat u de geselecteerde statistieken wilt overschrijven?"
    },
    "conflicts": {
      "noConflictsDetected": "Geen conflicten gedetecteerd",
      "overwrite": "Overschrijven"
    },
    "pushCloneAccount": {
      "assetsFoundLinked": "Gekoppelde assets gevonden",
      "checkingConflicts": "Controleren op conflicten",
      "chooseSnapshot": "Kies een snapshot",
      "copyingDataNotification": "Gegevens kopiëren naar geselecteerde locaties. Een ogenblik geduld...",
      "linkedLocations": "Gekoppelde locaties",
      "noConflictsFound": "Er zijn geen conflicten gevonden",
      "notAuthorizedMessage": "Alleen beheerders van het agentschap kunnen deze actie uitvoeren",
      "overwriteConflicts": "Conflicten overschrijven",
      "pickSnapshot": "Selecteer een Snapshot",
      "response": "Reactie",
      "selectAssetsToPush": "Selecteer assets om te pushen",
      "selectLocationsToUpdate": "Selecteer locaties om te updaten",
      "snapshotNotAuthorized": "Deze snapshot is niet toegestaan voor deze locatie",
      "snapshotNotSelected": "Snapshot niet geselecteerd"
    },
    "share": {
      "agencyRestrictedLink": "Beperkte link voor bureau",
      "deleteShareLink": "Deellink verwijderen",
      "editShareLink": "Deellink bewerken",
      "permanentLink": "Permanente link",
      "subaccountRestrictedLink": "Sub-account beperkte link"
    },
    "shareSnapshot": {
      "addCommaAfterEach": "(Voeg een komma (<span class='text-base font-bold'> , </span>) toe na elk relatienummer)",
      "addCommaAfterEachSubAccount": "(Voeg een komma (<span class='text-base font-bold'> , </span>) toe na elke subaccount-id)",
      "atLeast1EmailRequired": "Minimaal 1 e-mail vereist.",
      "emailShareLink": "Link voor delen van e-mail",
      "enterOnePerLine": "(Vul er één per regel in)",
      "errorGettingLink": "Er is iets misgegaan bij het ophalen van de link. Opnieuw proberen later.",
      "getAgencyRestrictedLink": "Ontvang agentschap beperkte link",
      "getLink": "Link ophalen",
      "getOneTimeLink": "Link voor eenmalig delen ophalen",
      "getPermanentLink": "Permanente link ophalen",
      "getSubAccountRestrictedLink": "Ontvang beperkte link voor sub-account",
      "shareType": "Type delen",
      "title": "Snapshot delen"
    },
    "snapshot": {
      "copySnapshotID": "Snapshot-ID kopiëren",
      "deleteSnapshot": "Snapshot verwijderen",
      "editSnapshot": "Snapshot bewerken",
      "pushUpdate": "Update pushen naar gekoppelde accounts",
      "refreshSnapshot": "Snapshot vernieuwen"
    },
    "updateShareLink": {
      "addCommaAfterEach": "(voeg een komma toe na elke relatienummer)",
      "addCommaAfterEachSubAccount": "(Voeg een komma toe na elke sub-account-ID)",
      "title": "Update deellink"
    }
  },
  "socialMedia": {
    "engagement": "Betrokkenheid",
    "potentialReach": "Potentieel bereik",
    "storiesCreated": "Verhalen aangemaakt",
    "recentPosts": "Recente berichten",
    "notConnected": "Niet verbonden (Nu verbinden!)",
    "totalAudience": "Totale doelgroep",
    "activeAudience": "Actieve doelgroep",
    "socialMediaOverview": "Overzicht sociale media"
  },
  "suspendModal": {
    "currentStatus": "Huidige abonnementstatus: Gepauzeerd",
    "instructions": "U moet een paar eenvoudige stappen voltooien om dit sub-account te {action}",
    "nextBillingDate": "Volgende factuurdatum :",
    "noKeepCharging": "Nee, blijf de klant kosten in rekening brengen.",
    "pauseSubscriptionQuestion": "Wilt u ook het abonnement van het sub-account pauzeren?",
    "resumeSubAccount": "Sub-account hervatten",
    "resuming": "Hervatten...",
    "saasSubscriptionActive": "Dit sub-account heeft een actief SaaS-abonnement.",
    "saasSubscriptionResumed": "Het SaaS-abonnement van dit account wordt hervat.",
    "yesPause": "Ja, pauzeer het abonnement"
  },
  "table": {
    "perPageOptions": {
      "5": "5 per pagina",
      "10": "10 per pagina",
      "15": "15 per pagina",
      "20": "20 per pagina",
      "25": "25 per pagina",
      "50": "50 per pagina",
      "100": "100 per pagina"
    },
    "filterPlaceholder": "Zoeken...",
    "emptyText": "Geen records gevonden",
    "loading": "Aan het laden...",
    "showingEntries": "Weergeven {from} tot {to} van {total} vermeldingen",
    "noEntriesToShow": "Er zijn geen vermeldingen om weer te geven"
  },
  "templateLibrary": {
    "public": {
      "loadingAccountData": "Accountgegevens worden geladen...",
      "toContinueWith": "om verder te gaan met"
    },
    "switcherModal": {
      "comingSoon": "Binnenkort beschikbaar!",
      "multiLocationMessage": "Deze functie is nu alleen beschikbaar voor individuele accounts. We doen ons best om dit binnenkort ook voor accounts met meerdere contactpersonen mogelijk te maken."
    },
    "importedMessage": "{productName} geïmporteerd! Ga naar de Sjablonenbibliotheek en kijk onder het tabblad {productName}.",
    "permissionErrorMsg": "Deze optie is alleen beschikbaar bij hogere abonnementen. Upgrade nu om dit te ontgrendelen.",
    "errors": {
      "sourceDeleted": "Fout: Het bronsjabloon is verwijderd. Het is niet meer beschikbaar. Controleer de status van het sjabloon of neem contact op met de bron voor hulp.",
      "sourceDraft": "Fout: het bronsjabloon is naar uw concepten verplaatsr. Controleer de status van het sjabloon of neem contact op met de bron voor hulp.",
      "linkedDeleted": "Fout: Het aan het gedeelde sjabloon gekoppelde bronsjabloon werd verwijderd. Controleer de status van het sjabloon of neem contact op met de bron voor hulp.",
      "fetchError": "Er lijkt een fout te zijn opgetreden bij het ophalen van de gegevens van {productName}. Controleer de URL of probeer het opnieuw!",
      "sameAgency": "U kunt geen sjabloon delen binnen hetzelfde agentschap"
    }
  },
  "triggers": {
    "addContactTagRequiresTag": "Contactpersoontag toevoegen vereist tag.",
    "addNotesRequiresData": "De actie Notities toevoegen vereist notitiegegevens.",
    "addTaskRequiresFields": "Actie Taak toevoegen vereist titel en deadline op dag.",
    "addToCampaignRequiresCampaign": "Actie Toevoegen aan campagne vereist een campagne.",
    "addToCustomAudienceRequires": "Toevoegen aan aangepaste doelgroepactie vereist advertentieaccount en aangepaste doelgroep.",
    "addTrigger": "Trigger toevoegen",
    "anyAction": "Elke actie",
    "anyCondition": "Elke voorwaarde",
    "brokenCustomVariables": "Sommige veld(en) bevatten niet werkende aangepaste variabelen, corrigeer ze voordat u opslaat.",
    "conditionCannotBeEmpty": "Voorwaarde '{condition}' mag niet leeg zijn",
    "confirmDeleteTrigger": "Weet u zeker dat u deze trigger wilt verwijderen?",
    "customDateFieldRequired": "Een filter voor het aangepaste datumveld is vereist voor de aangepaste datumherinneringstrigger",
    "detailPage": {
      "chooseTriggerPlaceholder": "Selecteer een trigger",
      "lastUpdate": "Bijgewerkt op:",
      "loopIdentifiedWarning": "Deze trigger is vergrendeld in de status Concept omdat deze een loop veroorzaakt. Neem contact op met de ondersteuning om deze trigger te activeren.",
      "ruleNotActiveWarning": "Deze regel zal niet worden uitgevoerd totdat u deze activeert.",
      "triggerCreation": "Trigger aanmaken:",
      "triggerDeletedPrompt": "Deze trigger is verwijderd! Wilt u deze terugzetten?",
      "triggerRunDailyTooltip": "Trigger run dagelijks om 8:00",
      "whatTriggersRule": "Wat zou deze regel moeten triggeren?",
      "whichEventTriggersAutomation": "Welke gebeurtenis zou deze automatisering moeten triggeren?"
    },
    "dndContactRequiresState": "De actie Contact niet storen (DND) vereist DND-status om in te stellen.",
    "emptyConditionNotAllowed": "Lege voorwaarde is niet toegestaan.",
    "emptyFieldNotAllowed": "Leeg veld is niet toegestaan.",
    "executeWebhookRequiresUrl": "Actie Webhook uitvoeren vereist webhook-URL.",
    "fieldCannotBeEmpty": "{field} mag niet leeg zijn",
    "fillRequiredFields": "Vul alle vereiste velden in de acties in.",
    "googleAdwordsRequiresConversion": "Actie Toevoegen aan Google Adwords vereist conversie.",
    "googleAnalyticsRequiresFields": "De actie Toevoegen aan Google Analytics vereist tracking-ID, actietype en actiecategorie",
    "membershipGrantOfferRequiresOffer": "Actie voor het aanbieden van lidmaatschapssubsidies vereist een aanbod.",
    "membershipRemoveOfferRequiresOffer": "Actie voor het aanbieden van lidmaatschapsverwijdering vereist een aanbod.",
    "newBasicRule": "Nieuwe basisregel",
    "opportunitiesRequirePipeline": "Activiteiten voor potentiële klanten vereisen dat u op een pijplijn klikt.",
    "opportunityLoopWarning": "Deze trigger zorgt ervoor dat er een lus ontstaat om kansen te creëren. Verwijder de optie ‘Dubbele kansen toestaan’ of pas de fase aan waar u naar verwijst.",
    "removeContactTagRequiresTag": "Actie voor het verwijderen van een contactpersoontag vereist een tag.",
    "removeFromCampaignRequiresCampaign": "De actie Campagne wissen vereist een campagne.",
    "removeFromCustomAudienceRequires": "Actie Verwijderen van Facebook Custom Audience vereist advertentieaccount en toevoegen aan Facebook Custom Audience.",
    "rulesBasedOn": "regels gebaseerd op",
    "selectUserForNotification": "Selecteer gebruiker voor verzendmelding.",
    "sendEmailRequiresFields": "De actie E-mail verzenden vereist een afzender, ontvanger, onderwerp en bericht.",
    "sendNotificationRequiresFields": "De actie Melding versturen vereist titel, body en gebruikerstype om de melding te verzenden.",
    "sendSmsRequiresFields": "De actie sms verzenden vereist nummer en bericht.",
    "stripeMinAmountUSD": "Het aantal moet groter dan of gelijk zijn aan 50 USD cent.",
    "stripeRequiresFields": "De actie Stripe eenmalige kosten vereist klant-ID, bedrag en valuta",
    "thatWillFire": "die zal worden geactiveerd",
    "triggerCannotBeEmpty": "Trigger mag niet leeg zijn",
    "updateContactFieldRequires": "Het contactpersoonveld updaten zou minstens één ingesteld veld moeten bevatten."
  },
  "workflow": {
    "resellPaywall": {
      "buttonText": "Betaal ${amount} en meld u aan",
      "commitment": "Geen verplichting, u kunt op elk moment annuleren",
      "features": {
        "billedOnUsage": "Gefactureerd op basis van gebruik nadat de limiet is overschreden",
        "externalAI": "Acties van extern AI Model uitgesloten; deze worden apart gefactureerd",
        "leadingPricing": "De beste prijsstelling!",
        "monthlyPurchase": "Geldig voor één Kopen per Maand",
        "premiumActions": "Van toepassing op premium activiteiten en triggers"
      },
      "planDetails": "Details plan",
      "subscribeAndSave": "Abonneer u en bespaar vandaag nog!",
      "title": "${amount} voor {executions} uitvoeringen per maand"
    }
  },
  "appointmentWidget": {
    "movedMessage": "Deze instelling is verplaatst naar de agendapagina.",
    "toNavigate": "hier om te navigeren. Deze pagina wordt binnenkort verwijderd."
  },
  "attribution": {
    "description": "De eerste interactie is simpelweg het eerste contactmoment dat een gebruiker heeft. Dus als iemand u voor het eerst ontdekt via een betaalde zoekadvertentie (PPC), krijgt dat kanaal de eer als het gaat om een conversie. Aan de andere kant zou de laatste interactie het laatste kanaal zijn.",
    "firstInteraction": "Eerste interactie",
    "lastInteraction": "Laatste interactie",
    "title": "Toewijzing"
  },
  "campaign": {
    "addEvent": "Gebeurtenis toevoegen",
    "a2p": {
      "address": {
        "chooseState": "Kies een provincie...",
        "city": "Stad*",
        "postalCode": "Postcode*",
        "streetAddress": "Straatnaam*",
        "streetAddressHelper": "Moet een geldig adres zijn dat aan uw bedrijf is gekoppeld.",
        "title": "Bedrijfsadres"
      },
      "addressError": {
        "title": "Indienen adres mislukt"
      },
      "authorizedRep": {
        "jobPosition": "Functie*",
        "jobTitle": "Functietitel*",
        "title": "Gegevens van de geautoriseerde vertegenwoordiger"
      },
      "brandDetails": {
        "solePropBrand": {
          "heading": "Enig Pprop-merk",
          "point1": "Slechts 1 telefoonnummer toegestaan",
          "point2": "EIN/SSN/DUNS niet vereist"
        },
        "solePropCampaign": {
          "heading": "Sole Prop-campagne",
          "point1": "Er mag slechts 1 nummer worden gekoppeld aan een Sole Prop-campagne",
          "point2": "Zodra dit is goedgekeurd, wordt uw standaardnummer automatisch gekoppeld.",
          "infoText": "U kunt het aantal ook bijwerken nadat het is goedgekeurd",
          "warningText": "Er mag slechts 1 nummer worden gekoppeld aan een Sole Prop-campagne. Na goedkeuring wordt uw standaardnummer automatisch gekoppeld. U kunt het nummer ook na goedkeuring bijwerken."
        },
        "solePropSubtitle": "Gegevens Sole Prop-merk en -campagne",
        "standardBrand": {
          "heading": "$ 4,41 - Eenmalig",
          "point1": "EIN/SSN/DUNS vereist",
          "point2": "Meer dan 1 telefoonnummer toegestaan"
        },
        "standardCampaign": {
          "heading": "€ 16,54 - Eenmalig",
          "point1": "Er mag meer dan 1 nummer aan een standaardcampagne worden gekoppeld",
          "point2": "EIN/SSN/DUNS vereist",
          "infoText": "Er geldt een extra campagnevergoeding van maximaal $ 12 per maand in overeenstemming met de TCR-regels."
        },
        "standardSubtitle": "Gegevens standaardmerk en -campagne",
        "title": "Gegevens merk en campagne"
      },
      "businessInfo": {
        "soleProp": {
          "contactInfo": "Contactgegevens",
          "contactInfoSubtitle": "Dit kan elke persoon zijn die indien nodig vragen over dit merk kan beantwoorden. Houd er rekening mee dat u contactgegevens niet kunt hergebruiken tussen merken. Elk merk dat u aanmaakt, moet unieke contactgegevens hebben.",
          "emailHelper": "Gebruik niet hetzelfde e-mailadres voor meer dan 5 merken.",
          "phoneNumberHelper": "Gebruik niet hetzelfde telefoonnummer voor meer dan 5 merken.",
          "profileName": "Bedrijfsnaam of uw voor- en achternaam*",
          "profileNameHelper": "Gebruik de juridische naam van de organisatie die de berichten verstuurt, of uw eigen naam als dit merk niet voor een organisatie is.",
          "nextLoading": "Volgende...",
          "invalidPhoneNumber": "Ongeldig telefoonnummer",
          "phoneNumberWithCountryCode": "Telefoonnummer (met landcode)*",
          "phoneNumberRequired": "Telefoonnummer is vereist.",
          "emailRequired": "E-mailadres is vereist.",
          "profileNameRequired": "Profielnaam is vereist."
        },
        "standard": {
          "businessType": "Bedrijfstype*",
          "legalBusinessName": "Juridische bedrijfsnaam*",
          "legalBusinessNameHelper": "Voer de exacte bedrijfsnaam in, zoals geregistreerd bij de overheid en vermeld in uw belastingdocumenten (CP 575). Bijv. Leadconnector LLC in plaats van Leadconnector.",
          "regionsOfOperations": "Bedrijfsregio's van de activiteiten*",
          "registrationNumber": "KVK-nummer*",
          "registrationNumberHelper": "Het nummer dat wordt gebruikt om uw bedrijf te identificeren. In het geval van een Amerikaans EIN moet dit een 9-cijferig nummer zijn, bijvoorbeeld 12-3456789.",
          "registrationType": "Type bedrijfsregistratie-ID",
          "website": "Bedrijfswebsite*"
        }
      },
      "businessProfileRegistration": {
        "stepProgress": "Stap {currentStep} van {businessInfoSteps}"
      },
      "businessProfileSuccess": {
        "message": "Uw bedrijfsprofiel is ingediend.",
        "startA2P": "A2P-registratie starten",
        "title": "Bedrijfsprofiel ingediend",
        "tooltips": {
          "agency": "Gebruikers van het agentschap kunnen de A2P-registratie starten",
          "location": "Locatiegebruikers kunnen beginnen met de A2P-registratie"
        }
      },
      "campaign": {
        "endUserConsent": {
          "closeExample": "Voorbeeld sluiten",
          "optInKeywords": "Opt-in zoekwoorden*",
          "optInKeywordsHelper": "Maximale lengte: 255 tekens.",
          "optInKeywordsPlaceholder": "Zoekwoorden gescheiden door komma, Voorbeeld: ABONNEREN, START.",
          "optInMessage": "Opt-in bericht*",
          "optInMessageInfo": "Moet bedrijfsnaam en een opt-out zoekwoord bevatten",
          "optInMessagePlaceholder": "Voorbeeld: U heeft zich met succes aangemeld voor het ontvangen van meldingen en promotionele sms-berichten van company_name. Stuur STOP als u zich in de toekomst wilt afmelden.",
          "placeholder": "Voorbeeld: Eindgebruikers melden zich aan door naar https://www.mycompany.com/book te gaan en hun gegevens in te vullen. Gebruikers vinken een vakje aan om meldingen en promotionele berichten van ons te ontvangen en daarmee hun toestemming te geven. Daarnaast kunnen eindgebruikers ook START sms'en naar +1 (213) 725-2867.",
          "question": "Hoe geven eindgebruikers toestemming om berichten te ontvangen?*",
          "seeExample": "Voorbeeld bekijken"
        },
        "messageDetails": {
          "embeddedLink": "Het bericht zal een ingesloten link bevatten",
          "phoneNumbers": "De berichten zullen telefoonnummers bevatten",
          "sampleMessage1Placeholder": "Voorbeeld: Hallo John! Dit is Jane van company_name. Onze afspraak op 20 juli om 11:00 uur is bevestigd. Neem contact op met +1(213) 725-2867 als u de afspraak moet verzetten. Antwoord met STOP om u af te melden.",
          "sampleMessage2Placeholder": "Voorbeeld: Hallo Brian! Dit is Jane van company_name. Ik zie dat u niet aanwezig was op onze afspraak. Zou u uw afspraak willen verzetten? - https://www.mycompany.com/book. Antwoord STOP om u af te melden.",
          "sampleMessageInfo": "Moet de naam van de lead, uw naam, bedrijfsnaam en opt-outtaal bevatten",
          "subtitle": "Voorbeeldberichten toevoegen"
        },
        "useCaseDetails": {
          "explainInDetail": "Geef een gedetailleerde toelichting",
          "pickUseCase": "Gebruiksscenario campagne selecteren",
          "solePropLabel": "Eenmanszaak",
          "subtitle": "Voer de campagnegegevens en -beschrijving in",
          "useCase": "Gebruiksscenario campagne*",
          "useCaseDescription": "Beschrijving gebruiksscenario*",
          "useCaseDescriptionPlaceholder": "Voorbeeld: Deze campagne verzendt afspraakinformatie - bevestigings- en herinneringsberichten naar onze klanten zodra zij een afspraak met ons hebben geboekt op onze website en zich hebben aangemeld voor het ontvangen van promotionele en informatieve sms-berichten van ons."
        }
      },
      "einModal": {
        "disableNoEINText": "Alleen bedrijven met een geldig adres in de VS en Canada mogen het A2P-merk registreren zonder belastings-ID.",
        "hasEIN": "Ja, het bedrijf dat ik registreer heeft een belasting-ID (bijv. EIN, CCN enz.).",
        "infoText": "U vindt uw Amerikaanse EIN op uw CP 575-formulier.",
        "noEIN": "Nee, het bedrijf dat ik registreer heeft geen belasting-ID (bijv. EIN, CCN enz.).",
        "question": "Heeft het bedrijf dat u registreert een belasting-ID (bijv. EIN, CCN enz.)?*",
        "title": "Bepaal de behoeften van het merk A2P"
      },
      "exampleModal": {
        "examples": "Voorbeelden"
      },
      "otpError": {
        "message": "Er ging iets mis bij het verzenden van de OTP.",
        "title": "OTP opnieuw verzenden mislukt"
      },
      "otpSuccess": {
        "title": "Uw OTP werd succesvol verzonden."
      },
      "validation": {
        "cityRequired": "Stad is vereist.",
        "countryRequired": "Land is vereist.",
        "invalidMobileNumber": "Ongeldig mobiel nummer",
        "postalCodeRequired": "Postcode is vereist.",
        "stateRequired": "Provincie is vereist.",
        "streetAddressRequired": "Straatnaam is vereist."
      }
    },
    "affiliates": {
      "affiliateAboutIframe": "affiliate-about-iframe",
      "agencyOwner": "Eigenaar agentschap",
      "agencyOwnerAndAdmins": "Eigenaar en beheerders agentschap",
      "contactAgencyOwner": "Voor hulp kunt u contact opnemen met uw",
      "firstPromoterAccessMessage": "Dit FirstPromoter-rapport is alleen toegankelijk via de",
      "firstPromoterIframe": "firstpromoter-iframe",
      "noPartnerFound": "Geen partner gevonden die overeenkomt met uw filters. Klik",
      "paymentDetailsAccessMessage": "Dit gedeelte met betalingsgegevens is alleen toegankelijk en bewerkbaar door de",
      "toApplyPartner": "om u aan te melden als partner."
    },
    "common": {
      "actions": {
        "googleDrive": "Google Drive"
      },
      "labels": {
        "doc": "Doc."
      },
      "loading": "Aan het laden",
      "legalBusinessNameHelper": "Voer de exacte bedrijfsnaam in, zoals geregistreerd bij de overheid en vermeld in uw belastingdocumenten (CP 575). Bijv. Leadconnector LLC in plaats van Leadconnector."
    },
    "desktop": {
      "highlevel": {
        "logoAltText": "HighLevel Logo",
        "launchingDescription": "Klik op <span class='font-semibold'>Open HighLevel</span> om de desktop-app te openen.<br>Werkt het niet? U kunt <a href=\"/\" class='!text-blue-700 hover:underline'>HighLevel ook in uw browser gebruiken</a>",
        "launchingTitle": "HighLevel Desktop starten",
        "launchButtonText": "Open HighLevel"
      },
      "leadconnector": {
        "logoAltText": "LeadConnector Logo",
        "launchingDescription": "Klik op <span class='font-semibold'>Open LeadConnector</span> om de desktop-app te openen.<br>Werkt het niet? U kunt <a href=\"/\" class='!text-blue-700 hover:underline'>LeadConnector ook in uw browser gebruiken</a>",
        "launchingTitle": "LeadConnector Desktop starten",
        "launchButtonText": "Open LeadConnector"
      }
    },
    "email": {
      "actionCard": {
        "chooseAction": "Selecteer een actie",
        "destination": "Bestemming",
        "removeFromAllCampaigns": "Deze actie verwijdert potentiële klanten uit alle campagnes behalve uit de huidige campagne",
        "triggerLinks": "Triggerlinks"
      },
      "importTemplate": {
        "errorImporting": "Fout bij het importeren van het sjabloon!",
        "importTemplate": "Sjabloon importeren",
        "importing": "Importeren",
        "title": "Sjabloon {entityName} importeren",
        "unnamedEntity": "Naamloze kopie {entityName}"
      },
      "lcEmail": {
        "migrationModal": {
          "below": "onder",
          "confirmByTyping": "Bevestigt u alstublieft door te typen",
          "confirmWord": "BEVESTIGEN",
          "existingNotMoved": "Als uw klant al Mailgun of SMTP-configuratie heeft, worden ze niet overgezet.",
          "notNow": "Niet nu",
          "pricingInfo": "LC Email is goedkoper dan Mailgun en kost ongeveer $ 0,68 voor 1000 e-mails",
          "setAsDefault": "LC Email instellen als de standaard aanbieder voor uw agentschap en klanten die nog geen Mailgun of SMTP hebben",
          "thisWill": "Dit zal:",
          "title": "U migreert naar Lead Connector-mail",
          "useLcEmail": "Gebruik LC-mail"
        }
      },
      "newPostModal": {
        "dragDropMedia": "Media hierheen slepen of neerzetten",
        "editPost": "Bericht bewerken",
        "enterText": "Voer hier tekst in",
        "exampleComment": "Geweldig!! Ik kijk hiernaar uit!",
        "exampleName": "Tech-test",
        "hashtag1": "#hashtag",
        "hashtag2": "#awesome",
        "hashtag3": "#cool",
        "imagePlaceholder": "img(02).png",
        "needReview": "Heb je een recensie nodig?",
        "network": "Netwerk",
        "photo": "foto",
        "previewPost": "Voorbeeldweergave bericht",
        "selectNetwork": "Selecteer sociaal netwerk",
        "sizeExample": "245kb",
        "textExample": "Lorem ipsum dolor sit amet consectetur adipisicing elit.",
        "urlExample": "https://searchengineland.com/google-announces-new-features-for-retail-advertisers-at-smx-advanced-300001"
      },
      "numberPool": {
        "confirmation": {
          "createdMultiple": "U hebt een nummerpool van {count} nummers aangemaakt om bezoekers op uw website te volgen. <br />Uw oproepen zullen worden doorgestuurd naar",
          "createdSingle": "U hebt {count} nummer gemaakt om bezoekers op uw website te volgen. <br />Uw oproepen zullen worden doorgestuurd naar",
          "percentComplete": "100% voltooid"
        },
        "create": {
          "correctErrors": "Corrigeer de fouten!",
          "forwardHelp": "Vertel ons welke telefoon moet overgaan wanneer de klant uw tracking telefoonnummer belt. Dit is meestal uw primaire zakelijke telefoonnummer. Voorbeeld: 404-555-1212",
          "heading": "Nummerpool en oproepdoorschakeling",
          "nameHelp": "De '{name}' is hoe we dit trackingnummer in uw account zullen aanduiden. Kies een korte en memorabele naam.",
          "newTrackingNumbers": "nieuwe trackingnummers.",
          "nextTracking": "Volgende: trackingopties",
          "percentComplete": "50% Voltooid",
          "pleaseConfirm": "Bevestig:",
          "poolSize": "Grootte pool",
          "poolSizeError": "Voer een poolgrootte in tussen 4 en 30 trackingnummers in.",
          "poolSizeHelp": "De omvang van uw nummerpool bepaalt bepaalt hoeveel mensen we tegelijk op uw website kunnen volgen. Uw poolgrootte zou een kwart van het piekuurverkeer moeten zijn dat in Google Analytics wordt gerapporteerd, met minimaal 4 cijfers.",
          "swappingHelp": "Vertel ons welk telefoonnummer we moeten wisselen op de website. Voorbeeld: 404-555-1212",
          "swappingNumber": "Nummer omwisselen",
          "validationError": "Er ging iets mis bij het valideren van het formulier"
        },
        "features": {
          "activateNumber": "Nummer activeren",
          "address": "{type} adres",
          "addressHelp": "Voor sommige landen is een adres vereist voor het aankopen van een nummer. Neem contact op met de ondersteuning over het toevoegen van een adres als u hulp nodig heeft.",
          "heading": "Nummerkenmerken",
          "leaveBlank": "Laat leeg voor geen bericht",
          "recordingDescription": "Activeer oproepopname en speel een kort bericht af voor de beller.",
          "recordingHelp": "Sommige rechtsgebieden vereisen dat beide partijen goedkeuring geven voor elke opgeslagen chat. Om te helpen in de naleving van deze wetten, kunt u een welkomstbericht opslaan om de beller te informeren dat het gesprek mogelijk wordt opgeslagen.",
          "whisperDescription": "Een kort bericht dat wordt afgespeeld vóór het gesprek. De beller hoort dit bericht niet."
        },
        "tracking": {
          "heading": "Trackingopties",
          "nextCreatePool": "Volgende: pool aanmaken",
          "percentComplete": "34% voltooid",
          "searchLower": "zoeken"
        },
        "whatToTrack": {
          "heading": "Wat wilt u volgen op uw site?",
          "trackCampaign": "Een marketingcampagne volgen",
          "trackCampaignDescription": "Maak één telefoonnummer dat alle bellers naar één marketingcampagne volgt.",
          "trackVisitor": "Volg de activiteit van bezoekers",
          "trackVisitorDescription": "Maak meerdere nummers die oproepen correleren met websitebezoekers, PPC-zoekwoorden en meer aan."
        }
      }
    },
    "loader": {
      "clickHereToRefresh": "klik hier om te vernieuwen.",
      "issuesLoadingApp": "Als u problemen ondervindt met het laden van de app",
      "loadingFreshData": "Nieuwe gegevens worden geladen...",
      "loadingNewSubAccountData": "Gegevens nieuwe subaccount laden..."
    },
    "login": {
      "bySigningInYouAgree": "Als u inlogt, gaat u akkoord met onze <a class='font-semibold text-curious-blue-500 hover:text-curious-blue-800' href='{termsConditionsURL}' target='_blank'>Algemene voorwaarden</a>",
      "newPasswordSent": "Er is een nieuw wachtwoord naar uw e-mail verzonden."
    },
    "regulatoryBundle": {
      "a2p": {
        "activityHistory": {
          "by": "Door:"
        },
        "affiliates": {
          "partnerBadgeAlt": "Partnerbadge"
        },
        "checkout": {
          "cardInformation": "Kaartgegevens",
          "cardNumberInvalid": "Uw kaartnummer is ongeldig.",
          "commitment": "verplichting",
          "consentOneTime": "Door te bevestigen, geeft u LeadConnector toestemming om uw kaart te belasten voor deze betaling.",
          "consentSubscription": "Door uw abonnement te bevestigen, geeft u LeadConnector toestemming om uw kaart te belasten voor deze betaling en toekomstige betalingen voor dit abonnemen",
          "defaultIntervalCount": "1",
          "endingIn": "eindigend op",
          "errorImageAlt": "Fout illustratie",
          "intervalSuffix": "(s)",
          "month": "maand",
          "pay": "Betalen",
          "payWithCard": "betalen met kaart",
          "paymentProcessing": "Uw betaling wordt verwerkt. Niet opnieuw laden of op de terugknop drukken",
          "proceedWithExistingCard": "Doorgaan met de huidige kaart",
          "proceedWithNewCard": "Doorgaan met een nieuwe kaart",
          "prorationDetails": "U betaalt nu voor {days} dagen voor de periode tot {billingEnd}, en u betaalt het volledig bedrag van ${amount}/maand vanaf {billingDate}.",
          "prorationMessage": "De initiële kosten worden naar rato berekend en reguliere facturering begint vanaf {billingDate}",
          "purchase": "aankoop",
          "subscribe": "Abonneren",
          "subscribeTo": "Abonneer u op",
          "updateCardDetails": "Update de kaartgegevens",
          "zip": "zip"
        },
        "options": {
          "jobPosition": {
            "gm": "GM",
            "vp": "VP"
          }
        },
        "registration": {
          "stepProgress": "Stap {currentStep} van 8",
          "successDescription": "Uw A2P-merk en campagne zijn ingediend.",
          "successMessage": "Opmerking: U ontvangt een OTP-bericht op het door u opgegeven mobiele nummer om te verifiëren van TCR. Gelieve binnen 24 uur na ontvangst van de sms met \"Yes\" te reageren.",
          "successWaitDays": "7 dagen",
          "successWaitPrefix": "Het kan tot ",
          "successWaitSuffix": " voor de goedkeuring van uw merk en nog eens 4-5 weken voor de goedkeuring van de campagne."
        },
        "reminder": {
          "noReplyYet": "Nog geen antwoord",
          "patientConfirmed": "Patiënt geverifieerd"
        },
        "sendGrid": {
          "apiKeyRequired": "API-sleutel vereist"
        },
        "update": {
          "brandNameHelper": "Gebruik de juridische naam van de organisatie die de berichten verzendt.",
          "businessVerticals": "Bedrijfsverticalen*",
          "resendOTP": "OTP opnieuw verzenden",
          "retryOTPTitle": "OTP-verificatie opnieuw proberen"
        }
      },
      "addCustomEmailModal": {
        "title": "Aangepaste e-mail toevoegen"
      },
      "addEditSMTPServiceModal": {
        "addProvider": "Aanbieder toevoegen",
        "clickHereForInfo": "Klik hier voor meer informatie.",
        "clickHereToFindOut": "Klik hier om meer over hen te weten te komen.",
        "createProviderError": "Er is iets misgegaan tijdens het aanmaken van de aanbieder!",
        "gmailLimitations": "Gmail heeft enkele beperkingen.",
        "needHelp": "Hulp nodig bij het vinden van het SMTP-server- en poortnummer?",
        "port25NotSupported": "Poort 25 wordt niet ondersteund! Gebruik in plaats daarvan poort 2525",
        "providerExists": "Er bestaat al een aanbieder met deze e-mail/gebruikersnaam.",
        "providerName": "Naam aanbieder",
        "selectProvider": "Aanbieder selecteren",
        "smtpPortNumber": "SMTP-poortnummer",
        "smtpProvider": "SMTP-aanbieder",
        "smtpServer": "SMTP-server",
        "username": "Gebruikersnaam",
        "usernameOrEmailRequired": "Gebruikersnaam of e-mail is vereist.",
        "verifySmtpAccount": "SMTP-account verifiëren"
      },
      "addTagModal": {
        "addTag": "Tag toevoegen",
        "editTag": "Tag bewerken",
        "tagAlreadyExists": "Tag {tag} bestaat al"
      },
      "affiliates": {
        "firstPromoterAccessMessage": "Dit FirstPromoter-rapport is alleen toegankelijk voor de <strong>Eigenaar van het agentschap en de beheerders</strong>. Als u hulp nodig heeft, neem dan contact op met de <strong>Eigenaar van het agentschap ({agencyOwnerEmail})</strong>.",
        "firstPromoterIframeTitle": "FirstPromoter-dashboard",
        "noPartnersFound": "Geen partner gevonden die aan uw filters voldoet. Klik <a href='javascript:void(0);'>hier</a> om u aan te melden als partner.",
        "paymentDetailsAccessMessage": "Dit onderdeel met uitbetalingsdetails is alleen toegankelijk en bewerkbaar via de <strong>Eigenaar van de Agentschap</strong>. Als u hulp nodig heeft, neem dan contact op met de <strong>Eigenaar van het agentschap ({agencyOwnerEmail})</strong>."
      },
      "appointmentDetails": {
        "title": "Afspraakgegevens"
      },
      "attachSnapshotToggle": {
        "loadSnapshot": "Momentopname laden:",
        "loadSnapshotWarning": "Wilt u de aan dit plan gekoppelde momentopname laden? <br /> <strong class='text-danger'>Bestaande gegevens gaan mogelijk verloren</strong>"
      },
      "auth": {
        "changePassword": {
          "changeButton": "Wachtwoord wijzigen",
          "confirmPassword": "Bevestig het nieuwe wachtwoord",
          "expired": "De link om uw wachtwoord opnieuw in te stellen is verlopen.",
          "regenerateLink": "Link opnieuw genereren",
          "success": "Het wachtwoord is gewijzigd",
          "title": "Nieuw wachtwoord instellen",
          "passwordMismatch": "Wachtwoorden komen niet overeen"
        },
        "forgotPassword": {
          "contactAgency": "neem contact op met uw agentschap.",
          "contactSupport": "Neem 24/7 contact op met de ondersteuning van HighLevel op",
          "supportMessage": "Als u geen toegang heeft tot dit e-mailadres,",
          "successMessage": "Een link om uw wachtwoord opnieuw in te stellen is naar uw e-mail verzonden.",
          "rateLimitError": "Te veel verzoeken om het wachtwoord opnieuw in te stellen. Probeer het later opnieuw."
        },
        "login": {
          "inactivityMsg": "We hebben gemerkt dat u al een tijdje inactief bent. Daarom hebben we u uitgelogd om uw veiligheid te garanderen.",
          "loginButton": "Login",
          "resetPasswordMsg": "Een link voor het opnieuw instellen van uw wachtwoord is naar uw e-mail verzonden.",
          "signInWithGoogle": "Inloggen met Google",
          "contactHighLevelSupport": " Neem 24/7 contact op met de ondersteuning van HighLevel op"
        },
        "logout": {
          "loggingOut": "Uitloggen..."
        },
        "otp": {
          "enterBackupCode": "Voer uw back-upcode in",
          "resend": "Opnieuw verzenden",
          "resendIn": "Opnieuw verzenden over",
          "sendToPhone": "Stuur code naar telefoon",
          "sending": "Verzenden...",
          "useAuthenticator": "Gebruik de Authenticator-app",
          "useBackupCode": "Back-upcode gebruiken",
          "verifyButton": "Verifiëren met back-upcode"
        },
        "sso": {
          "agreeTerms": "Als u inlogt, gaat u akkoord met onze <a class='font-semibold text-curious-blue-500 hover:text-curious-blue-800' href='{termsConditionsURL}' target='_blank'>Algemene voorwaarden</a>",
          "and": ", en",
          "loginDifferentMethod": "Log in via een andere methode",
          "loginSuccessRedirecting": "Inloggen geslaagd, u wordt doorverwezen...",
          "processing": "Uw verzoek wordt verwerkt...",
          "redirecting": "Doorverwijzen...",
          "redirectingToDashboard": "Doorverwijzen naar dashboard...",
          "signedIn": "Ingelogd",
          "signingIn": "Bezig met inloggen...",
          "testFailedRedirecting": "Test mislukt, u wordt doorverwezen...",
          "testSuccessRedirecting": "Test geslaagd, u wordt doorverwezen..."
        }
      },
      "businessDetailModal": {
        "businessAddress": "Bedrijfsadres: {address}",
        "businessDetailsText": "De volgende bedrijfsgegevens worden ingediend bij Google Local Services Ads for Reserve with Google-integratie. Controleer en bevestig of ga naar {link} om uw bedrijfsprofiel bij te werken.",
        "businessInfoRequired": "De hierboven vermelde bedrijfsinformatie is vereist voor integratie, {link} om de ontbrekende/onjuiste bedrijfsgegevens bij te werken.",
        "businessName": "Bedrijfsnaam: {name}",
        "businessNiche": "Bedrijfsniche: {niche}",
        "city": "Plaats: {city}",
        "confirmDetails": "Ik bevestig hierbij dat de hierboven genoemde details correct zijn",
        "country": "Land: {country}",
        "mustConfirmDetails": "U moet de bovengenoemde gegevens bevestigen.",
        "phoneNumber": "Telefoonnummer: {phone}",
        "state": "Provincie: {state}",
        "zipCode": "Postcode: {zipCode}"
      },
      "calendarHourRow": {
        "addHours": "Uren Toevoegen",
        "applyAll": "Alles toepassen"
      },
      "campaign": {
        "callerIdVerificationModal": {
          "answerCall": "Beantwoord de oproep en voer deze verificatiecode in:",
          "leadConnectorCalling": "Lead Connector belt u op...",
          "title": "Toevoegen van een Beller-ID via spraak",
          "waitingForVerification": "Wachten op de verificatie..."
        },
        "callerIdVerificationStatus": {
          "failed": "Beller-ID-verificatie mislukt. Probeer het opnieuw.",
          "success": "U hebt <strong>{contact}</strong> geverifieerd"
        },
        "choosePhoneNumberModal": {
          "addExistingNumbers": "Huidige nummer(s) toevoegen",
          "areaCode": "Netnummer:",
          "checkAvailability": "Beschikbaarheid controleren",
          "checkingAvailability": "Beschikbaarheid nummer controleren.",
          "chooseAreaCode": "Selecteer een netnummer",
          "choosePhoneNumbers": "Telefoonnummer(s) kiezen",
          "goBack": "Ga terug",
          "localNumbers": "Lokaal {type}",
          "nextNumberFeatures": "Volgende: nummerkenmerken",
          "noExistingNumbers": "Geen bestaand(e) nummer(s) om toe te voegen",
          "noNumbersAvailable": "Geen nummers beschikbaar",
          "notEnoughNumbers": "Niet genoeg nummers beschikbaar",
          "numbersAvailable": "Beschikbare nummers",
          "numbersDifferentArea": "Nummers met een ander netnummer",
          "numbersLocalTo": "Nummers lokaal voor <strong>{number}</strong>",
          "problemChecking": "Probleem met het controleren van de beschikbaarheid van nummers, controleer de netwerkverbinding of neem contact op met de support.",
          "somethingWentWrong": "Er ging iets mis. Controleer uw Twilio-accountgegevens en neem contact op met de ondersteuning als dit probleem zich blijft voordoen.",
          "tollFreeNumbers": "Gratis nummers ($ 2,00 toeslag per nummer per maand)",
          "percentageComplete": "67% voltooid"
        },
        "deleteNumberPoolModal": {
          "confirmDelete": "Ik begrijp de gevolgen, verwijder de pool",
          "confirmText": "Voer <b>{name}</b> in om te bevestigen",
          "title": "Wilt u numberpool - <strong>{name}</strong>verwijderen?",
          "warning": "Deze actie kan niet ongedaan worden gemaakt. Hiermee worden de nummers permanent verwijderd uit uw Twilio-Account, samen met de Nummersets uit onze Database. Bovendien, als u nummersets verwijdert omdat u een probleem ondervindt, neem dan contact op met ons ondersteuningsteam."
        },
        "editNumberFormatModal": {
          "description": "U kunt de opmaak van de omwissel- en poolnummer(s) naar wens aanpassen. Zorg ervoor dat het/de omwisselnummer(s) op de website hetzelfde zijn als de geformatteerde nummers.",
          "title": "Nummeropmaak bijwerken - <strong>{name}</strong>"
        },
        "editNumberPoolModal": {
          "addEditGroupId": "Groeps-ID toevoegen/bewerken",
          "callConnectTooltip": "Deze functie vereist dat de ontvanger een toets indrukt om het gesprek te verbinden, wat resulteert in een hogere nauwkeurigheid voor de rapportage van gesprekken.",
          "createGroupIdDescription": "Maak/Voeg een unieke Groep-ID toe om meerdere nummersets te gebruiken met één JavaScript-snippet.",
          "enableCallConnect": "Schakel de verbinding met oproepen in",
          "groupId": "Groeps-id",
          "outboundCallTimeout": "Uitgaande oproep time-out",
          "passCallerID": "Geef het gebelde nummer op als beller-ID",
          "passCallerIDTooltip": "Standaard geeft het systeem het nummer van de beller door, maar als u wilt dat de beller-ID in plaats daarvan het door de beller gekozen nummer weergeeft, schakelt u deze functie in.",
          "selectCallerID": "Selecteer beller-ID",
          "timeDuration": "Tijdsduur in seconde(n)",
          "titleNumber": "Nummer - <strong>{number}</strong>",
          "updateWhisperWarning": "Update fluisterbericht, want deze functie vereist dat de ontvanger een toets indrukt om het gesprek te verbinden.",
          "useVerifiedNumber": "Gebruik uw geverifieerde nummer als beller-ID voor uitgaande oproepen",
          "useVerifiedNumberTooltip": "Alleen van toepassing op geverifieerde telefoonnummers. U kunt een telefoonnummer verifiëren via Instellingen > Telefoonnummers > Geverifieerde beller-ID toevoegen."
        },
        "emailOTPModal": {
          "confirmCode": "Code bevestigen",
          "resendCode": "Als u de code niet hebt ontvangen, kunt u hier klikken om deze opnieuw te verzenden",
          "unexpectedIssue": "Er is een onverwacht probleem opgetreden"
        },
        "facebookFieldMapModal": {
          "customFieldInfo": "Informatie over Aangepaste Velden",
          "customFieldTooltip": "Tooltip voor aangepast veld: {options}",
          "field": "{companyName} veld",
          "trackingParameters": "Trackingparameters",
          "zipCode": "Postcode"
        },
        "howToUseNumberPoolModal": {
          "addSwappingNumbers": "Numberswisselen toevoegen",
          "addingSnippets": "Javascript-snippets toevoegen",
          "groupSnippet": "Snippet groep '{id}'",
          "normalSnippet": "Snippet normaal",
          "noswapDescription": "Als u niet wilt dat we het nummer op een bepaalde plek omwisselen, voeg dan een klasse 'noswap' toe.",
          "notReplacing": "Niet vervangen op een bepaalde plaats",
          "requiredSteps": "Vereiste stappen",
          "snippetsDescription": "Kopieer de onderstaande snippet en voeg deze toe net boven de afsluitende body-tag van elke pagina waar u de nummers wilt vervangen.",
          "swappingDescription": "Gebruik de onderstaande nummers om het wisselen van telefoonnummers in te schakelen. Selecteer een lokalel of internationale indeling of zelfs beide indelingen."
        },
        "newPhoneNumberModal": {
          "areaCode": "Netnummer",
          "availableNumbers": "Beschikbare nummers",
          "bundle": "Pakket",
          "chooseAddress": "Kies adres...",
          "chooseBundle": "Kies een bundel...",
          "createRegulatory": "Maak hier een regelgevingspakket/-adres aan.",
          "monthlyFee": "Maandelijkse prijs",
          "noNumbersFound": "Geen nummers gevonden, probeer een ander netnummer.",
          "selectAddress": "Selecteer 'Adres' om het nummer te kopen.",
          "selectBundle": "Selecteer 'Pakket' om het nummer aan te schaffen.",
          "title": "Telefoonnummer toevoegen",
          "upgradeAccount": "Upgrade uw Twilio-account. Alleen geüpgradede accounts kunnen telefoonnummers aankopen en ermee bellen.",
          "cardAuthenticationFailed": "Kaartauthenticatie mislukt!"
        },
        "reserveWithGoogleIntegration": {
          "agreeTerms": "U moet akkoord gaan met de Voorwaarden en de Privacyvoorwaarden.",
          "clickingProceed": "Door op Doorgaan te klikken, opent u de LSA-linkpagina in een nieuw tabblad",
          "configureCalendar": "Configureer ten minste één agenda om door te gaan met boeken met Google-integratie.",
          "configureCalendarBtn": "Configureer de agenda",
          "linkOneAccount": "Zorg ervoor dat u maar één account koppelt. Neem contact op met de ondersteuning als u de pagina in de bovenstaande schermafbeelding niet kunt bekijken.",
          "readInstructions": "Ik heb de bovengenoemde instructies gelezen"
        },
        "updateTrackingModal": {
          "title": "Trackingoptie bijwerken"
        },
        "usageSummary": {
          "agencyOnlyVisible": "(Dit is alleen zichtbaar voor beheerders van het agentschap)",
          "updatedEvery24Hours": "(elke 24 uur geüpdate)"
        },
        "userCalendarConfiguration": {
          "calendarNotSelected": "Agenda niet geselecteerd voor synchronisatie",
          "check": "Controleer {email}",
          "checkForConflicts": "Controleer op conflicten",
          "checkForConflictsTooltip": "Stel de agenda('s) in om te controleren op conflicten om dubbele boekingen te voorkomen.",
          "contactCreationAllowed": "Het aanmaken van contactpersonen is toegestaan",
          "googleCalendar": "Logo Google Agenda",
          "noGoogleAccounts": "Er zijn nog geen Google/Outlook-accounts toegevoegd in de integratie-instellingen",
          "noGoogleAccountsTeamMember": "Er zijn geen Google/Outlook-accounts toegevoegd voor dit teamlid op de huidige locatie. Vraag uw teamlid om in te loggen via zijn/haar account en de Google-verbinding toe te voegen vanuit zijn/haar integratie-instellingen.",
          "outlookCalendar": "Gebruikersagenda Outlook",
          "primaryCalendarTooltip": "Stel de agenda in waarin u nieuwe events wilt toevoegen zodra ze zijn ingepland.",
          "runTriggerAllowed": "Trigger uitvoeren toegestaan"
        },
        "warningModal": {
          "contactAgency": "Neem contact op met uw agentschap om de e-mailinstellingen te wijzigen.",
          "title": "Waarschuwing"
        }
      },
      "checkout": {
        "prioritySupport": {
          "features": {
            "faster247Chat": "Snellere 24/7-ondersteuning per chat",
            "faster247Ticket": "Snellere 24/7 ticketondersteuning en reactietijden"
          },
          "highlight": {
            "description": "We begrijpen het, het moet sneller gaan. Wanneer u een vraag of opmerking hebt, wilt u dat deze zo snel mogelijk wordt beantwoord! Met de upgrade naar prioriteitsondersteuning kunt u de rij overslaan en komen uw verzoeken automatisch boven aan de lijst terecht.",
            "heading": "Klaar voor de VIP-behandeling?"
          },
          "name": "Prioriteitsondersteuning",
          "success": {
            "description": "Prioriteitsondersteuning is ingeschakeld voor uw account. U hoeft niet meer in de rij te wachten.",
            "heading": "U bent nu een prioritaire klant!"
          }
        }
      },
      "cloneFunnel": {
        "cloneButton": "{entityName} klonen",
        "cloning": "Klonen...",
        "cloningLimit": "Klonen is beperkt tot 3 locaties per keer",
        "error": "Fout bij het klonen van de trechter!",
        "locationsLabel": "Selecteer locaties",
        "nameLabel": "Naam voor de gedupliceerde {entityName}",
        "namePlaceholder": "Voer een naam in voor de gekloonde {entityName}",
        "selectUpTo": "Selecteer maximaal {maxSelectableLocations} locaties",
        "title": "{entityName} klonen"
      },
      "cnam": {
        "learnMore": {
          "description": "Met CNAM verschijnt uw bedrijfsnaam op de beller-ID, waardoor uw oproepen direct herkenbaar zijn en het vertrouwen wordt vergroot. Laat uw klanten telkens weten dat u het bent die belt.",
          "title": "Laat uw oproepen opvallen!"
        },
        "registration": {
          "characterLimit": "{count}/15",
          "confirm": "Bevestigen en registreren",
          "description": "Geef uw bedrijfsnaam weer om ontvangers aan te moedigen te bellen, zodat het vertrouwen toeneemt en meer mensen uw oproepen beantwoorden.",
          "title": "Verhoog het vertrouwen in oproepen met CNAM",
          "warning": "De weergave van de bedrijfsnaam is niet gegarandeerd, vooral niet op mobiele apparaten."
        },
        "submitted": {
          "checkStatus": "CNAM-status controleren",
          "description": "Uw bedrijfsnaam zou binnen ongeveer 3-5 dagen aan relevante contactpersonen moeten worden weergegeven.",
          "subtitle": "Uw CNAM-verzoek is nu ingediend.",
          "title": "Gefeliciteerd!"
        }
      },
      "confirmMerchantDeleteModal": {
        "confirmDelete": "Verwijdering bevestigen",
        "confirmation": "Bevestiging"
      },
      "createAddress": {
        "successTitle": "Adres ingediend",
        "underReview": "Het ingediende adres wordt beoordeeld"
      },
      "createEndUser": {
        "dateFormat": "Het datumformaat moet JJJJ-MM-DD zijn.",
        "phoneExample": " Model: +14155552671",
        "title": "Bedrijfsgegevens:"
      },
      "customValueModal": {
        "changingNameWarning": "Het wijzigen van de naam heeft geen invloed op de veldsleutel.",
        "editCustomValue": "Aangepaste waarde bewerken",
        "fieldKeyCreatedWarning": "De veldsleutel wordt aangemaakt op basis van de naam en kan later niet worden gewijzigd.",
        "nameRequired": "Het veld Naam is vereist",
        "nameValidation": "De naam moet alfanumeriek zijn en ten minste één teken bevatten",
        "valueRequired": "Het veld Waarde is vereist"
      },
      "details": {
        "addressName": "Adresnaam",
        "addressTitle": "Adresgegevens",
        "bundleName": "Bundelnaam",
        "bundleTitle": "Gegevens regelgevingspakket",
        "countryFlag": "Markering {country}",
        "id": "ID",
        "organisation": "Organisatie",
        "rejectionReason": "Reden voor afwijzing",
        "status": {
          "approved": "Goedgekeurd",
          "notValidated": "Niet gevalideerd",
          "rejected": "Geweigerd",
          "validated": "Gevalideerd"
        },
        "typeOfNumber": "Type nummer"
      },
      "drChronoOfficeSelect": {
        "selectOffice": "Agentschap selecteren",
        "whichOffice": "Welk agentschap wilt u aan dit account koppelen?"
      },
      "editAddToCalendarModal": {
        "allowContactCreation": "Aanmaken van contactpersonen toestaan:",
        "allowTrigger": "Trigger toestaan:",
        "doNotSync": "Nieuwe afspraken niet synchroniseren met de primaire agenda",
        "primaryCalendarTooltip": "U kunt alleen een agenda met schrijftoegang selecteren die u niet hebt gekozen voor het controleren op conflicten.",
        "selectDefaultCalendar": "Selecteer standaard agenda",
        "whichCalendar": "Welke kalender moeten we gebruiken om gebeurtenissen naar te synchroniseren (lezen en schrijven)?"
      },
      "editCheckForConflictsCalendarsModal": {
        "checkThesePlaces": "Controleer deze plaatsen op conflicten",
        "howToCheckConflicts": "Hoe kunnen we controleren op conflicten?"
      },
      "ejectModal": {
        "agencyClosing": "Het account van het Elite Marketing-agentschap bij Highlevel wordt gesloten. Wilt u uw account behouden? Neem dan contact op met {userName} om uw account meteen naar Highlevel te migreren.",
        "cancelWarning": "Houd er rekening mee dat uw account op 30 juni 2025 officieel wordt geannuleerd en dat we uw statistieken na deze datum niet meer kunnen ophalen als de overdracht niet is voltooid.",
        "contactEmail": "transfers{'@'}gohighlevel.com",
        "contactUs": "Als u vragen heeft, neem dan contact met ons op via",
        "faqsUrl": "gohighlevel.com/getstartedtoday-em",
        "freeTransition": "Om u tijdens deze kosteloze overgang te ondersteunen, bieden we {months} gratis toegang tot uw nieuwe abonnement.",
        "intro": "Na herhaalde schendingen van de servicevoorwaarden van HighLevel is Elite Marketing Authority (EMA) permanent verwijderd van het HighLevel-platform.",
        "platformCommitment": "Als het platform dat de services van EMA mogelijk maakt, doet HighLevel er alles aan om alle gebruikers een veilige, conforme en betrouwbare omgeving te bieden. Om verstoring van uw account te voorkomen, helpen we u bij een soepele overgang naar een andere white-label aanbieder of direct naar HighLevel.",
        "questions": "Als u vragen hebt,",
        "retainAccess": "Om toegang te houden tot uw bestaande gegevens en hulpmiddelen, klikt u op de onderstaande knop en volgt u de instructies om de overdracht te initiëren.",
        "speakWithTeam": "Neem contact op met ons team.",
        "startTransfer": "Start uw gratis overdracht",
        "title": "Beste klanten van Elite Marketing",
        "viewFaqs": "Bekijk hier de veelgestelde vragen:",
        "whiteLabel": "Als u liever via een andere white-label aanbieder inlogt bij HighLevel, helpen wij u graag met die wijziging via ons supportticketsysteem nadat u uw account direct naar HighLevel heeft overgezet."
      },
      "emailTemplate": {
        "createdOn": "Aangemaakt op",
        "updatedOn": "Bijgewerkt op"
      },
      "error": {
        "title": "Indienen regelgevingspakket mislukt"
      },
      "errors": {
        "funnel": {
          "multiplePages": "Deze URL wordt door meer dan één pagina gebruikt. Verander het pad van deze pagina om de pagina te laten functioneren.",
          "urlNotFound": "Oeps, we kunnen de URL die u zocht niet vinden"
        },
        "productRebilling": {
          "requestFailed": "Verzoek mislukt"
        },
        "template": {
          "categoryNotFound": "Oeps, we kunnen de categorie die u zocht niet vinden.",
          "internalError": "Er is een interne fout opgetreden!"
        },
        "transfer": {
          "hipaaEnabled": {
            "message": "Het subaccount dat u probeert over te dragen, is HIPAA-compatibel en kan niet worden overgedragen aan een niet-HIPAA-agentschap."
          },
          "limitExceeded": {
            "message": "Het agentschap waar u de sub-account aan wilt overdragen heeft zijn gebruikslimiet bereikt en kan geen extra sub-accounts meer verkrijgen.  Vraag hen om ofwel een sub-account te verwijderen dat niet in gebruik is, of te upgraden naar een hoger abonnement om dit sub-account te verkrijgen."
          },
          "pendingRequest": {
            "heading": "Er loopt al een overdrachtsverzoek voor dit subaccount.",
            "message": "Annuleer het reeds bestaande overdrachtsverzoek voor dit sub-account voordat u een nieuw verzoek indient."
          }
        }
      },
      "facebookPageSelect": {
        "cannotFind": "Kunt u de pagina die u zoekt niet vinden? Ga naar uw Facebook-instellingen en zorg ervoor dat alle pagina's zijn geselecteerd.",
        "instagramAvailable": "Instagram is beschikbaar voor dit account!",
        "noPages": "U heeft geen pagina's voor dit account.",
        "title": "Selecteer de Facebook-pagina waaraan u deze locatie wilt koppelen"
      },
      "googleLocationSelect": {
        "closeButton": "Sluiten!",
        "enableCallTracking": "Schakel het volgen van GBP-gesprekken in",
        "noBusinesses": "U hebt geen gekoppelde bedrijven onder dit account."
      },
      "importCustomers": {
        "newExperience": {
          "efficient": "Efficiënter",
          "faster": "Sneller",
          "itsText": "Het is",
          "smoother": "Soepeler",
          "title": "Er is een nieuwe import-ervaring!",
          "warningMessage": "Door de nieuwe import-ervaring in te schakelen, worden Labs en de bètafunctie geactiveerd voor dit subaccount."
        },
        "validateEmails": "E-mails valideren?"
      },
      "initBundle": {
        "numberType": "Type nummers die u wilde gebruiken",
        "numberTypes": {
          "local": "Lokale nummers",
          "mobile": "Mobiel",
          "tollfree": "Gratis"
        },
        "selectCountry": "Selecteer uw land",
        "selectUserType": "Selecteer het gebruikerstype",
        "userTypes": {
          "business": "Bedrijf",
          "individual": "Persoon"
        }
      },
      "manageLocationCredits": {
        "creditLastAddedOn": "Tegoed laatst toegevoegd op:",
        "currentBalance": "Huidig saldo",
        "debitBalance": "- Debetsaldo",
        "depositComplimentaryCreditsOf": "Stort aanvullende tegoed van",
        "manageBalance": "Saldo beheren",
        "mustBeValidInteger": "Moet een geldig geheel getal zijn",
        "nextDate": "Volgende datum:",
        "perMonth": "per maand",
        "remainingWalletBalance": "Resterend saldo in de portemonnee van dit subaccount",
        "rolloverCredits": "Tegoeden overdragen naar volgende maand",
        "toManageMonthlyCredits": "Om maandelijkse tegoeden te beheren,"
      },
      "manageLocationSubscriptionModal": {
        "addNewSubscription": "Nieuw abonnement toevoegen"
      },
      "manualActions": {
        "confirmDelete": "Weet u zeker dat u deze actie wilt verwijderen?",
        "confirmDeleteAll": "Weet u zeker dat u alle handmatige acties op deze pagina wilt verwijderen?"
      },
      "membership": {
        "resetPassword": {
          "generateStrongPassword": "Maak een sterk wachtwoord aan",
          "sendEmailNotification": "Stuur ook een melding per e-mail."
        }
      },
      "modal": {
        "description": "U moet enkele eenvoudige stappen voor naleving uitvoeren om telefoonsystemen te kunnen gebruiken",
        "submit": "Verzenden",
        "title": "Telefoondienst Lead Connector"
      },
      "notifications": {
        "list": {
          "homePageVisitors": "Bezoekers van de startpagina",
          "launched": "Gelanceerd",
          "newNotification": "Nieuwe melding",
          "startMessage": "Begin met het verhogen van uw conversies door uw eerste melding aan te maken",
          "types": {
            "combination": "Integratie"
          }
        },
        "page": {
          "createTitle": "Nieuwe melding aanmaken",
          "steps": {
            "display": "Weergave",
            "track": "Volgen"
          }
        }
      },
      "opportunities": {
        "columns": {
          "additionalInfo": "Aanvullende informatie",
          "calendarEvent": "Agendagebeurtenis",
          "hideAssignedTo": "Verberg Toegewezen aan",
          "hideTags": "Tags verbergen"
        },
        "filters": {
          "dateAddedAsc": "↑ Datum toegevoegd (oplopend)",
          "dateAddedDesc": "↓ Datum toegevoegd (aflopend)",
          "orderBy": "Sorteren op"
        },
        "getStarted": "Aan de slag!",
        "noPipelines": "Oeps! Het lijkt erop dat er geen pijplijnen zijn. Maak een nieuwe pijplijn aan om"
      },
      "pages": {
        "pageMoved": {
          "title": "Uw online vermeldingen zijn verplaatst"
        }
      },
      "recentlyVisited": {
        "prices": "{count} prijzen"
      },
      "reminders": {
        "appointmentReminders": "Herinneringen voor afspraken",
        "apptTime": "Tijd afspraak",
        "defaultDateRange": "zo 1 apr 2018 - ma 31 apr 2018"
      },
      "saasAccountDetailsActiveSubscription": {
        "onHold": "In de wacht",
        "rebillingOnHoldWarning": "Dit account heeft al configuraties voor herfacturering in de wacht. Het SaaS-plan kan alleen worden gekoppeld nadat de klant een betaalmethode heeft toegevoegd.",
        "subscriptionId": "Abonnements-ID:"
      },
      "saasPricingTable": {
        "confirmAndProceed": "Opslaan en doorgaan",
        "documents": {
          "acceptedDocuments": "Geaccepteerde documenten",
          "acceptedDocumentsLabel": "Geaccepteerde documenten:",
          "additionalInfo": "Aanvullende informatie:",
          "createAddressLink": "Adres aanmaken.",
          "createAddressPrompt": "Maak eerst een adres aan en ga dan verder met het aanmaken van de bundel.",
          "documentInfo": "PNG, JPG, PDF tot 5 MB",
          "documentType": "Documenttype",
          "option": "Optie {number}",
          "selectAddress": "Adres selecteren:",
          "selectDocumentType": "Selecteer het documenttype:",
          "selectFile": "Bestand selecteren",
          "title": "Vereiste documenten:",
          "updateDocuments": "Documenten bijwerken"
        },
        "everythingIn": "Alles in <b>{plan}+</b>",
        "noPaymentMethod": {
          "linkText": "voeg hier een creditcard toe",
          "message": "Zou u uw klant willen vragen om",
          "title": "De locatie moet eerst de betaalmethode toevoegen."
        },
        "noSaasPlan": {
          "linkText": "maak hier uw SaaS-plannen aan.",
          "message": "Ga",
          "title": "U heeft geen SaaS-plan geconfigureerd."
        },
        "saasModeSetupPendingWarning": "Het SaaS-plan wordt geactiveerd nadat de klant een betaalmethode heeft toegevoegd. Tot die tijd is de toegang tot hun account beperkt.",
        "skipForNow": "Voorlopig overslaan",
        "skipPlan": "Plan overslaan",
        "success": {
          "title": "Regelgevingsbundel ingediend",
          "underReview": "Pakket ter beoordeling ingediend"
        }
      },
      "selectBundle": {
        "addressBundle": {
          "description": "Deze optie voegt een nieuw adres toe aan uw account",
          "label": "Adresbundel"
        },
        "regulatoryBundle": {
          "description": "Deze optie helpt u een nieuwe regelgevingsbundel aan te maken",
          "label": "Regelgevingsbundel"
        },
        "title": "Kies welk pakket u wilt toevoegen"
      },
      "settings": {
        "billing": "Facturering",
        "calendars": "Agenda's",
        "customEmails": "Aangepaste e-mails",
        "domains": "Domeinen",
        "domainsAndUrlRedirects": "Domeinen en URL-omleidingen",
        "facebookFormFieldsMapping": "Mapping van Facebook-formuliervelden",
        "groups": "Groepen",
        "integrations": "Integraties",
        "labs": "Labs",
        "media": "Media",
        "noShowSMS": "No-show sms",
        "pipelines": "Pijplijnen",
        "profile": "Profiel",
        "smtpAndMailGunService": "SMTP- en MailGun-service",
        "templates": "Sjablonen",
        "urlRedirects": "URL-omleidingen"
      },
      "shakenStir": {
        "confirmation": {
          "title": "Uw oproepen zijn nu geverifieerd!"
        },
        "modal": {
          "andThe": " en de ",
          "certification": "Ik verklaar dat het bijbehorende bedrijfsprofiel de bron is van de telefoongesprekken en verklaar dat ik zal meewerken aan traceerinspanningen, waaronder die welke worden geïnitieerd door de",
          "failedTitle": "Indienen mislukt",
          "friendlyNamePlaceholder": "Bijvoorbeeld: SHST 2022-11-24 om 19:47:14",
          "linkInfo": {
            "description": "Alle momenteel beschikbare nummers en toekomstige aangeschafte nummers worden automatisch geregistreerd bij SHAKEN/STIR.",
            "title": "Alle nummers worden automatisch gekoppeld"
          },
          "stiPa": "Secure Telephony Identity Policy Administrator (STI-PA)",
          "subtitle": "Voer de details en de beschrijving in",
          "successMessage": "Uw verzoek voor SHAKEN/STIR-registratie is ingediend. Het kan tot <b>3-4 dagen</b> duren voordat het wordt goedgekeurd. De status wordt binnenkort geüpdatet.",
          "successTitle": "SHAKEN/STIR vertrouwde oproep is ingeschakeld.",
          "title": "SHAKEN/STIR vertrouwde oproep inschakelen",
          "tracebackGroup": "US Telecom Traceback Group"
        },
        "withCnam": {
          "cnamPromo": "Wilt u nog een stap verder gaan? Toon uw bedrijfsnaam bij oproepen met CNAM.",
          "registerCnam": "Inschrijven voor CNAM",
          "title": "Bouw klantvertrouwen op en verhoog het aantal beantwoorde oproepen"
        },
        "successMessage": "Uw verzoek voor SHAKEN/STIR-registratie is ingediend. Het kan tot <b>3-4 dagen</b> duren voordat het wordt goedgekeurd. De status wordt binnenkort geüpdatet."
      },
      "shopify": {
        "selectLocation": "Selecteer welke locatie u aan deze shopify-winkel wilt koppelen"
      },
      "signup": {
        "accountType": "Accounttype",
        "agencyProAccount": "Agentschap Pro-account (€ 497 per maand)",
        "agencyTestAccount": "Testaccount agentschap",
        "freeTrialMessage": "Ontvang een <strong>gratis</strong> proefperiode van 14 dagen door u nu aan te melden.",
        "freelancerAccount": "Freelancer-account (€ 297 per maand)",
        "getStartedForFree": "Start helemaal gratis!",
        "pickPassword": "Kies een wachtwoord",
        "signUp": "Registreren",
        "starterAccount": "Starter-account ($ 97/maand)",
        "termsAndConditions": "Door u aan te melden, gaat u akkoord met onze <a href='https://www.gohighlevel.com/privacy' target='_blank'>Algemene voorwaarden</a>",
        "yourCompanyName": "Uw bedrijfsnaam",
        "yourFullName": "Uw volledige naam"
      },
      "standardPlan": {
        "description": "We hebben de volgende plannen voor standaard merkregistraties.",
        "plans": {
          "common": {
            "einRequiredForRegistration": "EIN vereist voor registratie",
            "moreThan1Phone": "Meer dan 1 telefoonnummer toegestaan"
          },
          "highVolume": {
            "heading": "Standaard hoog volume",
            "point3": "Tot 600.000 segmenten per dag",
            "infoText": "Er wordt eenmalig $ 20,95 in rekening gebracht voor de registratie van het merk en de campagne. Er geldt een extra campagnevergoeding van maximaal $ 2,25 per maand in overeenstemming met de TCR-regels.",
            "point2": "Verzend tot 3000 segmenten per dag",
            "point1": "EIN vereist voor registratie"
          },
          "lowVolume": {
            "heading": "Standaard laag volume",
            "recommended": "Aanbevolen",
            "point3": "Tot 6000 segmenten per dag",
            "infoText": "Er wordt eenmalig $ 20,95 in rekening gebracht voor de registratie van het merk en de campagne. Er geldt een extra campagnevergoeding van maximaal $ 2,25 per maand in overeenstemming met de TCR-regels.",
            "point2": "Verzend tot 3000 segmenten per dag",
            "point1": "EIN vereist voor registratie"
          }
        },
        "title": "Selecteer uw plan voor standaardmerken"
      },
      "submissionDetail": {
        "titles": {
          "bookingDetails": "Details boeking",
          "form": "Formulier",
          "quiz": "Quiz",
          "submissionDetail": "Indieningsgegevens",
          "survey": "Enquête"
        }
      },
      "suspension": {
        "suspended": {
          "description": "Alleen agentschapsbeheerders/gebruikers hebben toegang tot dit subaccount. Momenteel hebben u en andere accountbeheerders/gebruikers geen toegang tot dit subaccount.",
          "heading": "Dit sub-account is gepauzeerd."
        },
        "temporarily": {
          "description": "Al uw gegevens zijn veilig en alle triggers/campagnes enz. zullen na activering weer worden hervat.",
          "heading": " Uw account is tijdelijk opgeschort."
        }
      },
      "triggers": {
        "assignUser": {
          "onlyUnassignedContacts": "Alleen toepassen op niet-toegewezen contactpersonen",
          "splitTraffic": "Verkeer verdelen",
          "trafficWeightage": "Meting verkeer",
          "userRequired": "De gebruiker moet worden geselecteerd",
          "weightage": "Weging"
        },
        "birthdayFilters": {
          "afterDays": "Na aantal dagen",
          "beforeDays": "Voor aantal dagen",
          "dayIs": "Dag is",
          "daysInNumber": "Aantal dagen in cijfers",
          "hasTag": "Heeft een tag",
          "monthIs": "De maand is",
          "selectDay": "Selecteer een dag",
          "selectMonth": "Selecteer een maand"
        },
        "botConversation": {
          "enterTimeout": "Voer een timeout in (uren)",
          "selectEliza": "Selecteer Eliza",
          "selectThankyouTemplate": "Selecteer bedank-sjabloon",
          "selectWelcomeTemplate": "Selecteer een welkomstsjabloon"
        },
        "contactField": {
          "addField": "Velden toevoegen",
          "defineFilters": "Filters definiëren"
        },
        "copyModal": {
          "title": "Trigger kopiëren"
        },
        "detailModal": {
          "actionsPerform": "Welke acties moeten we uitvoeren?",
          "campaignNameRequired": "Het veld Campagnenaam is vereist",
          "campaignsDeprecation": "Campagnes worden niet langer beheerd. Voor een soepele overgang, kunt u uw bestaande campagnes omzetten in workflows.",
          "folderName": "Naam map",
          "mustSelectFolder": "Moet een map selecteren.",
          "newFolderName": "Nieuwe mapnaam",
          "selectFolder": "Map selecteren",
          "triggerNameRequired": "Het veld Triggernaam is vereist",
          "triggersDeprecation": "Triggers worden niet langer onderhouden. Voor een soepele overgang, kunt u uw bestaande triggers omzetten in workflows.",
          "triggerName": "Naam trigger"
        },
        "dnd": {
          "disableAll": "Niet storen uitschakelen voor alle kanalen",
          "disableSpecific": "Niet storen uitschakelen voor specifieke kanalen",
          "enableAll": "Niet storen inschakelen voor alle kanalen",
          "enableSpecific": "Niet storen inschakelen voor specifieke kanalen",
          "selectAction": "Actie selecteren"
        },
        "email": {
          "sendTestEmail": "Testmail verzenden",
          "smtpWarning": "SMTP-aanbieders hebben enkele beperkingen. Klik hier voor meer informatie."
        },
        "facebook": {
          "avatarAlt": "Facebookavatar",
          "selectCustomAudience": "Selecteer aangepaste doelgroep"
        },
        "googleAds": {
          "conversionName": "Conversienaam",
          "conversionTooltip": "De conversiebron moet Importeren vanuit klinks zijn en de categorie moet Geïmporteerde lead of Lead zijn",
          "noConversions": "Geen conversietarief gevonden",
          "selectConversion": "Selecteer conversie"
        },
        "googleAnalytics": {
          "eventAction": "Actie gebeurtenis",
          "eventActionRequired": "Actie voor gebeurtenis is vereist.",
          "eventCategory": "Gebeurteniscategorie",
          "eventCategoryRequired": "Evenementcategorie is vereist.",
          "eventLabel": "Label gebeurtenis",
          "eventValue": "Waarde gebeurtenis",
          "hitType": "Hittype",
          "hitTypeRequired": "Hittype is vereist.",
          "trackingId": "Tracking-ID",
          "trackingIdRequired": "Tracking-ID is vereist."
        },
        "membershipOffer": {
          "selectOffer": "Aanbieding selecteren"
        },
        "notification": {
          "selectRedirectPage": "Selecteer een doorverwijzingspagina",
          "selectUser": "Gebruiker selecteren",
          "selectUserType": "Selecteer gebruikerstype"
        },
        "sms": {
          "sendTestSMS": "Test-sms verzenden"
        },
        "stripeCharge": {
          "customerId": "Stripe klant-ID",
          "enterAmount": "Bedrag invoeren",
          "selectCurrency": "Selecteer een valuta"
        },
        "webhook": {
          "webhookUrl": "Webhook-URL"
        }
      },
      "twilioReselling": {
        "transactions": {
          "fields": {
            "activityDate": "Datum activiteit",
            "balance": "Saldo",
            "id": "id"
          }
        },
        "upgradeBanner": {
          "subtitle": "Agenschappen met een pro-abonnement verdienen ongeveer $ 363 per maand door telefoonkosten door te rekenen aan hun klanten",
          "title": "Wilt u dit opnieuw aan uw klanten aanrekenen?"
        }
      },
      "updateModals": {
        "error": {
          "title": "Het indienen van uw profiel is mislukt."
        },
        "success": {
          "message": "Uw A2P-merk en campagne zijn ingediend.<br/><br/><b>Bericht:</b> U ontvangt <b>een OTP-bericht op uw opgegeven mobiele nummer om te verifiëre</b> van TCR. Gelieve <b>binnen 24 na ontvangst van de sms</b> Yes te antwoorden."
        }
      },
      "usageLimit": {
        "contactLimit": "Limiet contactpersonen",
        "maxContactsAllowed": "Maximaal aantal toegestane contacten in het sub-account",
        "maxUsersAllowed": "Maximaal aantal toegestane gebruikers in het subaccount",
        "unlimited": "Onbeperkt",
        "usageLimits": "Gebruikslimieten",
        "userLimit": "Gebruikerslimiet",
        "userLimitHelpMessage": "Alleen gebruikers op subaccountniveau tellen mee voor deze limiet. U kunt nog steeds zoveel agentschapsgebruikers aan de subaccounts toevoegen als u nodig hebt"
      },
      "yext": {
        "reselling": {
          "agreeToEnable": "Ik ga akkoord met het opslaan van vermeldingen voor deze klant zonder bijverkopen en ik erken dat er kosten in rekening worden gebracht",
          "deployDirectly": "Vermeldingen rechtstreeks implementeren",
          "deployDirectlyDesc": "Gebruik deze optie als u vermeldingen aanbiedt als onderdeel van uw aanbod of als u uw klant extern wilt factureren",
          "minimumCommitment": "met een minimale verbintenis van 1 maand.",
          "offerListings": "Aanbod vermeldingen",
          "resellListings": "Doorverkoopaanbiedingen",
          "subscribedInfo": "{withoutUpsell} Zonder bijverkopen, {withUpsell} Met bijverkopen en {withSaas} Met SaaS-bundel",
          "subscriptionCreated": "Abonnement aangemaakt. Een ogenblik geduld...",
          "subscriptionCreating": "Abonnement wordt aangemaakt.<br/>Niet opnieuw laden of op de terugknop drukken",
          "unableToCreate": "Kan geen abonnement aanmaken, neem contact op met de ondersteuning",
          "unavailabilityForAgencyAdmin": "Yext is niet beschikbaar in dit land. Als u denkt dat dit een fout is, kunt u dit op onze routekaart aanvragen via",
          "yourResellOffer": "Uw doorverkoopaanbod"
        }
      },
      "selectCountry": "Selecteer uw land",
      "documents": {
        "additionalInfo": "Aanvullende informatie",
        "createAddressLink": "Adres aanmaken.",
        "createAddressPrompt": "Maak eerst een adres aan en ga dan verder met het aanmaken van de bundel.",
        "selectAddress": "Adres selecteren:"
      }
    },
    "triggers": {
      "emptyTrigger": "Lege trigger"
    },
    "util": {
      "addFiles": "+ Bestanden toevoegen",
      "fillValues": "Vul waarden in",
      "image": "img",
      "ok": "Oké",
      "pleaseTypeOrCancel": "Typ {consentString} hierboven of annuleer deze actie.",
      "pressEnterToAddCustomOption": "Klik op Enter om een aangepaste optie toe te voegen",
      "required": "* vereist",
      "unsaved": "Niet opgeslagen"
    },
    "workflow": {
      "announcement": {
        "enableMessage": "Om de Workflow voor een locatie in te schakelen, gaat u naar het tabblad Accounts, klikt u op het driepunten-icoon rechts van een subaccount en selecteert u <strong>Workflow Builder inschakelen</strong>. Dit proces is tijdelijk, want Workflows gaat volgende week live op alle locaties."
      },
      "faq": "Veelgestelde vragen",
      "gotIt": "Begrepen",
      "workflowIsLive": "De workflow is live in uw account!"
    },
    "action": {
      "stats": {
        "bounced": "Gebounced",
        "clicked": "Geklikt",
        "delivered": "Geleverd",
        "opened": "Geopend",
        "replied": "Geantwoord",
        "unsubscribed": "Afgemeld",
        "total": "Totaal",
        "failed": "Mislukt"
      },
      "actions": {
        "edit": "Bewerken",
        "send": "Verzenden",
        "remove": "Verwijderen"
      },
      "timing": {
        "days": "Dagen",
        "immediately": "Onmiddellijk",
        "before": "Voor",
        "after": "Na",
        "minutes": "Minuten",
        "hours": "Uren"
      },
      "labels": {
        "template": "Sjabloon",
        "manual": "Handmatig"
      },
      "details": {
        "hideDetail": "Details verbergen",
        "showDetail": "Details weergeven"
      },
      "queue": {
        "people": "mensen",
        "person": "persoon",
        "queued": "in de wachtrij"
      },
      "tooltips": {
        "clickedHelp": "De nauwkeurigheid van de bijgehouden klikken kan afhankelijk van de e-mailclient en de gebruikersinstellingen variëren.",
        "statsAccuracy": "De nauwkeurigheid van statistieken kan variëren afhankelijk van de e-mailclient en de instellingen van de gebruiker."
      }
    },
    "bulkRequest": {
      "list": {
        "confirmDelete": "Weet u zeker dat u dit bulkverzoek wilt verwijderen?",
        "startImmediately": "Begin onmiddellijk"
      },
      "modal": {
        "contactTypes": {
          "all": "Alle",
          "leads": "Potentiële klanten",
          "customers": "Klanten"
        },
        "buttons": {
          "cancel": "Annuleren",
          "update": "Updaten",
          "add": "Toevoegen"
        },
        "labels": {
          "name": "Naam",
          "contactType": "Type contactpersoon",
          "campaign": "Campagne",
          "scheduledDate": "Inplandatum",
          "tag": "Tag"
        },
        "placeholders": {
          "tags": "Tags",
          "selectCampaign": "Campagne selecteren",
          "pickType": "Selecteer type"
        },
        "sections": {
          "bulkRequest": "Bulkverzoek",
          "whoShouldRun": "Voor wie zou het moeten draaien?"
        },
        "titleAdd": "Bulkverzoek toevoegen",
        "titleEdit": "Bulkverzoek bewerken",
        "validation": {
          "scheduledDateRequired": "Geplande datum is vereist"
        }
      }
    },
    "listFolder": {
      "expandIcon": "Uitvouwen"
    },
    "list": {
      "confirmDeleteFolder": "Bevestig de verwijdering van de map",
      "delete": "Verwijderen",
      "confirmDelete": "Weet u zeker dat u deze campagne wilt verwijderen?",
      "moveToFolder": "Verplaatsen naar map",
      "pleaseRename": "Naam wijzigen",
      "removeFromFolder": "Verwijderen uit map"
    },
    "copy": {
      "title": "Campagne kopiëren",
      "newCampaignName": "Nieuwe campagnenaam",
      "locations": "Locaties"
    }
  },
  "compliance": {
    "findOutMore": "Meer informatie",
    "gdprDescription": "We nemen de bescherming van uw persoonsgegevens en die van uw klanten zeer serieus en behandelen deze vertrouwelijk en in overeenstemming met de wettelijke voorschriften inzake gegevensbescherming en deze privacyverklaring",
    "gdprTitle": "AVG-naleving",
    "hipaaDescription": "Activeer beveiligingsupgrades om ervoor te zorgen dat de gegevens in uw HighLevel-account veilig zijn en voldoen aan de vereisten van de HIPAA",
    "hipaaTitle": "HIPAA-naleving"
  },
  "customValues": {
    "key": "Sleutel",
    "selectedItemsCountSingular": "{count} rij geselecteerd",
    "selectedItemsCountPlural": "{count} rijen geselecteerd"
  },
  "facebookAdFields": {
    "checkIcon": "Formulier toegewezen",
    "errorMessage": "De token voor paginatoegang is verlopen of beschikt over onvoldoende rechten. Zorg ervoor dat u beheerdersrechten hebt voor de pagina's."
  },
  "fbLeadSync": {
    "confirmTitle": "Synchronisatie Facebookleads bevestigen?",
    "impactMessage": "Informeer u over de impact van de synchronisatie van Facebookleads voordat u verdergaat:",
    "observations": "1. Hierdoor worden Facebookleads gesynchroniseerd en nieuwe contacten aangemaakt voor elke niet in de contactlijst voorkomende lead die in de afgelopen {days} dagen werd gegenereerd. <br>2. Als u ontbrekende leads handmatig hebt geïmporteerd met behulp van uit Facebook Ads Manager geëxporteerde CSV-bestanden, schakel dan &quot;Dubbele contacten toestaan&quot; uit om te voorkomen dat er dubbele contacten worden aangemaakt bij de synchronisatie. <br>3. Als u workflows hebt die worden geactiveerd bij het <b>aanmaken van een contactpersoon</b> of het <b>indienen van een Facebook-leadformulier</b>, worden deze geactiveerd voor elke nieuw aangemaakte contactpersoon. <br>4. Dit is niet van toepassing op bestaande contactpersonen die via Facebook-leads werden aangemaakt. <br>5. De tijd waarop het contact werd aangemaakt wordt geregistreerd als de huidige tijd. <br>6. De synchronisatie kan tot een uur duren, afhankelijk van het aantal nog te synchroniseren leads. <br>",
    "proceedQuestion": "Wilt u doorgaan met de synchronisatie van Facebookleads?"
  },
  "integrationAI": {
    "accountDisconnected": "Account losgekoppeld!",
    "appNotFound": "App-configuratie kon niet worden gevonden. Fallbackgegevens worden gebruikt.",
    "checkingConnection": "Verbindingsstatus controleren...",
    "connecting": "Bezig met verbinden...",
    "disconnectApp": "De app loskoppelen",
    "disconnecting": "Verbinding verbreken...",
    "loadingAppInfo": "App-informatie wordt geladen...",
    "refreshConnection": "Verbinding vernieuwen",
    "refreshing": "Vernieuwen...",
    "svgNotAvailable": "SVG niet beschikbaar"
  },
  "phoneSystem": {
    "additionalSettings": "Aanvullende instellingen",
    "messaging": "Communicatie",
    "messagingAnalytics": "Berichtenanalyse",
    "regulatoryBundles": "Regelgevingsbundels",
    "title": "Telefoonsysteem",
    "trustCenter": "Trust Center",
    "voice": "Spraak"
  },
  "demo": {
    "draggable": {
      "title": "Sleepbare componenttest",
      "usingVue3": "Gebruik van Vue 3 compatibel sleepbaar",
      "description": "Dit onderdeel maakt nu gebruik van de herziene versleepbare component die compatibel is met Vue 3.",
      "buttons": {
        "resetAllLists": "Alle lijsten terugzetten",
        "clearLog": "Log wissen",
        "stopLoading": "Stop met laden",
        "simulateLoading": "Laden simuleren",
        "refreshData": "Gegevens vernieuwen"
      },
      "examples": {
        "basicDraggable": "Eenvoudig sleepbaar",
        "draggableWithElement": "Versleepbaar met element",
        "draggableWithTransitionGroup": "Sleepbaar met overgangsgroep",
        "draggableWithMoveFunction": "Sleepbaar met verplaatsfunctie"
      },
      "eventLog": "Gebeurtenislogboek",
      "handle": "Bijnaam",
      "name": "Naam",
      "cannotMove": "(kan niet verplaatsen)"
    },
    "tableDemo": {
      "title": "Vue 3 UIBTable Demo",
      "basicControls": "Eenvoudige bediening",
      "labels": {
        "filter": "Filter:",
        "sortBy": "Sorteren op:",
        "sortDirection": "Sorteerrichting:",
        "perPage": "Per pagina:",
        "tableStyling": "Tabelopmaak:"
      },
      "placeholders": {
        "typeToSearch": "Typ om te zoeken..."
      },
      "checkboxLabels": {
        "striped": "Gestreept",
        "bordered": "Met rand",
        "hover": "Zweven",
        "small": "Klein",
        "responsive": "Responsief"
      },
      "fields": {
        "id": "ID",
        "name": "Naam",
        "email": "E-mail",
        "status": "Status",
        "created": "Aangemaakt",
        "actions": "Acties"
      },
      "statuses": {
        "active": "Actief",
        "inactive": "Inactief",
        "pending": "In afwachting",
        "banned": "Verboden"
      },
      "modal": {
        "title": "Details item",
        "close": "Sluiten"
      },
      "messages": {
        "confirmDelete": "Weet u zeker dat u {name} wilt verwijderen?",
        "editItem": "Object bewerken {id}",
        "showingItems": "Er worden {count} van {total} items weergegeven"
      }
    },
    "saasPricingTable": {
      "confirmAndProceed": "Opslaan & Doorgaan",
      "everythingIn": "Alles in <b>{plan}+</b>",
      "noPaymentMethod": {
        "linkText": "voeg hier creditcard toe",
        "message": "Zou u uw klant willen vragen om",
        "title": "De locatie moet eerst de betaalmethode toevoegen."
      },
      "noSaasPlan": {
        "linkText": "maak hier uw SaaS-plannen aan.",
        "message": "Alstublieft",
        "title": "U heeft geen SaaS-plan geconfigureerd."
      },
      "saasModeSetupPendingWarning": "Het SaaS-plan wordt geactiveerd nadat de klant een betaalmethode heeft toegevoegd. Tot die tijd is de toegang tot hun account beperkt.",
      "skipForNow": "Voor nu overslaan",
      "skipPlan": "Plan overslaan"
    }
  },
  "isv": {
    "business_registration_id_type": "Type bedrijfsregistratie-ID",
    "business_registration_number": "KVK-nummer",
    "business_website": "Bedrijfswebsite",
    "enter_your_business_registration_id_type": "Voer uw type bedrijfsregistratie-ID in",
    "name_of_other_registration_id_type": "Naam van een ander registratie-ID type",
    "pick_business_industry": "Selecteer een bedrijfssector",
    "pick_business_registration_id_type": "Kies het type bedrijfsregistratie-ID",
    "emailWithStar": "E-mail*",
    "businessIndustry": "Bedrijfssector*",
    "businessType": "Bedrijfstype*",
    "regionsOfOperations": "Bedrijfsregio's van de activiteiten*",
    "registrationNumber": "KVK-nummer*",
    "registrationNumberHelper": "Het nummer dat wordt gebruikt om uw bedrijf te identificeren. In het geval van een Amerikaans EIN moet dit een 9-cijferig nummer zijn, bijvoorbeeld 12-3456789.",
    "businessWebsiteWithStar": "Bedrijfswebsite*",
    "businessTypeWithStar": "Bedrijfstype",
    "businessWebsite": "Bedrijfswebsite"
  },
  "aiProductRebilling": {
    "enableRebilling": "Herfactureren inschakelen",
    "ratesMayDiffer": "Tarieven kunnen verschillen per regio. De getoonde berekeningen zijn volgens de tarieven voor het VK,",
    "supportDoc": "ondersteunend document",
    "cancel": "Annuleren",
    "profit": "Winst",
    "chargedToCustomer": "In rekening gebracht aan de klant:",
    "enabling": "Inschakelen...",
    "forMore": "voor meer details.",
    "rebillAmount": "Bedrag herfacturering",
    "tenDollarsWillGive": "$ 10 geeft u ongeveer",
    "yourCost": "Uw kosten",
    "clientBillingPage": "factureringspagina van het bedrijf van de klant",
    "needStripeConnection": "Om herfacturering in te schakelen, moet u uw Stripe koppelen aan",
    "per1000Words": "per 1000 woorden",
    "perImage": "per afbeelding",
    "perReviewResponse": "reactie per recensie",
    "perFunnel": "per trechter",
    "minimumBetween": "Het minimum moet tussen {min} en {max} liggen",
    "images": "afbeeldingen",
    "reviewResponse": "reactie bekijken",
    "funnel": "trechter",
    "pleaseCheckSupport": "controleer dit"
  },
  "a2p": {
    "otpSuccess": {
      "title": "OTP Succes",
      "message": "OTP-succesbericht"
    },
    "otpError": {
      "title": "OTP-fout",
      "message": "OTP-foutmelding"
    },
    "businessProfileError": {
      "title": "Fout in het bedrijfsprofiel",
      "message": "Foutmelding bedrijfsprofiel"
    },
    "addressError": {
      "title": "Adresfout",
      "status": "Foutstatus adres"
    },
    "profileError": {
      "title": "A2P-profiel Fout",
      "message": "A2P-profiel foutmelding"
    },
    "address": {
      "country": "Land",
      "state": "Provincie",
      "chooseCountry": "Selecteer een land...",
      "statePlaceholder": "Provincie invoeren",
      "chooseState": "Selecteren een provincie...",
      "city": "Stad*",
      "postalCode": "Postcode*",
      "streetAddress": "Straatnaam*",
      "streetAddressHelper": "Moet een geldig adres zijn dat aan uw bedrijf is gekoppeld.",
      "title": "Bedrijfsadres"
    },
    "validation": {
      "brandNameRequired": "De merknaam is vereist.",
      "businessVerticalRequired": "Bedrijfsverticaal is vereist.",
      "cityRequired": "Stad is vereist.",
      "countryRequired": "Land is vereist.",
      "invalidMobileNumber": "Ongeldig mobiel nummer.",
      "mobileNumberRequired": "Mobiel nummer is vereist.",
      "postalCodeRequired": "Postcode is vereist.",
      "stateRequired": "Provincie is vereist.",
      "streetAddressRequired": "Straatnaam is vereist."
    },
    "authorizedRep": {
      "email": "E-mail*",
      "firstName": "Voornaam*",
      "jobPosition": "Functie*",
      "jobTitle": "Functietitel*",
      "jobTitlePlaceholder": "Voer de functietitel in",
      "lastName": "Achternaam*",
      "phoneNumber": "Telefoonnummer*",
      "phoneNumberPlaceholder": "Telefoonnummer invoeren",
      "pickJobPosition": "Selecteer een functie",
      "title": "Gegevens van de geautoriseerde vertegenwoordiger"
    },
    "registration": {
      "stepProgress": "Stap {currentStep} van 8",
      "successTitle": "Uw A2P-merk en campagne zijn ingediend.",
      "successWaitDays": "duren",
      "successWaitPrefix": "Het kan tot 7 dagen ",
      "successWaitSuffix": " voor de goedkeuring van uw merk en nog eens 4-5 weken voor de goedkeuring van de campagne.",
      "otpNote": "Opmerking: U ontvangt een OTP-bericht op het door u opgegeven mobiele nummer om te verifiëren van TCR. Gelieve binnen 24 uur na ontvangst van de sms met \"Yes\" te reageren."
    },
    "update": {
      "brandDetailsTitle": "Merkgegevens bijwerken",
      "brandName": "Merknaam*",
      "brandNameHelper": "Gebruik de juridische naam van de organisatie die de berichten verstuurt, of uw eigen naam als dit merk niet voor een organisatie is.",
      "businessVerticals": "Bedrijfssector*",
      "chooseVertical": "Selecteer verticaal...",
      "mobileNumber": "Mobiel nummer voor OTP-verificatie (met landcode)*",
      "mobileNumberHelper": "Geef een mobiel nummer op waartoe u toegang hebt, zodat u de OTP-verificatie kunt bevestigen. Alleen Amerikaanse/Canadese nummers worden geaccepteerd. U mag geen CPaaS-telefoonnummer gebruiken, zoals een nummer verkregen van LeadConnector. U kunt niet hetzelfde mobiele nummer gebruiken om meer dan 3 Sole Proprietor-merken te registreren. Deze beperking wordt beheerd door TCR.",
      "updateButton": "Updaten",
      "retryOTPTitle": "OTP opnieuw proberen",
      "retryOTPMessage": "Klik op de onderstaande knop om het OTP-verificatiebericht opnieuw te verzenden.",
      "sending": "Verzenden...",
      "resendOTP": "OTP opnieuw verzenden"
    },
    "einModal": {
      "title": "Heeft u een EIN?",
      "question": "Heeft u een identificatienummer voor werkgevers (EIN)?",
      "hasEIN": "Ja, ik heb een EIN.",
      "noEIN": "Nee, ik heb geen EIN",
      "disableNoEINText": "EIN is vereist voor locaties buiten de VS/CA",
      "infoText": "Een EIN is vereist voor bedrijven in de Verenigde Staten en Canada."
    },
    "brandDetails": {
      "brandHeading": "Merkgegevens",
      "brandName": "Merknaam*",
      "brandNameHelper": "Gebruik de juridische naam van de organisatie die de berichten verstuurt, of uw eigen naam als dit merk niet voor een organisatie is.",
      "businessIndustry": "Bedrijfssector*",
      "chooseVertical": "Selecteer verticaal...",
      "mobileNumber": "Mobiel nummer voor OTP-verificatie (met landcode)*",
      "mobileNumberHelper": "Geef een mobiel nummer op waartoe u toegang hebt, zodat u de OTP-verificatie kunt bevestigen. Alleen Amerikaanse/Canadese nummers worden geaccepteerd. U mag geen CPaaS-telefoonnummer gebruiken, zoals een nummer verkregen van LeadConnector. U kunt niet hetzelfde mobiele nummer gebruiken om meer dan 3 Sole Proprietor-merken te registreren. Deze beperking wordt beheerd door TCR.",
      "solePropBrand": {
        "heading": "Sole Prop-merk",
        "point1": "Slechts 1 telefoonnummer toegestaan",
        "point2": "EIN/SSN/DUNS niet vereist",
        "subheading": "Merkregistratie voor eenmanszaak"
      },
      "solePropCampaign": {
        "heading": "Sole Prop-campagne",
        "point1": "Er mag slechts 1 nummer worden gekoppeld aan een Sole Prop-campagne",
        "point2": "Zodra dit is goedgekeurd, wordt uw standaardnummer automatisch gekoppeld.",
        "infoText": "U kunt het aantal ook bijwerken nadat het is goedgekeurd",
        "warningText": "Er mag slechts 1 nummer worden gekoppeld aan een Sole Prop-campagne. Na goedkeuring wordt uw standaardnummer automatisch gekoppeld. U kunt het nummer ook na goedkeuring bijwerken.",
        "subheading": "Registratie Sole Prop-campagne"
      },
      "solePropSubtitle": "Gegevens Sole Prop-merk en -campagne",
      "standardBrand": {
        "heading": "$ 4,41 - Eenmalig",
        "point1": "EIN/SSN/DUNS vereist",
        "point2": "Meer dan 1 telefoonnummer toegestaan",
        "subheading": "Standaard merkregistratie"
      },
      "standardCampaign": {
        "heading": "$ 16,54 - Eenmalig",
        "point1": "Er mag meer dan 1 nummer aan een standaardcampagne worden gekoppeld",
        "point2": "EIN/SSN/DUNS vereist",
        "infoText": "Er geldt een extra campagnevergoeding van maximaal $ 12 per maand in overeenstemming met de TCR-regels.",
        "subheading": "Standaard Campagneregistratie"
      },
      "standardSubtitle": "Gegevens standaardmerk en -campagne",
      "title": "Gegevens merk en campagne"
    },
    "campaign": {
      "useCaseDetails": {
        "title": "Gebruiksscenario campagne-info",
        "subtitle": "De campagnegegevens en -beschrijving invoeren",
        "useCase": "Gebruiksscenario campagne*",
        "pickUseCase": "Gebruiksscenario campagne selecteren",
        "useCaseDescription": "Beschrijving gebruiksscenario*",
        "explainInDetail": "Geef een gedetailleerde uitleg",
        "useCaseDescriptionPlaceholder": "Voorbeeld: Deze campagne verzendt afspraakinformatie - bevestigings- en herinneringsberichten naar onze klanten zodra zij een afspraak met ons hebben geboekt op onze website en zich hebben aangemeld voor het ontvangen van promotionele en informatieve sms-berichten van ons.",
        "useCaseDescriptionHelper": "Zou u een gedetailleerde beschrijving kunnen geven van het doel van deze campagne?",
        "solePropLabel": "Sole Proprietor",
        "seeExamples": "Voorbeelden bekijken",
        "closeExamples": "Voorbeelden sluiten"
      }
    }
  },
  "opportunities": {
    "email": "E-mail",
    "phone": "Telefoon",
    "status": "Status",
    "contactType": "Type contactpersoon",
    "bulkOperation": "Bulkverrichting",
    "contactName": "Naam contactpersoon",
    "unassigned": "Niet toegewezen",
    "abandoned": "Verlaten",
    "addOpportunityName": "Naam van lead toevoegen",
    "companyName": "Bedrijfsnaam",
    "contactInfo": "Contactgegevens",
    "enterValue": "Waarde invoeren",
    "lost": "Verloren",
    "open": "Open",
    "opportunityInfo": "Info gelegenheid",
    "opportunityName": "Naam gelegenheid",
    "opportunitySource": "Bron gelegenheid",
    "owner": "Eigenaar",
    "pipeline": "Pijplijn",
    "selectPipeline": "Pijplijn selecteren",
    "selectStage": "Fase selecteren",
    "stage": "Fase",
    "won": "Gewonnen",
    "createdOn": "Aangemaakt op",
    "goToContactDetail": "Ga naar de pagina met contactdetails",
    "leadValue": "Waarde lead",
    "removeOwner": "Eigenaar verwijderen",
    "createdBy": "Aangemaakt door",
    "notAllowedToChange": "U mag dit contact niet wijzigen",
    "opportunityAlreadyExists": "Er bestaat al een lead voor deze contactpersoon in de geselecteerde pijplijn.",
    "filters": {
      "all": "Alle",
      "statuses": {
        "all": "Alle",
        "open": "Open",
        "won": "Gewonnen",
        "lost": "Verloren",
        "abandoned": "Verlaten"
      },
      "search": "Zoeken",
      "status": "Status",
      "campaign": "Campagne",
      "owner": "Eigenaar",
      "pipeline": "Pijplijn",
      "dateAddedAsc": "↑ Dag toegevoegd (oplopend)",
      "dateAddedDesc": "↓ Datum toegevoegd (aflopend)",
      "orderBy": "BestellenVoor"
    },
    "columns": {
      "note": "Notitie",
      "task": "Taak",
      "companyName": "Naam bedrijf",
      "additionalInfo": "Extra informatie",
      "calendarEvent": "Agendagebeurtenis",
      "hideAssignedTo": "Verbergen Toegewezen aan",
      "hideTags": "Tags verbergen"
    },
    "buttons": {
      "new": "Nieuw"
    },
    "dragActions": {
      "abandoned": "Verlaten",
      "lost": "Verloren",
      "won": "Gewonnen"
    },
    "getStarted": "aan de slag te gaan!",
    "noPipelines": "Oeps! Het lijkt erop dat er geen pijpleidingen zijn. Maak een nieuwe pijplijn aan om",
    "addTask": "Taak toevoegen",
    "tasksCount": "{count} taken"
  },
  "appointmentDetails": "Afspraakgegevens",
  "cloneFunnel": {
    "cloneButton": "{entityName} klonen",
    "cloning": "Klonen...",
    "cloningLimit": "Klonen is beperkt tot 3 locaties per keer",
    "error": "Fout bij het klonen van trechter!",
    "locationsLabel": "Selecteer locaties",
    "nameLabel": "Naam voor de gedupliceerde {entityName}",
    "namePlaceholder": "Voer een naam in voor de gekloonde {entityName}",
    "selectUpTo": "Selecteer maximaal {maxSelectableLocations} locaties",
    "title": "{entityName} klonen"
  },
  "errors": "Fouten",
  "renderEmailAddress": "E-mailadres weergeven",
  "noPaymentMethodWarning": "Waarschuwing: geen betaalmethode beschikbaar",
  "pageDetail": "Paginadetail",
  "activityHistory": "Geschiedenis van de activiteit",
  "uiAlert": "UI-waarschuwing",
  "eventModals": {
    "wait": {
      "save": "Opslaan",
      "days": "Dagen",
      "fri": "Vr",
      "mon": "Ma",
      "sat": "Za",
      "sun": "Zo",
      "thu": "Do",
      "tue": "Di",
      "wed": "Wo",
      "wait": "Wacht",
      "minutes": "Minuten",
      "hours": "Uren",
      "title": "Bewerk Wachtgebeurtenis",
      "whichDaysResume": "Op welke dagen moeten we hervatten?",
      "pickDayError": "Selecteer minstens één dag",
      "whatTimeResume": "Hoe laat moeten we hervatten?"
    },
    "sms": {
      "send": "Verzenden",
      "name": "Naam",
      "attachFile": "Bestanden bijvoegen",
      "learnMore": "Meer informatie",
      "sendTest": "Test verzenden",
      "title": "Bewerk {eventType} gebeurtenis",
      "titleTemplate": "Bewerk {eventType} sjabloon",
      "nameRequired": "Naam is vereist",
      "pickTemplate": "Kies een sjabloon",
      "appCharacters": "Tekens app",
      "numSegments": "Aantal segmenten",
      "approximateCost": "Geschatte kosten",
      "costEstimateNote": "Notitie kostenraming",
      "urlAttachmentAutocompleteToken": "URL-bijlage",
      "addFileUrl": "Voeg een bestands-URL toe",
      "urlImageAlt": "URL-afbeelding",
      "fileImageAlt": "Bestandsafbeelding",
      "enterMessage": "Bericht invoeren",
      "mobilePhonePlaceholder": "Mobiele telefoon",
      "unsupportedContentType": "Niet-ondersteund inhoudstype: {fileType}",
      "urlAttachmentWarning": "{count} URL-bijlage{plural} niet geladen. Wilt u doorgaan?",
      "provideMobileNumber": "Geef alstublieft uw mobiele nummer op"
    },
    "email": {
      "text": "Tekst",
      "checkLinks": "Controleer de links met een aangepaste waarde. Er is een extra '%20' tussen de {{ en de custom_values.",
      "errorOccurred": "Er is een fout opgetreden. Probeer het opnieuw.",
      "insertToAddress": "Voer een afleveradres in."
    },
    "voicemail": {
      "save": "Opslaan",
      "dropFile": "Sleep het bestand hierheen of klik om te uploaden",
      "faq": "Veelgestelde vragen",
      "title": "Voicemail-gebeurtenis bewerken",
      "voicemailFile": "Voicemailbestand",
      "warning": "Waarschuwing: voicemailbestanden moeten in MP3-, WAV- of GSM-formaat zijn.",
      "unsupportedFormat": "Niet-ondersteund bestandsformaat. Gebruik MP3, WAV of GSM."
    },
    "call": {
      "title": "Oproepgebeurtenis bewerken",
      "save": "Opslaan",
      "name": "Naam",
      "nameRequired": "Naam is vereist",
      "callWhisper": "Fluisteroproep",
      "whisperMessage": "Fluisterbericht",
      "thisIsTheMessage": "Dit is de boodschap die aan de agent wordt afgespeeld voordat de oproep wordt doorverbonden.",
      "callTimeoutS": "Time-out gesprek(ken)",
      "timeoutSeconds": "Timeout (seconden)",
      "disableVoicemailDetect": "Voicemaildetectie uitschakelen",
      "callWillPatchInstantly": "Het gesprek wordt direct gepatcht zonder voicemail te detecteren."
    }
  },
  "emailTemplate": {
    "createdOn": "Aangemaakt op",
    "updatedOn": "Bijgewerkt op"
  },
  "cnam": {
    "learnMore": {
      "title": "CNAM - Meer Informatie",
      "description": "CNAM Beschrijving"
    },
    "submitted": {
      "checkStatus": "CNAM-status controleren",
      "description": "Uw bedrijfsnaam zou binnen ongeveer 3-5 dagen aan relevante contactpersonen moeten worden weergegeven.",
      "subtitle": "Uw CNAM-verzoek is nu ingediend.",
      "title": "Gefeliciteerd!"
    },
    "registration": {
      "confirm": "Bevestigen",
      "learnMore": "Meer informatie",
      "characterLimit": "{count}/15",
      "title": "CNAM-registratie",
      "description": "Voer uw bedrijfsnaam in (max. 15 tekens)",
      "warning": "Waarschuwing: Uw bedrijfsnaam wordt weergegeven als beller-ID. "
    }
  },
  "updateModals": {
    "error": {
      "title": "Fout bijwerken",
      "message": "Updatefoutmelding"
    },
    "success": {
      "message": "Uw A2P-merk en campagne zijn ingediend.<br/><br/><b>Bericht:</b> U ontvangt <b>een OTP-bericht op uw opgegeven mobiele nummer om te verifiëre</b> van TCR. Gelieve <b>binnen 24 na ontvangst van de sms</b> Yes te antwoorden.",
      "title": "Uw A2P-merk en campagne zijn ingediend. Het kan tot <b>7 dagen</b> duren voor de goedkeuring van uw merk en nog eens 4-5 weken voor de goedkeuring van de campagne."
    }
  },
  "regulatoryBundle": {
    "error": {
      "title": "Fout regelgevingspakket",
      "status": "Foutstatus regelgevingspakket"
    },
    "createAddress": {
      "successMessage": "Uw A2P-merk en campagne zijn ingediend.",
      "successTitle": "Adres ingediend",
      "underReview": "Het ingediende adres wordt beoordeeld"
    },
    "createEndUser": {
      "dateFormat": "Het datumformaat moet JJJJ-MM-DD zijn.",
      "phoneExample": " Model: +14155552671",
      "title": "Bedrijfsgegevens:"
    },
    "success": {
      "title": "Regelgevingsbundel ingediend",
      "underReview": "Bundel ter beoordeling ingediend",
      "message": "Uw verzoek voor SHAKEN/STIR-registratie is ingediend. Het kan tot <b>3-4 dagen</b> duren voordat het wordt goedgekeurd. De status wordt binnenkort geüpdatet."
    },
    "documents": {
      "additionalInfo": "Aanvullende informatie",
      "createAddressLink": "Adres aanmaken.",
      "createAddressPrompt": "Maak eerst een adres aan en ga dan verder met het aanmaken van de bundel.",
      "selectAddress": "Selecteer adres:"
    },
    "selectBundle": {
      "addressBundle": {
        "description": "Deze optie voegt een nieuwe contactpersoon toe aan uw account",
        "label": "Adresbundel"
      },
      "regulatoryBundle": {
        "description": "Deze optie helpt u een nieuwe regelgevingsbundel aan te maken",
        "label": "Regelgevingsbundel"
      },
      "title": "Kies welke bundel u wilt toevoegen"
    },
    "modal": {
      "back": "Terug",
      "next": "Volgende",
      "submit": "Verzenden",
      "title": "Nieuwe Regelgevingsbundel",
      "description": "Maak een nieuw regelgevingsbundel aan voor uw locatie."
    }
  },
  "reminder": {
    "phone": "Telefoon",
    "noReplyYet": "Nog geen antwoord"
  },
  "sendGrid": {
    "apiKey": "SendGrid API-sleutel",
    "save": "SendGrid Opslaan",
    "apiKeyRequired": "SendGrid API-sleutel vereist"
  },
  "twilioReselling": {
    "upgradeBanner": {
      "upgradeButton": "Upgraden",
      "subtitle": "Bureaus met een pro-abonnement verdienen ongeveer $ 363 per maand door telefoonkosten door te berekenen aan hun klanten",
      "title": "Wilt u dit opnieuw aan uw klanten doorbelasten?"
    }
  },
  "emailField": {
    "label": "E-mail",
    "placeholder": "E-mail",
    "tooltip": {
      "primary": "Primair",
      "emails": "E-mails"
    }
  },
  "attachSnapshotToggle": {
    "loadSnapshot": "Momentopname laden:",
    "loadSnapshotWarning": "Wilt u de aan dit plan gekoppelde momentopname laden? <br /> <strong class='text-danger'>Bestaande gegevens gaan mogelijk verloren</strong>"
  },
  "suspension": {
    "suspended": {
      "description": "Alleen bureaubeheerders/gebruikers hebben toegang tot dit subaccount. Momenteel hebben u en andere accountbeheerders/gebruikers geen toegang tot dit subaccount.",
      "heading": "Dit subaccount is gepauzeerd."
    },
    "temporarily": {
      "description": "Al uw gegevens zijn veilig en alle triggers/campagnes enz. zullen na activering weer worden hervat.",
      "heading": " Uw Account is tijdelijk onderbroken."
    }
  },
  "callerIdUpdateModal": {
    "friendlyName": "Beschrijvende bedrijfsnaam",
    "title": "Beller-ID updaten"
  },
  "drChronoOfficeSelect": {
    "selectOffice": "Agentschap selecteren",
    "whichOffice": "Welk agentschap wilt u aan dit account koppelen?",
    "connect": "Verbinden!"
  },
  "phoneField": {
    "label": "Telefoon",
    "placeholder": "Telefoonnummer",
    "tooltip": {
      "invalidNumber": "Ongeldig telefoonnummer",
      "notSmsCapable": "Dit {type} nummer is niet geschikt voor sms"
    }
  },
  "submissionDetail": {
    "titles": {
      "bookingDetails": "Details boeking",
      "form": "Formulier",
      "quiz": "Quiz",
      "submissionDetail": "Indieningsgegevens",
      "survey": "Enquête"
    }
  },
  "shakenStir": {
    "confirmation": {
      "description": "Uw verzoek voor SHAKEN/STIR-registratie is ingediend. Het kan tot <b>3-4 dagen</b> duren voordat het wordt goedgekeurd. De status wordt binnenkort geüpdatet.",
      "title": "SHAKEN/STIR vertrouwde oproep ingeschakeld."
    },
    "modal": {
      "andThe": " en de ",
      "businessProfile": "Bedrijfsprofiel",
      "certification": "Ik verklaar dat het bijbehorende bedrijfsprofiel de bron is van de telefoongesprekken en verklaar dat ik zal meewerken aan traceerinspanningen, waaronder die welke worden geïnitieerd door de",
      "failedTitle": "Indienen mislukt",
      "friendlyName": "Beschrijvende naam",
      "friendlyNamePlaceholder": "Bijvoorbeeld: SHST 2022-11-24 om 19:47:14",
      "linkInfo": {
        "description": "Alle momenteel beschikbare nummers en toekomstige aangeschafte nummers worden automatisch geregistreerd bij SHAKEN/STIR.",
        "title": "Alle nummers worden automatisch gekoppeld"
      },
      "stiPa": "Secure Telephony Identity Policy Administrator (STI-PA)",
      "subtitle": "Voer de details en de beschrijving in",
      "successMessage": "Uw verzoek voor SHAKEN/STIR-registratie is ingediend. Het kan tot <b>3-4 dagen</b> duren voordat het wordt goedgekeurd. De status wordt binnenkort geüpdatet.",
      "successTitle": "SHAKEN/STIR Trusted Calling is ingeschakeld.",
      "title": "SHAKEN/STIR Trusted Calling inschakelen",
      "tracebackGroup": "US Telecom Traceback Group"
    },
    "withCnam": {
      "cnamPromo": "Registreer u voor CNAM om uw bedrijfsnaam als beller-ID te tonen",
      "registerCnam": "Registreer CNAM"
    }
  },
  "task": {
    "2day": "2 dagen",
    "3day": "3 dagen",
    "4day": "4 dagen",
    "5day": "5 dagen",
    "addTask": "Taak toevoegen",
    "countTasks": "{count} taken"
  },
  "updatedProductsModal": {
    "title": "Bijgewerkte Producten",
    "copyDirectSaleLink": "Kopieer de link voor directe verkoop",
    "setupFeeInstruction": "De opstartkosten kunnen worden ingesteld in het Stripe-dashboard. ",
    "doNotDeleteWarning": "Verwijder geen producten of prijzen uit het Stripe-dashboard. Dit zal de integratie onderbreken."
  },
  "termsOfService": {
    "privacyLink": "Privacybeleid",
    "accept": "Accepteren",
    "termsLink": "Servicevoorwaarden",
    "updateMessage": "We hebben onze Servicevoorwaarden en ons Privacybeleid bijgewerkt. Lees de informatie aandachtig door en stem ermee in om verder te gaan.",
    "agreementPrefix": "Door verder te gaan, gaat u akkoord met onze ",
    "agreementConjunction": " en "
  },
  "callerIdVerificationModal": {
    "answerCall": "Beantwoord de oproep en voer deze verificatiecode in:",
    "leadConnectorCalling": "Lead Connector belt u op...",
    "title": "Beller-ID toevoegen via spraak",
    "waitingForVerification": "Wachten op de verificatie..."
  },
  "emailOTPModal": {
    "confirmCode": "Code bevestigen",
    "resendCode": "Als u de code niet hebt ontvangen, kunt u hier klikken om deze opnieuw te verzenden"
  },
  "survey": {
    "copy": {
      "cancel": "Annuleren",
      "location": "Locatie",
      "copy": "Kopiëren",
      "newSurveyName": "Nieuwe enquêtenaam",
      "title": "Enquête kopiëren",
      "locationRequired": "Locatie is vereist"
    }
  },
  "stripeProductDetailsModal": {
    "productName": "Productnaam",
    "planDetails": "Details plan",
    "title": "Productbeschrijving",
    "planId": "Abonnements-ID",
    "copiedToClipboard": "Gekopieerd naar klembord"
  },
  "importCustomers": {
    "newExperience": {
      "efficient": "Efficiënter",
      "faster": "Sneller",
      "itsText": "Het is",
      "smoother": "Soepeler",
      "title": "Er is een nieuwe import-ervaring hier!",
      "warningMessage": "Door de nieuwe import-ervaring in te schakelen, wordt Labs voor dit sub-account geactiveerd en wordt de bètafunctie ingeschakeld.",
      "tryNow": "Nu proberen"
    },
    "validateEmails": "E-mails valideren?"
  },
  "yext": {
    "reselling": {
      "zero": "0",
      "highlevelPrice": "HighLevel-prijs",
      "howDoesItWork": "Hoe werkt het?",
      "payNow": "Nu betalen",
      "priceError": "De prijs moet hoger of gelijk zijn aan de HighLevel-prijs",
      "saving": "Opslaan",
      "yourPrice": "Uw prijs",
      "yourProfit": "Uw winst",
      "subscriptionCreating": "Abonnement wordt gemaakt.<br/>Niet opnieuw laden of op de terugknop drukken",
      "subscriptionCreated": "Abonnement aanmaken gelukt. Een ogenblik geduld...",
      "unableToCreate": "Kan geen abonnement maken, neem contact op met de ondersteuning",
      "perMonth": "per maand",
      "agreeToEnable": "Ik ga akkoord met het opslaan van vermeldingen voor deze klant zonder bijverkopen en ik erken dat er kosten in rekening worden gebracht",
      "deployDirectly": "Advertenties direct inzetten",
      "deployDirectlyDesc": "Gebruik deze optie als u vermeldingen aanbiedt als onderdeel van uw aanbod of als u uw klant extern wilt factureren",
      "minimumCommitment": "met een minimale verbintenisperiode van 1 maand.",
      "offerListings": "Aanbod vermeldingen",
      "resellListings": "Doorverkoopaanbiedingen",
      "subscribedInfo": "{withoutUpsell} Zonder bijverkopen, {withUpsell} Met bijverkopen en {withSaas} met SaaS-bundel",
      "yourResellOffer": "Uw doorverkoopaanbod"
    }
  }
}
